import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterListingPage_template} from "./filterListingPage_template";
import {multipleHubPagesWidget_template} from "./multipleHubPagesWidget_template";
import {filterAutocomplete_template} from "./filterAutocomplete_template";
import {
    filterDropdown_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {pinnedArticle, pinnedArticles_template} from "./pinnedArticles_template";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";
import {HubPageSearchResult} from "../../utils/types/listing_page";
import {
    imagePicker_template
} from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template';
import {imagePickerHelper} from "../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";
import {imageWidget_template} from "./imageWidget_template";

declare var ko: any;

export class configHomePage_template extends vnTemplate {

    public pinnedArticles: pinnedArticles_template;
    public filterListingPageTemplate: filterListingPage_template;
    public filterSowMoreListingPageTemplate: filterListingPage_template;
    protected filterSidebarLinksListingPage: filterListingPage_template;
    protected filterSidebarLinksArticle: filterAutocomplete_template;
    protected filterSectionType: filterDropdown_template;
    protected sectionTypes: any;

    public listingPageFilter: filterListingPage_template;
    public headerLatestHubPageFilter: filterListingPage_template;
    private threeArticleHubPageConfigurationSnapshot: {
        hubPage: any;
        alternateTitle: string;
        articlesConfig: string;
    } | null = null;

    //New Widget stuff
    public listingPageFilterLeft: filterListingPage_template;
    public listingPageFilterRight: filterListingPage_template;
    public listingPageFilterFullWidth: filterListingPage_template;
    public multipleHubPagesWidget: multipleHubPagesWidget_template;
    public multiListingPinnedListingPageFilter: filterListingPage_template;

    public listingPageFilterLeftShowMore: filterListingPage_template;
    public listingPageFilterRightShowMore: filterListingPage_template;
    public listingPageFilterFullWidthShowMore: filterListingPage_template;

    public showMoreListingPageFilter: filterListingPage_template;
    public imagePicker: imagePicker_template;
    public imagePickerHelper: imagePickerHelper;
    public imageWidget: imageWidget_template;
    public homePageEventBannerImageWidget: imageWidget_template;
    public homePageEventBannerListingPageFilter: filterListingPage_template;
    public featuredWikiImageWidget: imageWidget_template;
    public latestYoutubeOverrideImageWidget: imageWidget_template;
    public featuredWikiFilter: filterAutocomplete_template;
    public latestYoutubeVideoFilter: filterAutocomplete_template;

    public hpFullWidthArticles: pinnedArticles_template;
    public hpLeftPinnedArticles: pinnedArticles_template;
    public hpRightPinnedArticles: pinnedArticles_template;
    public multiListingPinnedArticles: pinnedArticles_template;
    public imageWidgetForFullWidth: imageWidget_template;
    public imagePickerForNewsletter: imageWidget_template;

    protected getTemplateHtml(): string {

        return /*html*/`
            <div class="w-form">
               <div class="form-header">
                  <input type="hidden">
                  <h3 class="form-title">Home page</h3>
               </div>


               <div class="form-body">

                   <!-- ko if: isMLT() -->
                   <h3 class="form-sub-title icon i-article">Homepage Event Banner</h3>
                   <div class="form-group">
                       <input type="checkbox" id="homePageEventBannerEnabled" data-bind="checked: homePageEventBannerEnabled">
                       <label class="form-label icon i-check" for="homePageEventBannerEnabled">Enabled</label>
                   </div>
                   <div data-bind="visible: homePageEventBannerEnabled">
                       <div class="form-group img">
                           <label class="form-label">Banner Image</label>
                           ${this.homePageEventBannerImageWidget.getHtmlBuild()}
                       </div>
                       <div class="form-group">
                           <label class="form-label">Listing Page</label>
                           ${this.homePageEventBannerListingPageFilter.getHtmlBuild()}
                       </div>
                       <div class="form-group">
                           <label class="form-label" for="homePageEventBannerStartDate">Start Date</label>
                           <input class="input-text" type="date" id="homePageEventBannerStartDate" data-bind="value: homePageEventBannerStartDate">
                       </div>
                       <div class="form-group">
                           <label class="form-label" for="homePageEventBannerEndDate">End Date</label>
                           <input class="input-text" type="date" id="homePageEventBannerEndDate" data-bind="value: homePageEventBannerEndDate">
                       </div>
                   </div>
                   <!-- /ko -->

                   <!-- ko if: !isFX() -->
                   <h3 class="form-sub-title icon i-article">Pinned articles</h3>
                   <div class="form-group">
                        <label class="form-label" for="layout">Layout</label>
                        <div data-bind="foreach: activeLayoutOptions" class="featured-pinned-list">
                            <div class="featured-pinned-element" >
                                <input type="radio" name="featured-template" data-bind="disable: (!$parent.permissions()['pin_homepage_layout'].write) || $data.id == 2, attr: {id: 'layoutOptions_' + id}, value: id, checked: $parent.idLayout, event:{ click : $parent.onClickLayout() }">
                                <label class="form-label icon " data-bind="attr: {for: 'layoutOptions_' + id, class: 'form-label icon ' + wrappingClass }"></label>
                                <label class="form-label" data-bind="text: $data.name"></label>
                            </div>
                        </div>
                    </div>

                    <div class="form-group" data-bind="visible: enableLayoutFeaturedPinnedTitle()">
                        <label class="form-label" for="layoutFeaturedPinnedTitle">Featured Pinned Title</label>
                        <input class="input-text" type="text" id="layoutFeaturedPinnedTitle" name="layoutFeaturedPinnedTitle" data-bind="value: layoutFeaturedPinnedTitle">
                    </div>

                    <div class="form-expend" data-bind="css: { 'is-disable': !permissions()['pin_homepage_layout'].write }">

                        <input type="checkbox" id="expandButton1" name="expandControl" value="expand1">
                        <label for="expandButton1" class="form-label icon i-dropdown-simple">Header Latest Articles Options</label>
                        <!-- ko if: isThreeArticleHubPageConfigurationVisible() -->
                        <button type="button" class="btn highlight" data-bind="disable: !permissions()['pin_homepage_layout'].write, event: { click: onClickOpenThreeArticleHubPageConfigurationModal }">
                            Featured Articles Configuration
                        </button>
                        <!-- /ko -->

                        <div class="form-expend-div">
                            <div class="form-group" data-bind="if: horizontalLatest()">
                                <label class="form-label">Available Article Counts</label><br>
                                <!-- ko foreach: horizontalLatest -->
                                    <input type="radio" name="articleCount"
                                        data-bind="disable: !$parent.permissions()['pin_homepage_layout'].write,attr: { id: 'count_' + $data }, value: $data, checked: $parent.articleCount, event:{ change: $parent.onClickArticleCount }">
                                    <label class="form-label" data-bind="attr: { for: 'count_' + $data }, text: $data"></label>
                                <!-- /ko -->
                            </div>

                            <div class="form-group">
                                <label class="form-label">Image</label><br>

                                <input type="radio" name="showImage" id="_showImageYes"
                                    data-bind="disable: !permissions()['pin_homepage_layout'].write, checked: showImage, checkedValue: true">
                                <label class="form-label" for="_showImageYes">Yes</label>

                                <input type="radio" name="showImage" id="_showImageNo"
                                    data-bind="disable: !permissions()['pin_homepage_layout'].write, checked: showImage, checkedValue: false">
                                <label class="form-label" for="_showImageNo">No</label>
                            </div>

                            <div class="form-group">
                                <label class="form-label">Background</label><br>

                                <input type="radio" name="useBackground" id="_useBackgroundNone"
                                    data-bind="disable: !permissions()['pin_homepage_layout'].write, checked: useBackground, checkedValue: 'none'">
                                <label class="form-label" for="_useBackgroundNone">None</label>

                                <!-- ko if: !lightBackgroundDisabled() -->
                                    <input type="radio" name="useBackground" id="_useBackgroundLight"
                                        data-bind="disable: !permissions()['pin_homepage_layout'].write, checked: useBackground, checkedValue: 'light'">
                                    <label class="form-label" for="_useBackgroundLight">Light</label>
                                <!-- /ko -->

                                <input type="radio" name="useBackground" id="_useBackgroundDark"
                                    data-bind="disable: !permissions()['pin_homepage_layout'].write, checked: useBackground, checkedValue: 'dark'">
                                <label class="form-label" for="_useBackgroundDark">Dark</label>
                            </div>

                        </div>

                    </div>

                   <div class="form-group">
                        ${this.pinnedArticles.getHtmlBuild()}
                   </div>
                   <!-- /ko -->

                   <!-- ko if: !isFX() -->
                        <div class="form-group">
                            <h3 class="form-sub-title icon i-article">Pinned Widgets (Featured Section)</h3>
                            <button data-bind="event: { click: onClickAddPinnedWidgetToggle.bind($data) }" class="btn highlight" type="button">
                                Add Pinned Widget
                            </button>
                        </div>


                    <!-- Pinned Widget Display Section -->
                    <!-- ko if: pinnedWidgets() && pinnedWidgets().length > 0 -->
                        <div class="form-group" data-bind="foreach: pinnedWidgets, childrenComplete : handleDragAndDrop($element, pinnedWidgets ,'.w-pinned-widgets')">
                            <div class="form-body w-pinned w-pinned-widgets" style="background: none">
                                <div class="pinned-form article-pinned entry drag-element">
                                    <div class="pinned-drag icon i-drag">
                                        <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                                    </div>
                                    <div class="w-btn">
                                        <button class="btn border only-icon icon border i-edit" type="button"
                                            data-bind="event: { click: $parent.onClickEditPinnedWidget }">
                                            <span class="hidden-text">Edit</span>
                                        </button>
                                        <button class="btn border only-icon icon border highlight i-delete" type="button"
                                            data-bind="event: { click: $parent.onClickDeletePinnedWidget.bind($data) }">
                                            <span class="hidden-text">Delete</span>
                                        </button>
                                    </div>
                                    <div class="w-title">
                                        <div>
                                            <span class="pinned-info">Configuration: </span>
                                            <span class="pinned-title" data-bind="text: $parent.formatCamelCaseLabel(configuration)"></span>
                                        </div>
                                    </div>

                                    <!-- Full Width Type -->
                                    <!-- ko if: configuration == 'fullWidth' -->
                                    <div class="d-flex" style="gap: 1rem;">

                                        <!-- Layout -->
                                        <!-- ko if: fullWidthWidgetType == 'hubPage' -->
                                            <div class="widget-card-pinned">

                                                <div class="featured-pinned-list">
                                                    <div class="featured-pinned-element">
                                                <!-- ko if: layoutFullWidth == 'accordionReversed' -->

                                                        <label class="form-label icon featured-accordian-full-reversed"></label>
                                                <!-- /ko -->
                                                <!-- ko if: layoutFullWidth == 'accordion' -->
                                                        <label class="form-label icon featured-accordian-full"></label>
                                                <!-- /ko -->
                                                <!-- ko if: layoutFullWidth == 'equalSizeHorizontal-5' -->
                                                        <label class="form-label icon featured-full"></label>
                                                <!-- /ko -->
                                                <!-- ko if: layoutFullWidth == 'equalSizeHorizontal-4' -->
                                                        <label class="form-label icon featured-thread"></label>
                                                <!-- /ko -->
                                            <!-- ko if: layoutFullWidth == 'grid' -->
                                                    <label class="form-label icon featured-grid"></label>
                                            <!-- /ko -->
                                            <!-- ko if: layoutFullWidth == 'gridAccordion' -->
                                                    <label class="form-label icon featured-grid"></label>
                                            <!-- /ko -->
                                            <!-- ko if: layoutFullWidth == 'ordered-list' -->
                                                    <label class="form-label icon featured-ordered-list"></label>
                                            <!-- /ko -->
                                            <!-- ko if: layoutFullWidth == 'equalSizePortraitList' -->
                                                    <label class="form-label icon featured-portrait"></label>
                                            <!-- /ko -->
                                            <!-- ko if: layoutFullWidth == 'ticker-thin' -->
                                                    <label class="form-label icon featured-ticker-thin"></label>
                                            <!-- /ko -->
                                            <!-- ko if: layoutFullWidth == 'stack' -->
                                                    <label class="form-label icon featured-stack"></label>
                                            <!-- /ko -->
                                                    </div>
                                                </div>

                                                <!-- Hub Page -->
                                                <div>
                                                    <span class="form-label">Type:</span>
                                                    <span data-bind="text: $parent.formatCamelCaseLabel(fullWidthWidgetType)"></span>
                                                </div>

                                                <!-- ko if: pinnedHubPages && pinnedHubPages.fullWidth -->
                                                <div>
                                                    <span class="form-label">Hub Page:</span>
                                                    <span data-bind="text: pinnedHubPages.fullWidth.name"></span>
                                                </div>
                                                <div>
                                                    <span class="form-label">Alternate Title:</span>
                                                    <span data-bind="text: pinnedHubPages.fullWidthAlternateTitle"></span>
                                                </div>
                                                <!-- /ko -->
                                                <div>
                                                    <span class="form-label">Articles:</span>
                                                    <span data-bind="text: $parent.formatArticlesForDisplay(pinnedArticles.fullWidth||[])"></span>
                                                </div>
                                            </div>
                                        <!-- /ko -->

                                        <!-- ko if: fullWidthWidgetType == 'multipleHubPages' -->
                                            <div class="widget-card-pinned">
                                                <div class="featured-pinned-list">
                                                    <div class="featured-pinned-element">
                                                        <!-- ko if: layoutFullWidth == 'mediumGrid' -->
                                                            <label class="form-label icon featured-medium-grid"></label>
                                                        <!-- /ko -->
                                                        <!-- ko if: layoutFullWidth == 'largeGrid' -->
                                                            <label class="form-label icon featured-large-grid"></label>
                                                        <!-- /ko -->
                                                    </div>
                                                </div>
                                                <div>
                                                    <span class="form-label">Type:</span>
                                                    <span data-bind="text: $parent.formatCamelCaseLabel(fullWidthWidgetType)"></span>
                                                </div>
                                                <div>
                                                    <span class="form-label">Alternate Title:</span>
                                                    <span data-bind="text: widgetTitle"></span>
                                                </div>
                                                <div>
                                                    <span class="form-label">Multiple Hub Pages:</span>
                                                    <span data-bind="text: $parent.formatListingPagesForDisplay(pinnedHubPages.fullWidthMultiple)"></span>
                                                </div>
                                           </div>

                                        <!-- /ko -->

                                        <!-- ko if: fullWidthWidgetType == 'ratingWidget' -->
                                        <div class="widget-card-pinned" style="padding: 3rem 1rem;">
                                            <div class="featured-pinned-list">
                                                <div class="featured-pinned-element">
                                                    <label class="form-label icon i-premium"></label>
                                                </div>
                                            </div>
                                            <div>
                                                <span class="form-label">Type:</span>
                                                <span> Rating  Widget</span>
                                            </div>
                                        </div>
                                        <!-- /ko -->

                                        <!-- ko if: fullWidthWidgetType == 'marketplaceWidget' -->
                                            <div class="widget-card-pinned" style="padding: 3rem 1rem;">
                                                <div class="featured-pinned-list">
                                                    <div class="featured-pinned-element">
                                                        <label class="form-label icon i-premium"></label>
                                                    </div>
                                                </div>
                                                <div>
                                                    <span class="form-label">Type:</span>
                                                    <span> Marketplace  Widget</span>
                                                </div>
                                            </div>
                                        <!-- /ko -->

                                        <!-- ko if: fullWidthWidgetType == 'newsletterWidget' -->
                                            <div class="widget-card-pinned" style="padding: 3rem 1rem;">
                                                <div class="featured-pinned-list">
                                                    <div class="featured-pinned-element">
                                                        <label class="form-label icon i-premium"></label>
                                                    </div>
                                                </div>
                                                <div>
                                                    <span class="form-label">Type:</span>
                                                    <span> Newsletter  Widget</span>
                                                </div>
                                                <!-- ko if: newsletterTitle != null && newsletterTitle != '' -->
                                                <div>
                                                    <span class="form-label">Title:</span>
                                                    <span data-bind="text: newsletterTitle"></span>
                                                </div>
                                                <!-- /ko -->
                                                <!-- ko if: newsletterDescription != null && newsletterDescription != '' -->
                                                <div>
                                                    <span class="form-label">Description:</span>
                                                    <span data-bind="text: newsletterDescription"></span>
                                                </div>
                                                <!-- /ko -->
                                            </div>
                                        <!-- /ko -->

                                    </div>
                                    <!-- /ko -->

                                    <!-- Side-by-Side -->
                                    <!-- ko if: configuration == 'sideBySide' -->
                                    <div class="side-by-side">
                                        <!-- ko if: widgetTypeLeft == 'hubPage' -->
                                            <div class="widget-card-pinned">
                                                <div class="featured-pinned-list">
                                                    <div class="featured-pinned-element">
                                                <!-- ko if: layoutSideBySideLeft == 'carousel' -->
                                                        <label class="form-label icon featured-sbs-carousel"></label>
                                                <!-- /ko -->
                                                <!-- ko if: layoutSideBySideLeft == 'horizontal-2' -->
                                                        <label class="form-label icon featured-sbs-2-horizon"></label>
                                                <!-- /ko -->
                                                <!-- ko if: layoutSideBySideLeft == 'vertical-3' -->
                                                        <label class="form-label icon featured-sbs-3-vertical"></label>
                                                <!-- /ko -->
                                                    </div>
                                                </div>

                                                <div>
                                                    <span class="form-label">Type:</span>
                                                    <span data-bind="text: $parent.formatCamelCaseLabel(widgetTypeLeft)"></span>
                                                </div>
                                                <!-- ko if: pinnedHubPages && pinnedHubPages.left -->
                                                <div>
                                                    <span class="form-label">Hub Page:</span>
                                                    <span data-bind="text: pinnedHubPages.left.name"></span>
                                                </div>
                                                <div data-bind="visible: pinnedHubPages.leftAlternateTitle">
                                                    <span class="form-label"> Alternate Title:</span>
                                                    <span data-bind="text: pinnedHubPages.leftAlternateTitle"></span>
                                                </div>
                                                <!-- /ko -->
                                                <div>
                                                    <span class="form-label">Articles:</span>
                                                    <span data-bind="text: $parent.formatArticlesForDisplay(pinnedArticles.left||[])"></span>
                                                </div>

                                            </div>
                                        <!-- /ko -->

                                        <!-- ko if: widgetTypeLeft == 'ratingWidget' -->
                                            <div class="widget-card-pinned" style="padding: 3rem 1rem;">
                                                <div class="featured-pinned-list">
                                                    <div class="featured-pinned-element">
                                                        <label class="form-label icon i-premium"></label>
                                                    </div>
                                                </div>
                                                <div>
                                                    <span class="form-label">Type:</span>
                                                    <span> Rating  Widget</span>
                                                    <span class="form-label">Alternate Title:</span>
                                                    <span data-bind="text: leftWidgetRatingWidgetAlternateTitle"></span>
                                                </div>
                                            </div>
                                        <!-- /ko -->

                                        <!-- ko if: widgetTypeRight == 'hubPage' -->
                                            <div class="widget-card-pinned">
                                                <div class="featured-pinned-list">
                                                    <div class="featured-pinned-element">
                                                <!-- ko if: layoutSideBySideRight == 'carousel' -->
                                                        <label class="form-label icon featured-sbs-carousel"></label>
                                                <!-- /ko -->
                                                <!-- ko if: layoutSideBySideRight == 'horizontal-2' -->
                                                        <label class="form-label icon featured-sbs-2-horizon"></label>
                                                <!-- /ko -->
                                                <!-- ko if: layoutSideBySideRight == 'vertical-3' -->
                                                        <label class="form-label icon featured-sbs-3-vertical"></label>
                                                <!-- /ko -->
                                                    </div>
                                                </div>

                                                <div>
                                                    <span class="form-label">Type:</span>
                                                    <span data-bind="text: $parent.formatCamelCaseLabel(widgetTypeRight)"></span>
                                                </div>
                                                <!-- ko if: pinnedHubPages && pinnedHubPages.right -->
                                                <div>
                                                    <span class="form-label">Hub Page:</span>
                                                    <span data-bind="text: pinnedHubPages.right.name"></span>
                                                </div>
                                                <div data-bind="visible: pinnedHubPages.rightAlternateTitle">
                                                    <span class="form-label">Alternate Title:</span>
                                                    <span data-bind="text: pinnedHubPages.rightAlternateTitle"></span>
                                                </div>
                                                <!-- /ko -->
                                                <div>
                                                    <span class="form-label">Articles:</span>
                                                    <span data-bind="text: $parent.formatArticlesForDisplay(pinnedArticles.right||[])"></span>
                                                </div>

                                            </div>
                                        <!-- /ko -->

                                        <!-- ko if: widgetTypeRight == 'ratingWidget' -->
                                            <div class="widget-card-pinned" style="padding: 3rem 1rem;">
                                                <div class="featured-pinned-list">
                                                    <div class="featured-pinned-element">
                                                        <label class="form-label icon i-premium"></label>
                                                    </div>
                                                </div>
                                                <div>
                                                    <span class="form-label">Type:</span>
                                                    <span>Rating  Widget</span>
                                                    <span class="form-label">Alternate Title:</span>
                                                    <span data-bind="text: rightWidgetRatingWidgetAlternateTitle"></span>
                                                </div>
                                            </div>
                                        <!-- /ko -->

                                    </div>
                                    <!-- /ko -->
                                </div>
                            </div>
                        </div>
                    <!-- /ko -->
                   <!-- /ko -->



                   <!-- ko if: !isFX() -->
                   <h3 class="form-sub-title icon i-listing-2-preview">Pinned Hub Pages (Full List Tab)</h3>
                   <div class="form-group">
                       <button data-bind="event: { click: onClickToggleListingPagePinnedSection.bind($data, 'fullList', true, true) }" class="btn highlight" type="button">Add As Full List Tab</button>
                   </div>
                   <div class="form-group " data-bind="foreach: fullListPinnedListingPages, childrenComplete : handleDragAndDrop($element, fullListPinnedListingPages ,'.entry')">
                       <div class="form-body w-pinned">
                           <div class="pinned-form listingPage-pinned entry" data-bind="css: {'is-edit' : enableEdit}">
                                <div class="pinned-drag icon i-drag">
                                   <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                                </div>
                                <div class="w-btn" data-bind="visible: !enableEdit">
                                   <button class="btn border only-icon icon border i-edit" type="button" data-bind="event: { click: $parent.onClickEditPinnedListing }"><span class="hidden-text">Edit</span></button>
                                   <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDeletePinnedListingPage }"><span class="hidden-text">Delete</span></button>
                                </div>
                                <div class="w-title">
                                    <div>
                                        <span class="pinned-info">ID :<span data-bind="text: listingPage.id"></span></span>
                                    </div>
                                    <span class="pinned-title" data-bind="text: listingPage.name + ' (' + listingPage.permalink + ')'"></span>
                                </div>
                                <div class="last">
                                    <label class="form-label icon i-overwrite"></label>
                                    <span class="pinned-title" data-bind=" visible: !enableEdit, text: alternateTitle"></span>
                                    <input type="text" class="input-text"  type="text" data-bind="visible: enableEdit, value: alternateTitle, event:{ focus: $parent.onFocus, blur: $parent.onBlur}"/>
                                </div>
                                <div data-bind="if: showMoreListingPage && !enableEdit" style="margin-bottom: 0;">
                                    <div class="border" style="width: 100%;margin-bottom: 1rem">
                                        <div>
                                           <span class="pinned-title" data-bind="text: showMoreListingPage.name + ' (' + showMoreListingPage.permalink + ')'"></span>
                                        </div>
                                    </div>
                                </div>
                                <div data-bind="visible: enableEdit" style="margin-bottom: 0;">
                                    <div class="border" style="width: 100%;">
                                        <div>
                                            <div data-bind="template: { name: 'filterListingPage-template', data: $data.showMoreListingPageFilter.getTemplateViewModel() }"></div>
                                        </div>
                                    </div>
                                 </div>
                           </div>
                       </div>
                   </div>
                   <!-- /ko -->
               </div>
               <div data-bind="visible: ratingWidgetEnabled">
                    <h3 class="form-sub-title icon i-article">Pinned DB Listing Pages</h3>
                    <div class="form-group">
                        <button data-bind="event: { click: onClickToggleHubPage2HubPreviewSection.bind($data, 'hubRating', true, false) }" class="btn highlight" type="button">Add DB Page</button>
                    </div>
                    <div class="form-group " data-bind="foreach: pinnedDbPages, childrenComplete : handleDragAndDrop($element, pinnedDbPages ,'.entry')">
                    <div class="form-body w-pinned">
                        <div class="pinned-form listingPage-pinned entry">
                            <div class="pinned-drag icon i-drag">
                                <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                            </div>
                            <div class="w-btn">
                                <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDeletePinnedListingPage }"><span class="hidden-text">Delete</span></button>
                            </div>
                            <div class="w-title">
                                <div>
                                    <span class="pinned-info">ID :<span data-bind="text: idTags[0]"></span></span>
                                </div>
                                <span class="pinned-title" data-bind="text: listingPage.name + ' (' + listingPage.permalink + ')'"></span>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>

               <div data-bind="visible: isDbSpotlightEnabled() && !isFX()">
                    <h3 class="form-sub-title icon i-article">DB Home Spotlight</h3>
                    <div class="form-group">
                        <label class="form-label" for="article">Title</label>
                        <input class="input-text" type="text" id="spotlightTitle" name="spotlightTitle" data-bind="value: spotlightTitle">
                    </div>
                    <div class="form-group">
                        <button data-bind="event: { click: onClickToggleHubPage2HubPreviewSection.bind($data, 'homeSpotlight', true, false) }" class="btn highlight" type="button">Add DB Page</button>
                    </div>
                    <div class="form-group " data-bind="foreach: pinnedDbHomeSpotlightPages, childrenComplete : handleDragAndDrop($element, pinnedDbHomeSpotlightPages ,'.entry')">
                        <div class="form-body w-pinned">
                            <div class="pinned-form listingPage-pinned entry">
                                <div class="pinned-drag icon i-drag">
                                    <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                                </div>
                                <div class="w-btn">
                                    <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDeletePinnedListingPage }"><span class="hidden-text">Delete</span></button>
                                </div>
                                <div class="w-title">
                                    <div>
                                        <span class="pinned-info">ID :<span data-bind="text: idTags[0]"></span></span>
                                    </div>
                                    <span class="pinned-title" data-bind="text: listingPage.name + ' (' + listingPage.permalink + ')'"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ko if: false -->
                    <h3 class="form-sub-title icon i-listing-2-preview">Pinned Custom Cards (Featured Section)</h3>
                    <div class="form-group" >
                        <input id="activatePinnedCustomCards" name="activatePinnedCustomCards" type="checkbox" data-bind="checked: activatePinnedCustomCards">
                        <label for="activatePinnedCustomCards" class="form-label icon i-check">Activate Widget</label>
                    </div>
                    <div class="form-group" data-bind="visible: activatePinnedCustomCards()">
                        <div class="form-group">
                            <label class="form-label" for="customCardsSectionTitle" >Section Title</label>
                            <input type="text" id="customCardsSectionTitle" class="input-text" data-bind="value: customCardsSectionTitle">
                        </div>
                        <div class="form-group">
                            <label class="form-label" for="" >More Linkout</label>
                            <input type="text" placeholder="Title" id="customCardsMoreLinkoutTitle" class="input-text" data-bind="value: customCardsMoreLinkoutTitle">
                            <input type="text" placeholder="URL" id="customCardsMoreLinkoutUrl" class="input-text" data-bind="value: customCardsMoreLinkoutUrl">
                        </div>
                        <div class="form-group">
                            <button data-bind="click: function() { onClickTogglePinnedCustomCardSection(true) }" class="btn highlight" type="button">Add Pinned Custom Card</button>
                        </div>
                        <div class="form-group " data-bind="foreach: pinnedCustomCardItems, childrenComplete : handleDragAndDrop($element, pinnedCustomCardItems ,'.entry')">
                            <div class="form-body w-pinned">
                                <div class="pinned-form listingPage-pinned entry">
                                    <div class="pinned-drag icon i-drag">
                                        <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                                    </div>
                                    <div class="w-btn">
                                        <button class="btn border only-icon icon border i-edit" type="button" data-bind="event: { click: $parent.onClickEditPinnedCustomCardItem }"><span class="hidden-text">Edit</span></button>
                                        <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDeletePinnedCustomCardItem }"><span class="hidden-text">Delete</span></button>
                                    </div>
                                    <div class="w-title">
                                        <span class="pinned-title">Card Title :<span data-bind="text: cardTitle"></span></span>
                                        <span class="pinned-title">Card Linkout :<span data-bind="text: cardLinkoutUrl"></span></span>
                                        <!-- ko if: cardImage && cardImage.url -->
                                        <div class="pinned-title"> Card Image:
                                            <img data-bind="attr: { src: cardImage.url + '?w=50&h=50', alt: cardImage.altText || 'Card image' }" style="width: 50px; height: 50px; object-fit: cover; margin-left: 5px;" />
                                        </div>
                                        <!-- /ko -->
                                        <span class="pinned-title">Card Description :<span data-bind="html: cardDescription"></span></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- /ko -->

                <!-- ko if: isFX() -->
                    <h3 class="form-sub-title icon i-listing-2-preview">Featured Wikis</h3>
                    <div class="form-group">
                        <div class="form-group">
                            <button data-bind="click: function() { onClickToggleFeaturedWikiModal(true) }" class="btn highlight" type="button">Add Featured Wiki</button>
                        </div>
                        <div class="form-group " data-bind="foreach: featuredWikiItems, childrenComplete : handleDragAndDrop($element, featuredWikiItems ,'.entry')">
                            <div class="form-body w-pinned">
                                <div class="pinned-form listingPage-pinned entry fx-pinned-entry">
                                    <div class="pinned-drag icon i-drag">
                                        <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                                    </div>
                                    <div class="w-btn">
                                        <button class="btn border only-icon icon border i-edit" type="button" data-bind="event: { click: $parent.onClickEditFeaturedWikiItem }"><span class="hidden-text">Edit</span></button>
                                        <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDeleteFeaturedWikiItem }"><span class="hidden-text">Delete</span></button>
                                    </div>
                                    <div class="w-title fx-w-title">
                                        <div class="fx-info-col">
                                            <div class="fx-field">
                                                <span class="fx-field-label">Current Title</span>
                                                <span class="fx-field-value" data-bind="text: $parent.getFeaturedWikiCurrentTitle($data)"></span>
                                            </div>
                                            <div class="fx-field">
                                                <span class="fx-field-label">Current URL</span>
                                                <span class="fx-field-value" data-bind="text: $parent.getFeaturedWikiCurrentUrl($data)"></span>
                                            </div>
                                            <div class="fx-field">
                                                <span class="fx-field-label">Override Title</span>
                                                <span class="fx-field-value" data-bind="text: overrideTitle || '—', css: { 'is-empty': !overrideTitle }"></span>
                                            </div>
                                        </div>
                                        <div class="fx-media-col">
                                            <!-- ko if: $parent.getFeaturedWikiCurrentImageUrl($data) -->
                                            <div class="fx-media">
                                                <span class="fx-field-label">Current Image</span>
                                                <img class="fx-media-thumb" data-bind="attr: { src: $parent.getFeaturedWikiCurrentImageUrl($data) + '?w=160&h=160', alt: $parent.getFeaturedWikiCurrentTitle($data) || 'Featured wiki image' }" />
                                            </div>
                                            <!-- /ko -->
                                            <!-- ko if: overrideImage && overrideImage.url -->
                                            <div class="fx-media">
                                                <span class="fx-field-label">Override Image</span>
                                                <img class="fx-media-thumb" data-bind="attr: { src: overrideImage.url + '?w=160&h=160', alt: overrideImage.altText || 'Featured wiki override image' }" />
                                            </div>
                                            <!-- /ko -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- /ko -->

                <!-- ko if: isFX() -->
                    <h3 class="form-sub-title icon i-listing-2-preview">Multi Listing With Pinned Articles</h3>
                    <div class="form-group">
                        <label class="form-label" for="multiListingPinnedSectionTitle">Section Title</label>
                        <input type="text" id="multiListingPinnedSectionTitle" class="input-text" data-bind="value: multiListingPinnedSectionTitle">
                    </div>
                    <div class="form-group">
                        <button class="btn highlight" type="button" data-bind="event:{ click: onClickOpenMultiListingPinnedModal }">Add Hub Page Entry</button>
                    </div>
                    <div class="form-group" data-bind="foreach: multiListingPinnedItems, childrenComplete : handleDragAndDrop($element, multiListingPinnedItems ,'.entry')">
                        <div class="form-body w-pinned">
                            <div class="pinned-form listingPage-pinned entry fx-pinned-entry fx-pinned-entry-articles">
                                <div class="pinned-drag icon i-drag">
                                    <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                                </div>
                                <div class="w-btn">
                                    <button class="btn border only-icon icon border i-edit" type="button" data-bind="event: { click: $parent.onClickEditMultiListingPinnedItem }"><span class="hidden-text">Edit</span></button>
                                    <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDeleteMultiListingPinnedItem }"><span class="hidden-text">Delete</span></button>
                                </div>
                                <div class="w-title fx-w-title">
                                    <div class="fx-info-col">
                                        <div class="fx-field">
                                            <span class="fx-field-label">Title</span>
                                            <span class="fx-field-value" data-bind="text: title"></span>
                                        </div>
                                        <div class="fx-field">
                                            <span class="fx-field-label">Use Latest</span>
                                            <span class="fx-field-value" data-bind="text: useLatest ? 'Yes' : 'No'"></span>
                                        </div>
                                        <div class="fx-field">
                                            <span class="fx-field-label">Hub Page</span>
                                            <span class="fx-field-value" data-bind="text: listingPage ? listingPage.name + ' (' + listingPage.permalink + ')' : 'Latest articles'"></span>
                                        </div>
                                        <div class="fx-field">
                                            <span class="fx-field-label">Primary</span>
                                            <span class="fx-field-value" data-bind="text: isPrimary ? 'Yes' : 'No'"></span>
                                        </div>
                                    </div>
                                    <div class="fx-media-col fx-articles-col">
                                        <span class="fx-field-label">Pinned Articles</span>
                                        <div class="fx-articles-list" data-bind="text: $parent.formatArticlesForDisplay(pinnedArticles)"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h3 class="form-sub-title icon i-video">Latest Youtube Videos</h3>
                    <div class="form-group">
                        <label class="form-label" for="latestYoutubeVideosSectionTitle">Title</label>
                        <input type="text" id="latestYoutubeVideosSectionTitle" class="input-text" data-bind="value: latestYoutubeVideosSectionTitle">
                    </div>
                    <div class="form-group">
                        <label class="form-label" for="latestYoutubeVideosIdChannel">Youtube Channel</label>
                        <select id="latestYoutubeVideosIdChannel" class="input-select" data-bind="options: latestYoutubeChannelOptions, optionsText: 'name', optionsValue: 'idChannel', value: latestYoutubeVideosIdChannel, event: { change: onChangeLatestYoutubeVideosChannel }"></select>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Video</label>
                        ${this.latestYoutubeVideoFilter.getHtmlBuild()}
                    </div>
                    <div class="form-group">
                        <button class="btn highlight" type="button" data-bind="event:{ click: onClickAddLatestYoutubeVideo }">Add Video</button>
                    </div>
                    <div class="form-group" data-bind="foreach: latestYoutubeVideoItems, childrenComplete : handleDragAndDrop($element, latestYoutubeVideoItems ,'.entry')">
                        <div class="form-body w-pinned">
                            <div class="pinned-form article-pinned entry fx-pinned-entry">
                                <div class="pinned-drag icon i-drag">
                                    <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                                </div>
                                <div class="w-btn">
                                    <button class="btn border only-icon icon border i-edit" type="button" data-bind="event: { click: $parent.onClickEditLatestYoutubeVideo }"><span class="hidden-text">Edit</span></button>
                                    <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDeleteLatestYoutubeVideo }"><span class="hidden-text">Delete</span></button>
                                </div>
                                <div class="w-title fx-w-title">
                                    <div class="fx-info-col">
                                        <div class="fx-field">
                                            <span class="fx-field-label">Title</span>
                                            <span class="fx-field-value" data-bind="text: $parent.getLatestYoutubeVideoDisplayTitle($data)"></span>
                                        </div>
                                        <div class="fx-field">
                                            <span class="fx-field-label">Video ID</span>
                                            <span class="fx-field-value" data-bind="text: idVideo"></span>
                                        </div>
                                        <div class="fx-field">
                                            <span class="fx-field-label">Published</span>
                                            <span class="fx-field-value" data-bind="text: datePublished || '—', css: { 'is-empty': !datePublished }"></span>
                                        </div>
                                        <!-- ko if: overrideTitle -->
                                        <div class="fx-field">
                                            <span class="fx-field-label">Override Title</span>
                                            <span class="fx-field-value" data-bind="text: overrideTitle"></span>
                                        </div>
                                        <!-- /ko -->
                                    </div>
                                    <div class="fx-media-col">
                                        <!-- ko if: $parent.getLatestYoutubeVideoDisplayImageUrl($data) -->
                                        <div class="fx-media">
                                            <span class="fx-field-label">Image</span>
                                            <img class="fx-media-thumb" data-bind="attr: { src: $parent.getLatestYoutubeVideoDisplayImageUrl($data) + '?w=160&h=160', alt: $parent.getLatestYoutubeVideoDisplayTitle($data) || 'YouTube video image' }" />
                                        </div>
                                        <!-- /ko -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- /ko -->

                <div data-bind="visible: isTradingCardFeatureEnabled()">
                    <h3 class="form-sub-title icon i-article">Pinned Trading Cards</h3>
                    <div class="form-group">
                        <label class="form-label" for="article">Title</label>
                        <input class="input-text" type="text" id="tradingCardsSectionTitle" name="tradingCardsSectionTitle" data-bind="value: tradingCardsSectionTitle">
                    </div>
                    <div class="form-group">
                        <button data-bind="event: { click: onClickToggleHubPage2HubPreviewSection.bind($data, 'tradingCard', true, false) }" class="btn highlight" type="button">Add Trading Card</button>
                    </div>
                    <div class="form-group " data-bind="foreach: pinnedTradingCardPages, childrenComplete : handleDragAndDrop($element, pinnedTradingCardPages ,'.entry')">
                        <div class="form-body w-pinned">
                            <div class="pinned-form listingPage-pinned entry">
                                <div class="pinned-drag icon i-drag">
                                    <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                                </div>
                                <div class="w-btn">
                                    <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDeletePinnedListingPage }"><span class="hidden-text">Delete</span></button>
                                </div>
                                <div class="w-title">
                                    <div>
                                        <span class="pinned-info">ID :<span data-bind="text: listingPage.id"></span></span>
                                    </div>
                                    <span class="pinned-title" data-bind="text: listingPage.name + ' (' + listingPage.permalink + ')'"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


               <div class="form-footer">
                  <button data-bind="event: { click: onClickCancelHomePageConfig }" title="There will be no changes made" class="btn " type="button">Cancel</button>
                  <button data-bind="event: { click: onClickSaveHomePageConfig }" class="btn highlight" type="button">Save</button>
               </div>

            </div>

            <!-- ko if: !isFX() -->
            <!-- sidebar-featured-links FE-->
            <div class="w-form sidebar-featured-links">
                <div class="form-header">
                    <h3 class="form-title icon">Pinned Sidebar Sections</h3>
                    <button class="btn icon i-plus" data-bind="event: { click: onClickShowSectionModal }" type="button">ADD SECTION</button>
                </div>
                 <div class="drag-handles section-sortable">
                     <div class="form-body">

                        <div class="form-group">
                            <label class="form-label" for="test1" >Tab Title</label>
                            <input type="text" id="test1" class="input-text" data-bind="value: sidebarSectionTabTitle">
                        </div>

                        <!-- ko foreach: sidebarSections -->
                        <div data-bind="css: { dragging: dragging },
                                                   dragZone: { name: 'section-sortable',
                                                     dragStart: $parent.dragStart,
                                                     dragEnd: $parent.dragEnd
                                                   },
                                                   dragEvents: {
                                                     accepts: 'section-sortable',
                                                     dragOver: $parent.reorderSortable,
                                                     data: { items: $parent.sidebarSections, item: $data }
                                                   }">
                            <button class="btn icon i-move i-drag drag-handle featured-title" data-bind="event: { click: $parent.onClickSetActiveSection.bind($data, $index()) }, css: { 'is-activated' : $index() == $parent.activeSection()}" type="button"><span class="btn-text" data-bind="text: $data.value.sectionTitle"></span></button>
                            <div class="form-body featured-content" data-bind="css: { 'is-hidden' : $index() != $parent.activeSection()} ">
                                <table class="list-action">
                                    <thead>
                                        <tr class="no-border">
                                            <th class="align-left" colspan="4">
                                                <h3 class="section-title" data-bind="text: $data.value.sectionTitle"></h3>
                                                <h3 class="section-title alt" data-bind="text: $data.value.sectionTypeTitle"></h3>
                                            </th>
                                            <th class="align-right no-border">
                                                <button class="btn border small only-icon icon i-edit" data-bind="event: { click: $parent.onClickEditSection }" type="button"></button>
                                                <button class="btn border small only-icon icon i-delete" data-bind="event: { click: $parent.onClickDeleteSection }" type="button"></button>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody data-bind="foreach: $data.value.links" class="drag-handles sortable">
                                         <tr data-bind="css: { dragging: dragging },
                                                   dragZone: { name: 'sortable',
                                                     dragStart: $parents[1].dragStart,
                                                     dragEnd: $parents[1].dragEnd
                                                   },
                                                   dragEvents: {
                                                     accepts: 'sortable',
                                                     dragOver: $parents[1].reorderSortable,
                                                     data: { items: $parent.value.links, item: $data }
                                                   }">
                                                <td class="drag-handle i-move align-center no-border width-reduce">
                                                    <button class="btn no-bg small only-icon icon i-drag"></button>
                                                </td>
                                                <td class="no-border align-left" colspan="3">
                                                    <table>
                                                        <tr><td>TYPE:</td><td><span data-bind="text: value.type"></span></td></tr>
                                                        <tr><td>TITLE:</td><td><span data-bind="text: value.title"></span></td></tr>
                                                        <tr><td>ALT TITLE:</td><td><span data-bind="text: value.alternateTitle"></span></td></tr>
                                                    </table>
                                                </td>
                                                <td class="no-border align-right no-wrap">
                                                    <button data-bind="event: { click: $parents[1].onClickEditLink }" class="btn border small only-icon icon i-edit"></button>
                                                    <button data-bind="event: { click: $parents[1].onClickDeleteLink }" class="btn border small only-icon icon i-delete"></button>
                                                </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="form-group w-add-item">
                                    <button type="button" class="btn dark icon i-plus"  data-bind="event: {click : $parent.onClickShowItemModal}">Add Item</button>
                                </div>
                            </div>
                        </div>

                        <!-- /ko -->
                     </div>
                </div>
                <div class="form-footer">
                  <button  title="There will be no changes made" class="btn " type="button">Cancel</button>
                  <button  class="btn highlight" data-bind="event: { click: onClickSaveSidebarFeaturedLinks }" type="button">Save</button>
                </div>


            </div>

            <div class="w-lightbox light-theme" data-bind="css: { 'is-visible': isThreeArticleHubPageConfigurationModalVisible }">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Featured Articles Configuration</h3>
                            <button class="close-button icon i-close-2" type="button" data-bind="event: { click: onClickCancelThreeArticleHubPageConfigurationModal }"></button>
                        </div>
                        <div class="form-body">
                            <div class="form-group">
                                <label class="form-label">Hub Page Selection</label><br>
                                ${this.headerLatestHubPageFilter.getHtmlBuild()}
                            </div>
                            <div class="form-group">
                                <label class="form-label">Primary Alternate Title</label><br>
                                <div class="last">
                                    <label class="form-label icon i-overwrite"></label>
                                    <input type="text" class="input-text" data-bind="value: headerLatestHubPageAlternateTitle">
                                </div>
                            </div>
                            <div class="form-group">
                                <h3 class="form-label">Articles Configuration</h3>
                                <div class="featured-pinned-list">
                                    <div class="featured-pinned-element">
                                        <input type="radio" name="headerLatestArticlesConfig" id="headerLatestHubPageSortOrderConfig" data-bind="checked: headerLatestHubArticlesConfig, checkedValue: 'hubPageSortOrder'">
                                        <label class="form-label" for="headerLatestHubPageSortOrderConfig">Hub Page Sort Order</label>
                                    </div>
                                    <div class="featured-pinned-element">
                                        <input type="radio" name="headerLatestArticlesConfig" id="headerLatestHubPagePinnedArticlesConfig" data-bind="checked: headerLatestHubArticlesConfig, checkedValue: 'hubPagePinnedArticles'">
                                        <label class="form-label" for="headerLatestHubPagePinnedArticlesConfig">Hub Page Pinned Articles</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-footer">
                            <button type="button" class="btn secondary" data-bind="event: { click: onClickSaveThreeArticleHubPageConfigurationModal }">Save</button>
                            <button type="button" class="btn" data-bind="event: { click: onClickCancelThreeArticleHubPageConfigurationModal }">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="new-section-pop-up w-lightbox light-theme" data-bind="css: { 'is-visible': isSectionDialogVisible }" id="section-popup">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title icon i-listing-page">New Section</h3>
                            <button class="close-button icon i-close-2" data-bind="event: {click : onClickCancelSectionEdit}" type="button"></button>
                        </div>
                        <div class="form-body">
                            <div class="form-group">
                                <label class="form-label" for="test1" >Section Title</label>
                                <input type="text" id="test1" class="input-text" data-bind="textInput: sectionTitle">
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="test1" >Section Type</label>
                                ${this.filterSectionType.getHtmlBuild()}
                            </div>
                        </div>
                        <div class="form-footer">
                          <button  title="There will be no changes made" class="btn" data-bind="event: {click : onClickCancelSectionEdit}" type="button">Cancel</button>
                          <button  class="btn highlight" type="button" data-bind=" enable: sectionTitle , event: { click: onClickSaveSection  }">Confirm</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="add-item-pop-up w-lightbox light-theme" data-bind="css: { 'is-visible': isItemDialogVisible }" id="item-popup">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title icon i-listing-page">ADD NEW ITEM</h3>
                            <button class="close-button icon i-close-2" data-bind="event: {click : onClickCancelLinkEdit}" type="button"></button>
                        </div>
                        <div class="form-body">
                            <div class="form-group">
                                <div class="form-check-inline width-auto">
                                   <input type="radio" id="article" name="home-page-link-type-radio-group" value="article" data-bind="checked: linkType">
                                   <label  for="article">Article</label>
                                </div>
                                <div class="form-check-inline width-auto">
                                   <input type="radio" id="listing-page" name="home-page-link-type-radio-group" value="listing_page" data-bind="checked: linkType">
                                   <label for="listing-page">Listing Page</label>
                                </div>
                            </div>
                            <div class="form-group">
                                    <!-- ko if: linkType() == 'listing_page' -->
                                   ${this.filterSidebarLinksListingPage.getHtmlBuild()}
                                   <!-- /ko -->
                                   <!-- ko if: linkType() == 'article' -->
                                   ${this.filterSidebarLinksArticle.getHtmlBuild()}
                                   <!-- /ko -->
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="article">Alternate Title</label>
                                <input class="input-text" type="text" id="alternatTitle" name="alternateTitle" data-bind="value: alternateTitle">
                            </div>
                        </div>
                        <div class="form-footer">
                          <button  title="There will be no changes made" class="btn" data-bind="event: { click: onClickCancelLinkEdit }" type="button">Cancel</button>
                          <button  class="btn highlight" type="button" data-bind="enable: linkType() && (filterSidebarLinksListingPage.listingPageObj() || filterSidebarLinksArticle.optionObj()) ,event: { click: onClickAddLink }">Confirm</button>
                        </div>
                    </div>
                </div>
            </div>

            <div data-bind="css: { 'is-visible': isLinkDeleteVisible }" class="w-lightbox light-theme">
                <div class="lightbox-content">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Confirm deletion of link</h3>
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                    <p class="form-text">Do you confirm the deletion of this item?</p>
                                </div>
                             </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onClickConfirmLinkDelete}" class="btn highlight">Confirm</button>
                                <button type="button" data-bind="event: { click: onClickCancelLinkDelete}" class="btn ">Cancel</button>
                            </div>
                        </div>
                    </div>
            </div>

            <div data-bind="css: { 'is-visible': isSectionDeleteVisible }" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Confirm deletion of section</h3>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">Do you confirm the deletion of this item?</p>
                            </div>
                         </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickConfirmSectionDelete}" class="btn highlight">Confirm</button>
                            <button type="button" data-bind="event: { click: onClickCancelSectionDelete}" class="btn ">Cancel</button>
                        </div>
                    </div>

                </div>
            </div>
            <!-- /ko -->

                <div data-bind="css: { 'is-visible': isAddFeaturedWikiVisible }" class="w-lightbox light-theme">
                    <div class="lightbox-content">
                        <div class="w-form w-form-large lightbox-form">
                            <div class="pinned-form">
                                <div class="form-header">
                                    <h3 class="form-title" data-bind="text: featuredWikiEditedIndex() !== null ? 'Update Featured Wiki' : 'Add Featured Wiki'">Add Featured Wiki</h3>
                                    <button class="close-button icon i-close-2" data-bind="event: { click: onClickToggleFeaturedWikiModal.bind($data, false)}"></button>
                                </div>
                                <div class="w-form-body">
                                    <div class="form-body">
                                        <div class="form-group">
                                            ${this.featuredWikiFilter.getHtmlBuild()}
                                        </div>
                                        <div class="form-group" data-bind="with: featuredWikiSelectedOption">
                                            <span class="pinned-title">Current Title: <span data-bind="text: name"></span></span>
                                            <span class="pinned-title">Current URL: <span data-bind="text: currentUrl"></span></span>
                                            <!-- ko if: currentImageUrl -->
                                                <div class="pinned-title">Current Image:
                                                    <img data-bind="attr: { src: currentImageUrl + '?w=50&h=50', alt: name || 'Featured wiki image' }" style="width: 50px; height: 50px; object-fit: cover; margin-left: 5px;" />
                                                </div>
                                            <!-- /ko -->
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label" for="featuredWikiOverrideTitle">Override Title</label>
                                            <input type="text" id="featuredWikiOverrideTitle" class="input-text" data-bind="value: featuredWikiOverrideTitle">
                                        </div>
                                        <div class="form-group img">
                                            <label for="" class="form-label">Override Image</label>
                                            <div style="width: 200px; height: 200px; overflow: hidden;">
                                                ${this.featuredWikiImageWidget.getHtmlBuild()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-footer">
                                    <button class="btn secondary" type="button" data-bind="event:{click: onClickAddFeaturedWikiItem }, text: featuredWikiEditedIndex() !== null ? 'Update Featured Wiki' : 'Add to List'">Add to List</button>
                                    <button type="button" data-bind="event: { click: onClickToggleFeaturedWikiModal.bind($data, false)}" class="btn ">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div data-bind="css: { 'is-visible': isLatestYoutubeVideoEditModalVisible }" class="w-lightbox light-theme">
                    <div class="lightbox-content">
                        <div class="w-form w-form-large lightbox-form">
                            <div class="pinned-form">
                                <div class="form-header">
                                    <h3 class="form-title">Edit YouTube Video</h3>
                                    <button class="close-button icon i-close-2" data-bind="event: { click: onClickCancelLatestYoutubeVideoEdit }"></button>
                                </div>
                                <div class="w-form-body">
                                    <div class="form-body">
                                        <div class="form-group" data-bind="with: latestYoutubeVideoEditingItem">
                                            <span class="pinned-title">Current Title: <span data-bind="text: title || name || idVideo"></span></span>
                                            <span class="pinned-title">Video ID: <span data-bind="text: idVideo"></span></span>
                                            <!-- ko if: thumbnailUrl -->
                                            <div class="pinned-title">Current Image:
                                                <img data-bind="attr: { src: thumbnailUrl + '?w=50&h=50', alt: title || name || 'YouTube video image' }" style="width: 50px; height: 50px; object-fit: cover; margin-left: 5px;" />
                                            </div>
                                            <!-- /ko -->
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label" for="latestYoutubeVideoOverrideTitle">Override Title</label>
                                            <input type="text" id="latestYoutubeVideoOverrideTitle" class="input-text" data-bind="value: latestYoutubeVideoOverrideTitle">
                                        </div>
                                        <div class="form-group img">
                                            <label class="form-label">Override Image</label>
                                            <div style="width: 200px; height: 200px; overflow: hidden;">
                                                ${this.latestYoutubeOverrideImageWidget.getHtmlBuild()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-footer">
                                    <button class="btn secondary" type="button" data-bind="event:{click: onClickSaveLatestYoutubeVideoOverride }">Update Video</button>
                                    <button type="button" data-bind="event: { click: onClickCancelLatestYoutubeVideoEdit }" class="btn ">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div data-bind="css: { 'is-visible': isAddPinnedCustomCardVisible }" class="w-lightbox light-theme">

                        <div class="lightbox-content">
                            <div class="w-form w-form-large lightbox-form">
                                <div class="pinned-form">
                                    <div class="form-header">
                                        <h3 class="form-title">Add Pinned Custom Card</h3>
                                        <button class="close-button icon i-close-2" data-bind="event: { click: onClickTogglePinnedCustomCardSection(false)}"></button>
                                    </div>
                                    <div class="w-form-body">
                                        <div class="form-body">
                                            <div class="form-group">
                                                <label class="form-label">Card Title</label>
                                                <input type="text" class="input-text" data-bind="value: customCardTitle"/>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Card Linkout</label>
                                                <input type="text" class="input-text" data-bind="value: customCardLinkoutUrl"/>
                                            </div>
                                            <div class="form-group img">
                                                <label for="" class="form-label">Image</label>
                                                <div style="width: 200px; height: 200px; overflow: hidden;">
                                                    ${this.imageWidget.getHtmlBuild()}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-body">
                                            <div class="form-group">
                                                <label class="form-label">Description</label>
                                                <textarea id="customCardDescription" class="input-textarea"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-footer">
                                        <button class="btn secondary" type="button" data-bind="event:{click: onClickAddPinnedCustomCardItem }, text: 'Add'">Add to List</button>
                                        <button type="button" data-bind="event: { click: onClickTogglePinnedCustomCardSection(false)}" class="btn ">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                </div>

            <div class="w-lightbox light-theme scrollable" data-bind="css: { 'is-visible': isPinnedWidgetSectionVisible }">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form" style="min-width: 92rem">
                        <div class="pinned-form">
                            <div class="form-header">
                                <h3 class="form-title">Add Pinned Widget</h3>
                                <button class="close-button icon i-close-2" data-bind="click: onClickCancelPinnedWidget"></button>
                            </div>

                            <div class="form-body scroll">
                                <!-- Configuration -->
                                <div class="form-group">
                                    <label class="form-label">Configuration</label><br>
                                    <input type="radio" name="configuration" id="_configurationFullWidth" data-bind="checked: configuration, checkedValue: 'fullWidth', click: onClickValidatePinnedWidget()">
                                    <label class="form-label" for="_configurationFullWidth">Full Width</label>
                                    <input type="radio" name="configuration" id="_configurationSideBySide" data-bind="checked: configuration, checkedValue: 'sideBySide', click: onClickValidatePinnedWidget()">
                                    <label class="form-label" for="_configurationSideBySide">Side By Side</label>
                                </div>

                                <!-- Widget Type for Full Width -->
                                <!-- ko if: configuration() == 'fullWidth' -->
                                    <div class="form-group">
                                        <label class="form-label">Widget Type</label><br>
                                        <input type="radio" name="typeFull" id="_typeHubPage" data-bind="checked: fullWidthWidgetType, checkedValue: 'hubPage', click: onClickValidatePinnedWidget()">
                                        <label class="form-label" for="_typeHubPage">Articles</label>
                                        <input type="radio" name="typeFull" id="_typeMultipleHubPages" data-bind="checked: fullWidthWidgetType, checkedValue: 'multipleHubPages', click: onClickValidatePinnedWidget()">
                                        <label class="form-label" for="_typeMultipleHubPages">Hub Pages</label>
                                        <input type="radio" name="typeFull" id="_typeMarketplace" data-bind="checked: fullWidthWidgetType, checkedValue: 'marketplaceWidget', click: onClickValidatePinnedWidget()">
                                        <label class="form-label" for="_typeMarketplace">Marketplace</label>
                                        <input type="radio" name="typeFull" id="_typeNewsletter" data-bind="checked: fullWidthWidgetType, checkedValue: 'newsletterWidget', click: onClickValidatePinnedWidget()">
                                        <label class="form-label" for="_typeNewsletter">Newsletter</label>
                                    </div>

                                    <div class="form-group">
                                      <label class="form-label" for="widgetTitle">Widget Title</label><br>
                                      <input type="text" class="input-text" id="widgetTitle" placeholder="Widget Title" data-bind="value: widgetTitle, click: onClickValidatePinnedWidget()">
                                   </div>
                                    <!-- Hub Page Selection for Full Width -->
                                    <!-- ko if: fullWidthWidgetType() == 'hubPage' -->
                                        <div class="form-group">
                                            <label class="form-label">Articles</label><br>
                                            ${this.hpFullWidthArticles.getHtmlBuild()}
                                        </div>

                                        <div class="form-group">
                                            <label class="form-label">Hub Page Selection</label><br>
                                            ${this.listingPageFilterFullWidth.getHtmlBuild()}
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label">Primary Alternate Title</label><br>
                                            <div class="last">
                                                <label class="form-label icon i-overwrite"></label>
                                                <input type="text" class="input-text" data-bind="value: fullWidthWidgetHubPageAlternateTitle, click: onClickValidatePinnedWidget()">
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label">Hub Page Selection Show More</label><br>
                                            ${this.listingPageFilterFullWidthShowMore.getHtmlBuild()}
                                        </div>
                                        <div class="form-group">
                                            <h3 class="form-label">Articles Configuration</h3>
                                            <div class="featured-pinned-list">
                                                <div class="featured-pinned-element">
                                                    <input type="radio" name="fullArticlesConfig"  id="fullHubPageSortOrderConfig" data-bind="checked: fullHubArticlesConfig, checkedValue: 'hubPageSortOrder'">
                                                    <label class="form-label" for="fullHubPageSortOrderConfig">Hub Page Sort Order</label>
                                                </div>
                                                <div class="featured-pinned-element">
                                                    <input type="radio" name="fullArticlesConfig" id="fullHubPagePinnedArticlesConfig" data-bind="checked: fullHubArticlesConfig, checkedValue: 'hubPagePinnedArticles'">
                                                    <label class="form-label" for="fullHubPagePinnedArticlesConfig">Hub Page Pinned Articles</label>
                                                </div>
                                            </div>
                                        </div>
                                    <!-- /ko -->
                                    <!-- ko if: fullWidthWidgetType() == 'multipleHubPages' -->
                                        ${this.multipleHubPagesWidget.getHtmlBuild()}
                                    <!-- /ko -->
                                    <!-- ko if: fullWidthWidgetType() == 'newsletterWidget' -->
                                       
                                        <div class="form-group">
                                            <label class="form-label">Newsletter Title</label>
                                            <input type="text" 
                                                   class="input-text" 
                                                   data-bind="value: newsletterTitle, attr: { 'placeholder': 'Newsletter Title'}, click: onClickValidatePinnedWidget()">
                                        </div>
                                    
                                        <div class="form-group">
                                            <label class="form-label">Newsletter Description</label>
                                            <textarea class="input-text" 
                                                     rows="3"
                                                     data-bind="value: newsletterDescription, attr: {'placeholder': 'Newsletter Description'}, click: onClickValidatePinnedWidget()"></textarea>
                                        </div>
                                    
                                        <div class="form-group">
                                            <label class="form-label">Width</label><br>

                                            <input type="radio" name="newsletterWidth" id="_newsletterWidthFullScreen"
                                                   data-bind="checked: newsletterWidth, checkedValue: 'full-screen', click: onClickValidatePinnedWidget()">
                                            <label class="form-label" for="_newsletterWidthFullScreen">Full Screen</label>

                                            <input type="radio" name="newsletterWidth" id="_newsletterWidthGridWidth"
                                                   data-bind="checked: newsletterWidth, checkedValue: 'grid-width', click: onClickValidatePinnedWidget()">
                                            <label class="form-label" for="_newsletterWidthGridWidth">Grid Width</label>
                                        </div>

                                        <div class="form-group flex">
                                            <label class="form-label">Background Color</label>
                                            <div class="w-color-swatch"
                                                 data-bind="css: { 'is-empty': !newsletterBackgroundColor() }, style: { 'background-color': newsletterBackgroundColor() }">
                                                <input type="color"
                                                       class="input-color"
                                                       aria-label="Background Color"
                                                       data-bind="value: newsletterBackgroundColorPicker, event: { change: onNewsletterBackgroundColorPicked, input: onNewsletterBackgroundColorPicked }">
                                            </div>
                                            <span class="form-label" style="flex: none;" data-bind="visible: !newsletterBackgroundColor()">Not set</span>

                                             <button type="button" 
                                                    class="btn small w-auto"
                                                    data-bind="click: clearNewsletterBackgroundColor, visible: newsletterBackgroundColor">Clear Color</button>
                                        </div>
                                    
                                        <div class="form-group featured-pinned-image" style="margin-block: 20px 45px;">
                                            <label class="form-label">Background Image</label>
                                            <div class="form-group img" style="margin-inline: 0;">
                                            ${ this.imagePickerForNewsletter.getHtmlBuild() }
                                            </div>
                                        </div>
                                    <!-- /ko -->
                                <!-- /ko -->

                                <!-- Widget Type for Side-by-Side -->
                                <!-- ko if: configuration() == 'sideBySide' -->
                                    <div class="form-group d-flex">

                                        <div class="form-left" style="width: 50%;border-right: #d1d1d1 solid;">
                                            <label class="form-label">Left Widget Type</label><br>
                                            <input type="radio" name="typeLeft" id="_typeLeftHubPage" data-bind="checked: widgetTypeLeft, checkedValue: 'hubPage', click: onClickValidatePinnedWidget()">
                                            <label class="form-label" for="_typeLeftHubPage">Articles</label>
                                            <!-- ko if: ratingWidgetEnabled() -->
                                                <input type="radio" name="typeLeft" id="_typeLeftRating" data-bind="checked: widgetTypeLeft, checkedValue: 'ratingWidget', click: onClickValidatePinnedWidget()">
                                                <label class="form-label" for="_typeLeftRating">Rating Widget</label>
                                            <!-- /ko -->

                                            <!-- ko if: widgetTypeLeft() == 'hubPage' -->
                                                <div class="form-group">
                                                    <label class="form-label" for="widgetLeftTitle">Widget Title</label><br>
                                                    <input type="text" class="input-text" id="widgetLeftTitle" placeholder="Widget Left Title" data-bind="value: widgetLeftTitle, click: onClickValidatePinnedWidget()">
                                                </div>
                                                <div class="form-group">
                                                    <label class="form-label">Articles</label><br>
                                                    ${this.hpLeftPinnedArticles.getHtmlBuild()}
                                                </div>

                                                <div class="form-group">
                                                    <label class="form-label">Primary</label><br>
                                                    ${this.listingPageFilterLeft.getHtmlBuild()}
                                                </div>
                                                <!-- ko if: configuration() == 'sideBySide' -->
                                                    <div class="form-group">
                                                        <label class="form-label icon">Primary Alternate Title</label><br>
                                                        <div class="last">
                                                            <label class="form-label icon i-overwrite"></label>
                                                            <input type="text" class="input-text" data-bind="value: leftWidgetHubPageAlternateTitle">
                                                        </div>
                                                    </div>
                                                <!-- /ko -->
                                                <div class="form-group">
                                                    <label class="form-label">Show More</label><br>
                                                    ${this.listingPageFilterLeftShowMore.getHtmlBuild()}
                                                </div>
                                                <!-- Hub Page Widget Config -->
                                                <div class="form-group">
                                                    <h3 class="form-label">Articles Configuration</h3>
                                                    <div class="featured-pinned-list">
                                                        <div class="featured-pinned-element">
                                                            <input type="radio" name="leftArticlesConfig"  id="leftHubPageSortOrderConfig" data-bind="checked: leftHubArticlesConfig, checkedValue: 'hubPageSortOrder'">
                                                            <label class="form-label" for="leftHubPageSortOrderConfig">Hub Page Sort Order</label>
                                                        </div>
                                                        <div class="featured-pinned-element">
                                                            <input type="radio" name="leftArticlesConfig" id="leftHubPagePinnedArticlesConfig" data-bind="checked: leftHubArticlesConfig, checkedValue: 'hubPagePinnedArticles'">
                                                            <label class="form-label" for="leftHubPagePinnedArticlesConfig">Hub Page Pinned Articles</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            <!-- /ko -->

                                            <!-- Layout for Side-by-Side Left -->
                                            <!-- ko if: configuration() == 'sideBySide' && widgetTypeLeft() == 'ratingWidget' -->
                                                <div class="form-group">
                                                    <label class="form-label">Alternate Title</label><br>
                                                    <div class="last">
                                                        <label class="form-label icon i-overwrite"></label>
                                                        <input type="text" class="input-text" data-bind="value: leftWidgetRatingWidgetAlternateTitle, click: onClickValidatePinnedWidget()">
                                                    </div>
                                                </div>
                                            <!-- /ko -->

                                            <!-- ko if: configuration() == 'sideBySide' && widgetTypeLeft() == 'hubPage' -->
                                                <div class="form-group">
                                                    <label class="form-label">Left Layout</label>
                                                    <div class="featured-pinned-list">
                                                        <div class="featured-pinned-element">
                                                            <input type="radio" name="layoutSideLeft"  id="_layoutSideBySideLeftCarousel" data-bind="checked: layoutSideBySideLeft, checkedValue: 'carousel', click: onClickValidatePinnedWidget()">
                                                            <label class="form-label icon featured-sbs-carousel" for="_layoutSideBySideLeftCarousel"></label>
                                                            <label class="form-label">Carousel<br>3 Articles</label>
                                                        </div>
                                                        <div class="featured-pinned-element">
                                                            <input type="radio" name="layoutSideLeft" id="_layoutSideBySideLeftHorizontal2" data-bind="checked: layoutSideBySideLeft, checkedValue: 'horizontal-2', click: onClickValidatePinnedWidget()">
                                                            <label class="form-label icon featured-sbs-2-horizon" for="_layoutSideBySideLeftHorizontal2"></label>
                                                            <label class="form-label" >Horizontal<br>2 Articles</label>
                                                        </div>
                                                        <div class="featured-pinned-element">
                                                            <input type="radio" name="layoutSideLeft" id="_layoutSideBySideLeftVertical3" data-bind="checked: layoutSideBySideLeft, checkedValue: 'vertical-3', click: onClickValidatePinnedWidget()">
                                                            <label class="form-label icon featured-sbs-3-vertical" for="_layoutSideBySideLeftVertical3"></label>
                                                            <label class="form-label">Vertical<br>3 Articles</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            <!-- /ko -->

                                        </div>

                                        <div class="form-right" style="width: 50%; padding-left: 1rem">
                                            <label class="form-label">Right Widget Type</label><br>
                                            <input type="radio" name="typeRight" id="_typeRightHubPage" data-bind="checked: widgetTypeRight, checkedValue: 'hubPage', click: onClickValidatePinnedWidget()">
                                            <label class="form-label" for="_typeRightHubPage">Articles</label>
                                            <!-- ko if: ratingWidgetEnabled() -->
                                                <input type="radio" name="typeRight" id="_typeRightRating" data-bind="checked: widgetTypeRight, checkedValue: 'ratingWidget', click: onClickValidatePinnedWidget()">
                                                <label class="form-label" for="_typeRightRating">Rating Widget</label>
                                            <!-- /ko -->

                                            <!-- ko if: widgetTypeRight() == 'hubPage' -->
                                                <div class="form-group">
                                                    <label class="form-label" for="widgetTRightTitle">Widget Title</label><br>
                                                    <input type="text" class="input-text" id="widgetTRightTitle" placeholder="Widget Right Title" data-bind="value: widgetRightTitle, click: onClickValidatePinnedWidget()">
                                                </div>
                                                <div class="form-group">
                                                    <label class="form-label">Articles</label><br>
                                                    ${this.hpRightPinnedArticles.getHtmlBuild()}
                                                </div>

                                                <div class="form-group">
                                                    <label class="form-label">Primary</label><br>
                                                    ${this.listingPageFilterRight.getHtmlBuild()}
                                                </div>
                                                <!-- ko if: configuration() == 'sideBySide' -->
                                                    <div class="form-group">
                                                        <label class="form-label">Primary Alternate Title</label><br>
                                                        <div class="last">
                                                            <label class="form-label icon i-overwrite"></label>
                                                            <input type="text" class="input-text" data-bind="value: rightWidgetHubPageAlternateTitle, click: onClickValidatePinnedWidget()">
                                                        </div>
                                                    </div>
                                                <!-- /ko -->
                                                <div class="form-group">
                                                    <label class="form-label">Show More</label><br>
                                                    ${this.listingPageFilterRightShowMore.getHtmlBuild()}
                                                </div>
                                                <div class="form-group">
                                                    <h3 class="form-label">Articles Configuration</h3>
                                                    <div class="featured-pinned-list">
                                                        <div class="featured-pinned-element">
                                                            <input type="radio" name="rightArticlesConfig"  id="rightHubPageSortOrderConfig" data-bind="checked: rightHubArticlesConfig, checkedValue: 'hubPageSortOrder'">
                                                            <label class="form-label" for="rightHubPageSortOrderConfig">Hub Page Sort Order</label>
                                                        </div>
                                                        <div class="featured-pinned-element">
                                                            <input type="radio" name="rightArticlesConfig" id="rightHubPagePinnedArticlesConfig" data-bind="checked: rightHubArticlesConfig, checkedValue: 'hubPagePinnedArticles'">
                                                            <label class="form-label" for="rightHubPagePinnedArticlesConfig">Hub Page Pinned Articles</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            <!-- /ko -->

                                            <!-- Layout for Side-by-Side Right -->
                                            <!-- ko if: configuration() == 'sideBySide' && widgetTypeRight() == 'ratingWidget' -->
                                                <div class="form-group">
                                                    <label class="form-label">Alternate Title</label><br>
                                                    <div class="last">
                                                        <label class="form-label icon i-overwrite"></label>
                                                        <input type="text" class="input-text" data-bind="value: rightWidgetRatingWidgetAlternateTitle, click: onClickValidatePinnedWidget()">
                                                    </div>
                                                </div>
                                            <!-- /ko -->

                                            <!-- ko if: configuration() == 'sideBySide' && widgetTypeRight() == 'hubPage' -->
                                                <div class="form-group">
                                                    <label class="form-label">Right Layout</label>
                                                    <div class="featured-pinned-list">
                                                        <div class="featured-pinned-element">
                                                            <input type="radio" name="layoutSideRight"  id="_layoutSideBySideRightCarousel" data-bind="checked: layoutSideBySideRight, checkedValue: 'carousel', click: onClickValidatePinnedWidget()">
                                                            <label class="form-label icon featured-sbs-carousel" for="_layoutSideBySideRightCarousel"></label>
                                                            <label class="form-label">Carousel<br>3 Articles</label>
                                                        </div>
                                                        <div class="featured-pinned-element">
                                                            <input type="radio" name="layoutSideRight" id="_layoutSideBySideRightHorizontal2" data-bind="checked: layoutSideBySideRight, checkedValue: 'horizontal-2', click: onClickValidatePinnedWidget()">
                                                            <label class="form-label icon featured-sbs-2-horizon" for="_layoutSideBySideRightHorizontal2"></label>
                                                            <label class="form-label" >Horizontal<br>2 Articles</label>
                                                        </div>
                                                        <div class="featured-pinned-element">
                                                            <input type="radio" name="layoutSideRight" id="_layoutSideBySideRightVertical3" data-bind="checked: layoutSideBySideRight, checkedValue: 'vertical-3', click: onClickValidatePinnedWidget()">
                                                            <label class="form-label icon featured-sbs-3-vertical" for="_layoutSideBySideRightVertical3"></label>
                                                            <label class="form-label">Vertical<br>3 Articles</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            <!-- /ko -->
                                        </div>

                                    </div>
                                <!-- /ko -->

                                <!-- Layout for Full Width -->
                                <!-- ko if: configuration() == 'fullWidth' && (fullWidthWidgetType() == 'hubPage' || fullWidthWidgetType() == 'listingPage') -->
                                    <div class="form-group">
                                        <!-- ko if: fullWidthWidgetHubPage() == null || (fullWidthWidgetHubPage() && fullWidthWidgetHubPage().idArticleType != 16)-->
                                            <label class="form-label">Layout</label><br>
                                            <div class="featured-pinned-list">
                                                <div class="featured-pinned-element">
                                                    <input type="radio" name="layoutFull" id="_layoutFullAccordion" data-bind="checked: layoutFullWidth, checkedValue: 'accordion', click: onClickValidatePinnedWidget()">
                                                    <label class="form-label icon featured-accordian-full" for="_layoutFullAccordion"></label>
                                                    <label class="form-label" for="_layoutFullAccordion">Accordion</label>

                                               </div>
                                                <div class="featured-pinned-element">
                                                    <input type="radio" name="layoutFull" id="_layoutFullAccordionReversed" data-bind="checked: layoutFullWidth, checkedValue: 'accordionReversed', click: onClickValidatePinnedWidget()">
                                                    <label class="form-label icon featured-accordian-full-reversed" for="_layoutFullAccordionReversed"></label>
                                                    <label class="form-label" for="_layoutFullAccordionReversed">Accordion Reversed</label>

                                               </div>
                                                <div class="featured-pinned-element">
                                                    <input type="radio" name="layoutFull" id="_layoutFullEqualSizeHorizontal" data-bind="checked: layoutFullWidth, checkedValue: 'equalSizeHorizontal-5', click: onClickValidatePinnedWidget()">
                                                    <label class="form-label icon featured-full" for="_layoutFullEqualSizeHorizontal"></label>
                                                    <label class="form-label" for="_layoutFullEqualSizeHorizontal">Horizontal List</label>
                                               </div>
                                               <div class="featured-pinned-element">
                                                    <input type="radio" name="layoutFull" id="_layoutFullEqualSizeHorizontalMedium" data-bind="checked: layoutFullWidth, checkedValue: 'equalSizeHorizontal-4', click: onClickValidatePinnedWidget()">
                                                    <label class="form-label icon featured-full" for="_layoutFullEqualSizeHorizontalMedium"></label>
                                                    <label class="form-label" for="_layoutFullEqualSizeHorizontalMedium">Horizontal List Medium</label>
                                               </div>
                                               <div class="featured-pinned-element">
                                                    <input type="radio" name="layoutFull" id="_layoutFullGrid" data-bind="checked: layoutFullWidth, checkedValue: 'grid', click: onClickValidatePinnedWidget()">
                                                    <label class="form-label icon featured-grid" for="_layoutFullGrid"></label>
                                                    <label class="form-label" for="_layoutFullGrid">Grid</label>
                                               </div>
                                               <div class="featured-pinned-element">
                                                    <input type="radio" name="layoutFull" id="_layoutFullGridAccordion" data-bind="checked: layoutFullWidth, checkedValue: 'gridAccordion', click: onClickValidatePinnedWidget()">
                                                    <label class="form-label icon featured-grid" for="_layoutFullGridAccordion"></label>
                                                    <label class="form-label" for="_layoutFullGridAccordion">Grid Accordion</label>
                                               </div>
                                               <div class="featured-pinned-element">
                                                    <input type="radio" name="layoutFull" id="_layoutFullSreenGrid" data-bind="checked: layoutFullWidth, checkedValue: 'full-screen-grid', click: onClickValidatePinnedWidget()">
                                                    <label class="form-label icon featured-grid" for="_layoutFullSreenGrid"></label>
                                                    <label class="form-label" for="_layoutFullSreenGrid">Full Screen Grid</label>
                                               </div>
                                               <div class="featured-pinned-element">
                                                    <input type="radio" name="layoutFull" id="_layoutFullOrderedList" data-bind="checked: layoutFullWidth, checkedValue: 'ordered-list', click: onClickValidatePinnedWidget()">
                                                    <label class="form-label icon featured-ordered-list" for="_layoutFullOrderedList"></label>
                                                    <label class="form-label" for="_layoutFullOrderedList">Ordered List</label>
                                               </div>
                                               <!-- ko if: fullWidthWidgetHubPage() == null || (fullWidthWidgetHubPage() && fullWidthWidgetHubPage().idArticleType == 15) -->
                                               <div class="featured-pinned-element">
                                                    <input type="radio" name="layoutFull" id="_layoutFullEqualSizePortraitList" data-bind="checked: layoutFullWidth, checkedValue: 'equalSizePortraitList', click: onClickValidatePinnedWidget()">
                                                    <label class="form-label icon featured-portrait" for="_layoutFullEqualSizePortraitList"></label>
                                                    <label class="form-label" for="_layoutFullEqualSizePortraitList">Portrait List</label>
                                               </div>
                                               <!-- /ko -->
                                               <div class="featured-pinned-element">
                                                    <input type="radio" name="layoutFull" id="_layoutFullTickerThin" data-bind="checked: layoutFullWidth, checkedValue: 'ticker-thin', click: onClickValidatePinnedWidget()">
                                                    <label class="form-label icon featured-ticker-thin" for="_layoutFullTickerThin"></label>
                                                    <label class="form-label" for="_layoutFullTickerThin">Ticker Thin</label>
                                               </div>
                                               <div class="featured-pinned-element">
                                                    <input type="radio" name="layoutFull" id="_layoutFullStack" data-bind="checked: layoutFullWidth, checkedValue: 'stack', click: onClickValidatePinnedWidget()">
                                                    <label class="form-label icon featured-stack" for="_layoutFullStack"></label>
                                                    <label class="form-label" for="_layoutFullStack">Stack</label>
                                               </div>
                                            </div>
                                            <!-- ko if: layoutFullWidth() == 'full-screen-grid' -->
                                            <div class="featured-pinned-image" style="margin: 20px 0 35px;">
                                                <label class="form-label">WIDGET BACKGROUND IMAGE</label><br>
                                                <div class="form-group img" style="margin-inline: 0;">
                                                    ${this.imageWidgetForFullWidth.getHtmlBuild() }
                                                </div>
                                            </div>
                                            <!-- /ko -->

                                        <!-- /ko -->

                                        <!-- ko if: fullWidthWidgetHubPage() && fullWidthWidgetHubPage().idArticleType == 16 -->
                                            <label class="form-label">Layout</label><br>
                                            <div class="featured-pinned-list">
                                                <div class="featured-pinned-element">
                                                    <input type="radio" name="layoutFull" id="_layoutFullEqualSizeHorizontal4" data-bind="checked: layoutFullWidth, checkedValue: 'equalSizeHorizontal-4', click: onClickValidatePinnedWidget()">
                                                    <label class="form-label icon featured-full" for="_layoutFullEqualSizeHorizontal4"></label>
                                                    <label class="form-label" for="_layoutFullEqualSizeHorizontal4">Horizontal<br>4 Articles</label>
                                               </div>
                                            </div>
                                        <!-- /ko -->
                                    </div>
                                <!-- /ko -->
                            </div>

                            <div class="form-footer">
                                <button class="btn secondary" type="button" data-bind="click: onClickAddPinnedWidget, disable: addToListDisabled">Add to List</button>
                                <button class="btn" type="button" data-bind="click: onClickCancelPinnedWidget">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-lightbox light-theme scrollable" data-bind="css: { 'is-visible': isMultiListingPinnedModalVisible }">
                <div class="lightbox-content">
                    <div class="w-form w-form-large lightbox-form">
                        <div class="pinned-form">
                            <div class="form-header">
                                <h3 class="form-title" data-bind="text: multiListingPinnedEditedIndex() !== null ? 'Update Hub Page Entry' : 'Add Hub Page Entry'"></h3>
                                <button class="close-button icon i-close-2" data-bind="event: { click: onClickCancelMultiListingPinnedEdit }"></button>
                            </div>
                            <div class="w-form-body">
                                <div class="form-body">
                                    <div class="form-group">
                                        <label class="form-label" for="multiListingPinnedEntryTitle">Entry Title</label>
                                        <input type="text" id="multiListingPinnedEntryTitle" class="input-text" data-bind="value: multiListingPinnedEntryTitle">
                                    </div>
                                    <div class="form-group">
                                        <input type="checkbox" id="multiListingPinnedUseLatest" data-bind="checked: multiListingPinnedUseLatest, event: { change: onChangeMultiListingPinnedUseLatest }">
                                        <label class="form-label icon i-check" for="multiListingPinnedUseLatest">Use Latest</label>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Hub Page</label>
                                        ${this.multiListingPinnedListingPageFilter.getHtmlBuild()}
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Pinned Articles (up to 4 optional)</label>
                                        ${this.multiListingPinnedArticles.getHtmlBuild()}
                                    </div>
                                    <div class="form-group">
                                        <input type="checkbox" id="multiListingPinnedIsPrimary" data-bind="checked: multiListingPinnedIsPrimary">
                                        <label class="form-label icon i-check" for="multiListingPinnedIsPrimary">Primary Hub Page</label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-footer">
                                <button class="btn secondary" type="button" data-bind="event:{ click: onClickAddMultiListingPinnedItem }, text: multiListingPinnedEditedIndex() !== null ? 'Update Hub Page Entry' : 'Add to List'"></button>
                                <button class="btn" type="button" data-bind="event:{ click: onClickCancelMultiListingPinnedEdit }">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div data-bind="css: { 'is-visible': isPinnedListingPageSectionVisible }" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="pinned-form">
                            <div class="form-header">
                                <h3 class="form-title">Add Pinned Hub Page</h3>
                                <button class="close-button icon i-close-2" data-bind="event: { click: onClickToggleListingPagePinnedSection.bind($data, null, false, false)}"></button>
                            </div>
                            <div class="form-body">
                                <div class="form-group">
                                    ${this.listingPageFilter.getHtmlBuild()}
                                </div>
                                <div class="form-group" data-bind="visible: isAlternateTitleVisible()">
                                        <label class="form-label icon i-overwrite">Alternate Title</label>
                                        <input type="text" class="input-text" data-bind="value: listingPageAlternateTitle,, click: onClickValidatePinnedWidget()"/>
                                </div>
                                <div class="form-group" data-bind="visible: isShowMoreVisible()">
                                        ${this.showMoreListingPageFilter.getHtmlBuild()}
                                </div>
                            </div>
                            <div class="form-footer">
                                <button class="btn secondary" type="button" data-bind="event:{click: onClickAddPinnedListingPage }, text: 'Add'">Add to List</button>
                                <button type="button" data-bind="event: { click: onClickToggleListingPagePinnedSection.bind($data, null, false, false)}" class="btn ">Cancel</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            ${this.imagePicker.getHtmlBuild()}
        `;
    }

    protected initPartial(): void {

        this.pinnedArticles = new pinnedArticles_template('pinnedArticles', this.getTemplateViewModel(), this.caller);
        this.pinnedArticles.setMaximum(8);

        this.filterSidebarLinksListingPage = new filterListingPage_template("filterSidebarLinksListingPage", this.getTemplateViewModel(), this.caller);
        this.filterSidebarLinksListingPage.setPlaceholder('Listing Page');

        this.filterSidebarLinksArticle = new filterAutocomplete_template('filterSidebarLinksArticle', this.getTemplateViewModel(), this.caller);
        this.filterSidebarLinksArticle.setAddNewOptionEnabled(false);
        this.filterSidebarLinksArticle.setHasDisplayNameComplement(false);
        this.filterSidebarLinksArticle.setNumberOfChars(3);
        this.filterSidebarLinksArticle.setPlaceholderAndLabel("Article");
        this.filterSidebarLinksArticle.setOptionType("title");

        this.featuredWikiFilter = new filterAutocomplete_template('featuredWikiFilter', this.getTemplateViewModel(), this);
        this.featuredWikiFilter.setAddNewOptionEnabled(false);
        this.featuredWikiFilter.setHasDisplayNameComplement(false);
        this.featuredWikiFilter.setNumberOfChars(1);
        this.featuredWikiFilter.setPlaceholderAndLabel("Wiki");
        this.featuredWikiFilter.setOptionType("name");

        this.latestYoutubeVideoFilter = new filterAutocomplete_template('latestYoutubeVideoFilter', this.getTemplateViewModel(), this);
        this.latestYoutubeVideoFilter.setAddNewOptionEnabled(false);
        this.latestYoutubeVideoFilter.setHasDisplayNameComplement(false);
        this.latestYoutubeVideoFilter.setNumberOfChars(1);
        this.latestYoutubeVideoFilter.setPlaceholderAndLabel("YouTube Video");
        this.latestYoutubeVideoFilter.setOptionType("title");

        this.sectionTypes = [{ id: 'numerical', name: 'Numbered' }, { id: 'list', name: 'Bullet Point' }];

        this.filterSectionType = new filterDropdown_template('filterSidebarLinksSectionType', this.getTemplateViewModel(), this.caller);
        this.filterSectionType.setOptions(this.sectionTypes);

        this.listingPageFilter = new filterListingPage_template("filterListingPage", this.getTemplateViewModel(), this.caller);
        this.listingPageFilter.setPlaceholder("Main Hub Page");
        this.listingPageFilter.setShowDetails(true);
        this.listingPageFilter.setIsLoadingAnimationEnable(true);

        this.headerLatestHubPageFilter = new filterListingPage_template("filterHeaderLatestHubPage", this.getTemplateViewModel(), this.caller);
        this.headerLatestHubPageFilter.setPlaceholder("Hub Page");
        this.headerLatestHubPageFilter.setShowDetails(true);
        this.headerLatestHubPageFilter.setIsLoadingAnimationEnable(true);

        //NEW WIDGET
        this.listingPageFilterLeft = new filterListingPage_template("filterHubPageLeft", this.getTemplateViewModel(), this.caller);
        this.listingPageFilterLeft.setPlaceholder("Hub Page Left");
        this.listingPageFilterLeft.setShowDetails(true);
        this.listingPageFilterLeft.setIsLoadingAnimationEnable(true);

        this.listingPageFilterRight = new filterListingPage_template("filterHubPageRight", this.getTemplateViewModel(), this.caller);
        this.listingPageFilterRight.setPlaceholder("Hub Page Right");
        this.listingPageFilterRight.setShowDetails(true);
        this.listingPageFilterRight.setIsLoadingAnimationEnable(true);

        this.listingPageFilterFullWidth = new filterListingPage_template("filterHubPageFullWidth", this.getTemplateViewModel(), this.caller);
        this.listingPageFilterFullWidth.setPlaceholder("Hub Page Full Width");
        this.listingPageFilterFullWidth.setShowDetails(true);
        this.listingPageFilterFullWidth.setIsLoadingAnimationEnable(true);

        this.multipleHubPagesWidget = new multipleHubPagesWidget_template("filterHubPageMultipleHubPages", this.getTemplateViewModel(), this.caller);
        this.multipleHubPagesWidget.setAlternateTitlePlaceholder("Alternate Title");
        this.multipleHubPagesWidget.detectIfDBSearchIsEnabled();

        this.multiListingPinnedListingPageFilter = new filterListingPage_template("multiListingPinnedListingPage", this.getTemplateViewModel(), this.caller);
        this.multiListingPinnedListingPageFilter.setPlaceholder("Hub Page");
        this.multiListingPinnedListingPageFilter.setShowDetails(true);
        this.multiListingPinnedListingPageFilter.setIsLoadingAnimationEnable(true);

        this.listingPageFilterLeftShowMore = new filterListingPage_template("filterHubPageLeftShowMore", this.getTemplateViewModel(), this.caller);
        this.listingPageFilterLeftShowMore.setPlaceholder("Hub Page Left Show More");
        this.listingPageFilterLeftShowMore.setShowDetails(true);
        this.listingPageFilterLeftShowMore.setIsLoadingAnimationEnable(true);

        this.listingPageFilterRightShowMore = new filterListingPage_template("filterHubPageRightShowMore", this.getTemplateViewModel(), this.caller);
        this.listingPageFilterRightShowMore.setPlaceholder("Hub Page Right Show More");
        this.listingPageFilterRightShowMore.setShowDetails(true);
        this.listingPageFilterRightShowMore.setIsLoadingAnimationEnable(true);

        this.listingPageFilterFullWidthShowMore = new filterListingPage_template("filterHubPageFullWidthShowMore", this.getTemplateViewModel(), this.caller);
        this.listingPageFilterFullWidthShowMore.setPlaceholder("Hub Page Full Width Show More");
        this.listingPageFilterFullWidthShowMore.setShowDetails(true);
        this.listingPageFilterFullWidthShowMore.setIsLoadingAnimationEnable(true);

        this.showMoreListingPageFilter = new filterListingPage_template("filterShowMoreListingPage", this.getTemplateViewModel(), this.caller);
        this.showMoreListingPageFilter.setPlaceholder('Show More Hub Page');
        this.showMoreListingPageFilter.setShowDetails(true);
        this.showMoreListingPageFilter.setIsLoadingAnimationEnable(true);

        this.imagePicker = new imagePicker_template(
            "imagePicker",
            this.getTemplateViewModel(),
            this.caller
        );
        this.imagePickerHelper = new imagePickerHelper(
            this.imagePicker,
            this.caller.viewModel,
            this.caller.getVnAppZone(),
            this.caller
        );
        this.imageWidget = new imageWidget_template('custom_card_image', this.getTemplateViewModel(), this);
        this.imageWidget.setMode('single-select');
        this.imageWidget.setCaller(this.imagePickerHelper);

        this.homePageEventBannerImageWidget = new imageWidget_template('homepage_event_banner_image', this.getTemplateViewModel(), this);
        this.homePageEventBannerImageWidget.setMode('single-select');
        this.homePageEventBannerImageWidget.setCaller(this.imagePickerHelper);

        this.homePageEventBannerListingPageFilter = new filterListingPage_template('homePageEventBannerListingPage', this.getTemplateViewModel(), this.caller);
        this.homePageEventBannerListingPageFilter.setPlaceholder('Listing Page');
        this.homePageEventBannerListingPageFilter.setShowDetails(true);
        this.homePageEventBannerListingPageFilter.setIsLoadingAnimationEnable(true);

        this.featuredWikiImageWidget = new imageWidget_template('featured_wiki_override_image', this.getTemplateViewModel(), this);
        this.featuredWikiImageWidget.setMode('single-select');
        this.featuredWikiImageWidget.setCaller(this.imagePickerHelper);

        this.latestYoutubeOverrideImageWidget = new imageWidget_template('latest_youtube_override_image', this.getTemplateViewModel(), this);
        this.latestYoutubeOverrideImageWidget.setMode('single-select');
        this.latestYoutubeOverrideImageWidget.setCaller(this.imagePickerHelper);

        this.hpFullWidthArticles = new pinnedArticles_template("hpFullWidthArticles", this.getTemplateViewModel(), this.caller);
        this.hpLeftPinnedArticles = new pinnedArticles_template("hpLeftPinnedArticles", this.getTemplateViewModel(), this.caller);
        this.hpRightPinnedArticles = new pinnedArticles_template("hpRightPinnedArticles", this.getTemplateViewModel(), this.caller);
        this.multiListingPinnedArticles = new pinnedArticles_template("multiListingPinnedArticles", this.getTemplateViewModel(), this.caller);
        this.multiListingPinnedArticles.setMaximum(4);

        this.getTemplateViewModel().configuration.subscribe(() => this.updateFullWidthArticlesMaximum());
        this.getTemplateViewModel().fullWidthWidgetType.subscribe(() => this.updateFullWidthArticlesMaximum());
        this.getTemplateViewModel().layoutFullWidth.subscribe(() => this.updateFullWidthArticlesMaximum());
        this.getTemplateViewModel().fullWidthWidgetHubPage.subscribe(() => this.updateFullWidthArticlesMaximum());

        this.imageWidgetForFullWidth = new imageWidget_template('imageWidgetForFullWidthHubPage', this.getTemplateViewModel(), this);
        this.imageWidgetForFullWidth.setMode('single-select');
        this.imageWidgetForFullWidth.setCaller(this.imagePickerHelper);

        this.imagePickerForNewsletter = new imageWidget_template('imagePickerForNewsletter', this.getTemplateViewModel(), this);
        this.imagePickerForNewsletter.setMode('single-select');
        this.imagePickerForNewsletter.setCaller(this.imagePickerHelper);

    }

    protected getTemplateName(): string {
        return "configHomePage-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return ["ww-form", "config-homepage"];
    }

    protected buildViewModel(): any {

        let self = this;
        return {
            sidebarSections: ko.observableArray([]),
            isItemDialogVisible: ko.observable(false),
            isSectionDialogVisible: ko.observable(false),
            isSectionDeleteVisible: ko.observable(false),
            isLinkDeleteVisible: ko.observable(false),
            activeSection: ko.observable(null),
            linkToDelete: ko.observable(null),
            linkToEdit: ko.observable(null),
            sectionToEdit: ko.observable(null),
            linkType: ko.observable('article'),
            sidebarSectionTabTitle: ko.observable(null),
            alternateTitle: ko.observable(''),
            sectionTitle: ko.observable(''),
            maximumPinnedListingPages: ko.observable(25),
            maximumFullListPinnedListingPages: ko.observable(5),
            maximumPinnedHubPagesPreview: ko.observable(2),
            isFullListTabActive: ko.observable(false),
            isHubPagesPreviewTabActive: ko.observable(false),
            isPinnedListingPageSectionVisible: ko.observable(false),
            isAlternateTitleVisible: ko.observable(true),
            isShowMoreVisible: ko.observable(true),
            pinnedListingPages: ko.observableArray([]),
            fullListPinnedListingPages: ko.observableArray([]),
            pinnedHubPagesPreview: ko.observableArray([]),
            listingPageAlternateTitle: ko.observable(''),
            currentSection: ko.observable(null),
            addFeaturedListingPageEnabled: ko.observable(true),
            tagTrendingLogicConfig: ko.observable(null),
            isDbPageRatingEnabled: ko.observable(false),
            isDbSpotlightEnabled: ko.observable(true),
            isDbPageTabActive: ko.observable(false),
            isDbHomeSpotlightPageTabActive: ko.observable(false),
            spotlightTitle: ko.observable(''),
            pinnedDbPages: ko.observableArray([]),
            pinnedDbHomeSpotlightPages: ko.observableArray([]),
            activatePinnedCustomCards: ko.observable(false),
            isMLT: ko.observable(false),
            homePageEventBannerEnabled: ko.observable(false),
            homePageEventBannerStartDate: ko.observable(''),
            homePageEventBannerEndDate: ko.observable(''),
            customCardsSectionTitle: ko.observable(''),
            customCardsMoreLinkoutTitle: ko.observable(''),
            customCardsMoreLinkoutUrl: ko.observable(''),
            isAddPinnedCustomCardVisible: ko.observable(false),
            customCardTitle: ko.observable(''),
            customCardLinkoutUrl: ko.observable(''),
            pinnedCustomCardItems: ko.observableArray([]),
            cardEdited: ko.observable(),
            activateFeaturedWikis: ko.observable(false),
            featuredWikiOptions: ko.observableArray([]),
            selectedFeaturedWikiId: ko.observable(null),
            featuredWikiSelectedOption: ko.observable(null),
            isAddFeaturedWikiVisible: ko.observable(false),
            featuredWikiOverrideTitle: ko.observable(''),
            featuredWikiItems: ko.observableArray([]),
            featuredWikiEditedIndex: ko.observable(null),
            activeLayoutOptions: ko.observableArray([]),
            horizontalLatest: ko.observableArray([]),
            idLayout: ko.observable(''),
            enableLayoutFeaturedPinnedTitle: ko.observable(false),
            layoutFeaturedPinnedTitle: ko.observable(''),
            articleCount: ko.observable(),
            additionalDataType: ko.observable(),
            showImage: ko.observable(),
            showThreadCount: ko.observable(),
            useBackground: ko.observable(),
            headerLatestHubPageAlternateTitle: ko.observable(''),
            headerLatestHubArticlesConfig: ko.observable('hubPageSortOrder'),
            isThreeArticleHubPageConfigurationModalVisible: ko.observable(false),
            isFX: ko.observable(false),
            permissions: ko.observableArray(this.initPermissions(['pin_homepage_layout'])),
            isPinnedWidgetSectionVisible: ko.observable(false),
            configuration: ko.observable(""),
            fullWidthWidgetType: ko.observable(""),
            widgetTypeLeft: ko.observable(""),
            widgetTypeRight: ko.observable(""),
            layoutFullWidth: ko.observable(""),
            layoutSideBySideLeft: ko.observable(""),
            layoutSideBySideRight: ko.observable(""),
            selectedHubPageRightType: ko.observable(""),
            pinnedWidgets: ko.observableArray([]),
            leftWidgetHubPage: ko.observable(null),
            leftWidgetHubPageShowMore: ko.observable(null),
            rightWidgetHubPage: ko.observable(null),
            rightWidgetHubPageShowMore: ko.observable(null),
            fullWidthWidgetHubPage: ko.observable(null),
            fullWidthWidgetHubPageShowMore: ko.observable(null),
            fullWidthWidgetHubPageAlternateTitle: ko.observable(""),
            leftWidgetHubPageAlternateTitle: ko.observable(""),
            rightWidgetHubPageAlternateTitle: ko.observable(""),
            isEditingPinnedWidget: ko.observable(false),
            editingPinnedWidgetIndex: ko.observable(null),
            addToListDisabled: ko.observable(true),
            leftWidgetRatingWidgetAlternateTitle: ko.observable(null),
            rightWidgetRatingWidgetAlternateTitle: ko.observable(null),
            ratingWidgetEnabled: ko.observable(false),
            lightBackgroundDisabled: ko.observable(false),
            fullHubArticlesConfig: ko.observable('hubPageSortOrder'),
            leftHubArticlesConfig: ko.observable('hubPageSortOrder'),
            rightHubArticlesConfig: ko.observable('hubPageSortOrder'),
            widgetTitle: ko.observable(''),
            widgetLeftTitle: ko.observable(''),
            widgetRightTitle: ko.observable(''),
            newsletterTitle: ko.observable(null),
            newsletterDescription: ko.observable(null),
            newsletterBackgroundColor: ko.observable(null),
            // The native colour input cannot hold an empty value, so it binds to its own
            // always-valid observable while newsletterBackgroundColor stays nullable.
            newsletterBackgroundColorPicker: ko.observable('#ffffff'),
            newsletterWidth: ko.observable('full-screen'),
            isTradingCardPageTabActive: ko.observable(false),
            isTradingCardFeatureEnabled: ko.observable(false),
            tradingCardsSectionTitle: ko.observable(''),
            pinnedTradingCardPages: ko.observableArray([]),
            multiListingPinnedSectionTitle: ko.observable(''),
            multiListingPinnedEntryTitle: ko.observable(''),
            multiListingPinnedUseLatest: ko.observable(false),
            multiListingPinnedIsPrimary: ko.observable(false),
            multiListingPinnedItems: ko.observableArray([]),
            multiListingPinnedEditedIndex: ko.observable(null),
            isMultiListingPinnedModalVisible: ko.observable(false),
            latestYoutubeVideosSectionTitle: ko.observable('Latest Youtube Videos'),
            latestYoutubeVideosIdChannel: ko.observable(''),
            latestYoutubeChannelOptions: ko.observableArray([]),
            latestYoutubeVideoOptions: ko.observableArray([]),
            latestYoutubeVideoItems: ko.observableArray([]),
            latestYoutubeVideoEditedIndex: ko.observable(null),
            latestYoutubeVideoEditingItem: ko.observable(null),
            latestYoutubeVideoOverrideTitle: ko.observable(''),
            isLatestYoutubeVideoEditModalVisible: ko.observable(false),
            onClickAddLatestYoutubeVideo: function () {
                self.onClickAddLatestYoutubeVideo();
            },
            onClickEditLatestYoutubeVideo: function (data, event) {
                self.onClickEditLatestYoutubeVideo(data);
            },
            onClickSaveLatestYoutubeVideoOverride: function () {
                self.onClickSaveLatestYoutubeVideoOverride();
            },
            onClickCancelLatestYoutubeVideoEdit: function () {
                self.resetLatestYoutubeVideoEditForm();
            },
            onClickDeleteLatestYoutubeVideo: function (data, event) {
                self.onClickDeleteLatestYoutubeVideo(data);
            },
            onChangeLatestYoutubeVideosChannel: function () {
                self.onChangeLatestYoutubeVideosChannel();
                return true;
            },
            getLatestYoutubeVideoDisplayTitle: function (item) {
                return self.getLatestYoutubeVideoDisplayTitle(item);
            },
            getLatestYoutubeVideoDisplayImageUrl: function (item) {
                return self.getLatestYoutubeVideoDisplayImageUrl(item);
            },
            onClickOpenMultiListingPinnedModal: function () {
                self.onClickOpenMultiListingPinnedModal();
            },
            onClickAddMultiListingPinnedItem: function () {
                self.onClickAddMultiListingPinnedItem();
            },
            onClickEditMultiListingPinnedItem: function (data, event) {
                self.onClickEditMultiListingPinnedItem(data);
            },
            onClickDeleteMultiListingPinnedItem: function (data, event) {
                self.onClickDeleteMultiListingPinnedItem(data);
            },
            onClickCancelMultiListingPinnedEdit: function () {
                self.resetMultiListingPinnedEntryForm();
            },
            onChangeMultiListingPinnedUseLatest: function () {
                self.onChangeMultiListingPinnedUseLatest();
                return true;
            },
            onClickAddPinnedWidget: function () {
                self.onClickAddPinnedWidget();
            },
            onClickValidatePinnedWidget: function () {
                self.updateFullWidthArticlesMaximum();
                self.validatePinnedWidget();
            },
            onClickLayout: function (data, event) {
                self.onClickLayout(data);
            },
            onClickArticleCount: function (data, event) {
                self.onClickArticleCount();
            },
            onClickAddPinnedListingPage: function (data, event) {
                self.onClickAddPinnedListingPage();
            },
            onClickEditPinnedListing: function (data, event) {
                self.onClickEditPinnedListing(data);
            },
            onClickDeletePinnedListingPage: function (data, event) {
                self.onClickDeletePinnedListingPage(data);
            },
            handleDragAndDrop: function (element, currentObservableArray, childrenSelector) {
                self.handleDragAndDrop(element, currentObservableArray, childrenSelector);
            },
            onFocus: function (data, event) {
                self.onFocus(data, event);
            },
            onBlur: function (data, event) {
                self.onBlur(data, event);
            },
            onClickCancelHomePageConfig: (data, event) => {
                self.onClickCancelHomePageConfig();
            },
            onClickSaveHomePageConfig: (data, event) => {
                self.onClickSaveHomePageConfig();
            },
            onClickSaveSection: (data) => {
                self.onClickSaveSection();
            },
            onClickDeleteSection: (data) => {
                self.onClickDeleteSection();
            },
            onClickAddLink: (data) => {
                self.onClickAddLink();
            },
            onClickEditLink: (data) => {
                self.onClickEditLink(data);
            },
            onClickEditSection: (data) => {
                self.onClickEditSection(data);
            },
            onClickDeleteLink: (data) => {
                self.onClickDeleteLink(data);
            },
            onClickSaveSidebarFeaturedLinks: (data) => {
                self.onClickSaveSidebarFeaturedLinks();
            },
            onClickShowSectionModal: (data) => {
                self.onClickShowSectionModal();
            },
            onClickShowItemModal: (data) => {
                self.onClickShowItemModal();
            },
            onClickHideItemModal: (data) => {
                self.onClickHideItemModal();
            },
            onClickCancelLinkEdit: (data) => {
                self.onClickCancelLinkEdit(data);
            },
            onClickCancelSectionEdit: (data) => {
                self.onClickCancelSectionEdit();
            },
            onClickSetActiveSection: (value, data, event) => {
                self.onClickSetActiveSection(value);
            },
            onClickConfirmSectionDelete: function (data, event) {
                self.onClickConfirmSectionDelete();
            },
            onClickConfirmLinkDelete: function (data, event) {
                self.onClickConfirmLinkDelete(data);
            },
            onClickCancelLinkDelete: function (data, event) {
                self.onClickCancelLinkDelete()
            },
            onClickCancelSectionDelete: function (data, event) {
                self.setIsSectionDeleteDialogVisible(false)
            },
            onClickToggleListingPagePinnedSection: function (section, value, type, data, event) {
                //alert(JSON.stringify(arguments));
                self.setIsPinnedListingPageSectionDialogVisible(section, value, type);
            },
            onClickToggleHubPage2HubPreviewSection: function (section, value, type, data, event) {

                self.setIsPinnedListingPageSectionDialogVisible(section, value, type);
            },
            onClickTogglePinnedCustomCardSection: function (data, event) {
                self.onClickTogglePinnedCustomCardSection(data);
            },
            onClickAddPinnedCustomCardItem: function (data, event) {
                self.onClickAddPinnedCustomCardItem();
            },
            onClickDeletePinnedCustomCardItem: function (data, event) {
                self.onClickDeletePinnedCustomCardItem(data);
            },
            onClickEditPinnedCustomCardItem: function (data, event) {
                self.onClickEditPinnedCustomCardItem(data);
            },
            onClickAddFeaturedWikiItem: function (data, event) {
                self.onClickAddFeaturedWikiItem();
            },
            onClickDeleteFeaturedWikiItem: function (data, event) {
                self.onClickDeleteFeaturedWikiItem(data);
            },
            onClickEditFeaturedWikiItem: function (data, event) {
                self.onClickEditFeaturedWikiItem(data);
            },
            onClickToggleFeaturedWikiModal: function (show, data, event) {
                self.onClickToggleFeaturedWikiModal(show);
            },
            getFeaturedWikiPreview: function (idWiki) {
                return self.getFeaturedWikiOption(idWiki);
            },
            getFeaturedWikiCurrentTitle: function (item) {
                return self.getFeaturedWikiCurrentValue(item, 'name');
            },
            getFeaturedWikiCurrentUrl: function (item) {
                return self.getFeaturedWikiCurrentValue(item, 'currentUrl');
            },
            getFeaturedWikiCurrentImageUrl: function (item) {
                return self.getFeaturedWikiCurrentValue(item, 'currentImageUrl');
            },
            onClickCancelPinnedWidget: function () {
                self.onClickCancelPinnedWidget();
            },
            onClickDeletePinnedWidget: function (data, event) {
                const vm = self.getTemplateViewModel();
                vm.pinnedWidgets.remove(data);
            },
            onClickAddPinnedWidgetToggle: function (data, event) {
                self.onClickAddPinnedWidgetToggle();
            },
            onClickEditPinnedWidget: function (data, event) {
                self.onClickEditPinnedWidget(data);
            },
            dragStart: (data, event) => { self.startDrag(data, event); },
            dragEnd: (data) => { data.dragging(false); },
            reorderSortable: (event, dragData, zoneData) => { self.reorderSortable(event, dragData, zoneData); },
            formatCamelCaseLabel: (str) => { return self.formatCamelCaseLabel(str); },
            formatListingPagesForDisplay: (listingPages) => { return self.formatListingPagesForDisplay(listingPages); },
            formatArticlesForDisplay: (articles) => { return self.formatArticlesForDisplay(articles); },
            isThreeArticleHubPageConfigurationVisible: () => self.isThreeArticleHubPageConfigurationVisible(),
            onClickOpenThreeArticleHubPageConfigurationModal: () => self.onClickOpenThreeArticleHubPageConfigurationModal(),
            onClickSaveThreeArticleHubPageConfigurationModal: () => self.onClickSaveThreeArticleHubPageConfigurationModal(),
            onClickCancelThreeArticleHubPageConfigurationModal: () => self.onClickCancelThreeArticleHubPageConfigurationModal(),
            clearNewsletterBackgroundColor: () => { self.clearNewsletterBackgroundColor(); },
            onNewsletterBackgroundColorPicked: (data, event) => { self.onNewsletterBackgroundColorPicked(event); },
        };
    }


    public clearNewsletterBackgroundColor = () => {
        this.getTemplateViewModel().newsletterBackgroundColor(null);
        this.getTemplateViewModel().newsletterBackgroundColorPicker('#ffffff');
        this.validatePinnedWidget();
    };

    public onNewsletterBackgroundColorPicked = (event) => {
        const picked = event && event.target ? (event.target.value || '').trim() : '';
        this.getTemplateViewModel().newsletterBackgroundColorPicker(picked ? picked : '#ffffff');
        this.getTemplateViewModel().newsletterBackgroundColor(picked ? picked : null);
        this.validatePinnedWidget();
    };
    public getViewModelForRequest() {

        const layoutId = this.getTemplateViewModel().idLayout();
        const articleCount = this.getTemplateViewModel().articleCount()

        let layoutFeaturedPinnedTitle = '';
        if(layoutId == 3 && articleCount == 9) {
            layoutFeaturedPinnedTitle = this.getTemplateViewModel().layoutFeaturedPinnedTitle();
        }

        return {
            pinnedArticles: this.getPinnedArticles(),
            pinnedListingPages: this.getPinnedListingPages(),
            pinned2HubPreviewPages: this.getPinnedHubPagesPreviewPages(),
            isDbPageRatingEnabled: this.getTemplateViewModel().isDbPageRatingEnabled(),
            isDbSpotlightEnabled: this.getTemplateViewModel().isDbSpotlightEnabled(),
            pinnedDbPages: this.getPinnedDbPages(),
            pinnedDbHomeSpotlightPages: this.getPinnedDbHomeSpotlightPages(),
            pinnedCustomCardsSection: this.getPinnedCustomCardsSection(),
            homePageEventBanner: this.getHomePageEventBanner(),
            featuredWikisSection: this.getFeaturedWikisSection(),
            pinnedTradingCardPages: this.getPinnedTradingCardPages(),
            multiListingPinnedSection: this.getMultiListingPinnedSection(),
            latestYoutubeVideosSection: this.getLatestYoutubeVideosSection(),
            layout: this.getTemplateViewModel().idLayout(),
            pinnedWidgets: this.getTemplateViewModel().pinnedWidgets(),
            headerLatestArticles: {
                availableArticleCount: this.getTemplateViewModel().articleCount(),
                additionalData: this.getTemplateViewModel().additionalDataType(),
                image: this.getTemplateViewModel().showImage(),
                threadCount: this.getTemplateViewModel().showThreadCount(),
                background: this.getTemplateViewModel().useBackground(),
                hubPage: this.headerLatestHubPageFilter.getTemplateViewModel().listingPageObj(),
                alternateTitle: this.getTemplateViewModel().headerLatestHubPageAlternateTitle(),
                articlesConfig: this.getTemplateViewModel().headerLatestHubArticlesConfig()
            },
            layoutFeaturedPinnedTitle: layoutFeaturedPinnedTitle,
        };
    }

    public setPinnedArticles(articles) {

        let data = [];

        for (let item of articles) {

            let pinnedArticle: pinnedArticle = {

                id: item.id,
                idArticle: item.emakiArticle.id,
                reference: item.emakiArticle.reference,
                article: item.emakiArticle,
                alternateTitle: item.alternateTitle,
                pinnedHours: '',
                position: item.position,
                expire: item.expire,
                timeLeft: (item.timeLeft) ? item.timeLeft : '',
                enableEdit: false,
            }

            data.push(pinnedArticle)
        }

        this.pinnedArticles.setArticles(data)
    }

    public setLayoutOptions(layoutOptions) {
        this.getTemplateViewModel().activeLayoutOptions(layoutOptions);
    }

    public getPinnedArticles() {

        let data = [];
        let articles = this.pinnedArticles.getArticles();
        for (let item of articles) {

            let pinnedArticle = {

                id: item.id,
                idEmakiArticle: item.idArticle,
                emakiArticle: item.article,
                alternateTitle: item.alternateTitle,
                expire: item.expire,
                pinnedHours: item.pinnedHours,
                position: item.position
            };

            data.push(pinnedArticle)
        }

        return data;
    }

    public setArticleFilterAutocomplete(idElement, articles) {

        switch (idElement) {
            case 'hpFullWidthArticles_articleFilter':
                this.hpFullWidthArticles.articleFilter.setOptions(articles);
                break;
            case 'hpLeftPinnedArticles_articleFilter':
                this.hpLeftPinnedArticles.articleFilter.setOptions(articles);
                break;
            case 'hpRightPinnedArticles_articleFilter':
                this.hpRightPinnedArticles.articleFilter.setOptions(articles);
                break;
            case 'multiListingPinnedArticles_articleFilter':
                this.multiListingPinnedArticles.articleFilter.setOptions(articles);
                break;
            default:
                this.pinnedArticles.articleFilter.setOptions(articles);
                break;
        }
    }

    public setPinnedListingPages(listingPages) {

        let pinnedListingPages = [];
        let fullPinnedListingPages = [];
        let hubPreviewListingPages = [];
        let pinnedDbPages = [];
        let addFeaturedListingPageEnabled = true;

        for (let x in listingPages) {

            let id = 'limitedFilterShowMoreListingPage';
            if (listingPages[x].isFullList) {
                id = 'fullFilterShowMoreListingPage'
            }
            if (listingPages[x].type == "hubPreview") {
                id = 'hubPreviewFilterShowMoreListingPage';
            }

            let filter = new filterListingPage_template(id + (x), this.getTemplateViewModel(), this.caller);
            filter.setShowDetails(true);
            filter.setPlaceholder('Show More Listing Page');
            filter.setIsLoadingAnimationEnable(true);

            let pinnedListingPage = {

                id: listingPages[x].id,
                idListingPage: listingPages[x].idListingPage,
                listingPage: listingPages[x].listingPage,
                idShowMoreListingPage: listingPages[x].idShowMoreListingPage,
                showMoreListingPage: listingPages[x].showMoreListingPage,
                showMoreListingPageFilter: filter,
                position: listingPages[x].position,
                dateCreated: listingPages[x].dateCreated,
                alternateTitle: listingPages[x].alternateTitle,
                enableEdit: false,
                isFullList: listingPages[x].isFullList,
                isHubPreview: (listingPages[x].type == "hubPreview"),
                isDbPage: (listingPages[x].type == "hubRating"),
                isDbHomeSpotlightPage: (listingPages[x].type == "homeSpotlight"),
                type: listingPages[x].type,
                idTags: listingPages[x].listingPage && listingPages[x].listingPage.tags ? listingPages[x].listingPage.tags : [],
            };

            if (listingPages[x].showMoreListingPage) {

                let showMoreListingPage = listingPages[x].showMoreListingPage;
                pinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().listingPageObj(showMoreListingPage);
                pinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().listingPage(showMoreListingPage.name + ' (' + showMoreListingPage.permalink + ')');
                pinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().idListingPage(listingPages[x].idShowMoreListingPage);
            }

            if (listingPages[x].isFullList) {
                fullPinnedListingPages.push(pinnedListingPage);
            } else if (listingPages[x].type == "hubPreview") {
                hubPreviewListingPages.push(pinnedListingPage);
            } else if (listingPages[x].type == "hubRating") {
                pinnedDbPages.push(pinnedListingPage);
            }
            else {
                pinnedListingPages.push(pinnedListingPage);
            }

            if (listingPages[x].type == "featured") {
                addFeaturedListingPageEnabled = false;
            }

        }

        this.getTemplateViewModel().addFeaturedListingPageEnabled(addFeaturedListingPageEnabled);

        this.getTemplateViewModel().pinnedListingPages(pinnedListingPages);
        this.getTemplateViewModel().fullListPinnedListingPages(fullPinnedListingPages);
        this.getTemplateViewModel().pinnedHubPagesPreview(hubPreviewListingPages);
        this.getTemplateViewModel().pinnedDbPages(pinnedDbPages);
    }

    public getPinnedListingPages() {
        let addFeaturedListingPageEnabled = true;

        this.updatePinnedListingPagePosition();
        this.updateFullListPinnedListingPagePosition();
        let pinnedListingPageIds = [];
        const listingPages = [...this.getTemplateViewModel().pinnedListingPages(), ...this.getTemplateViewModel().fullListPinnedListingPages()]

        for (let i = 0; i < listingPages.length; i++) {

            let item = {
                idListingPage: listingPages[i].idListingPage,
                idShowMoreListingPage: listingPages[i].showMoreListingPageFilter.getTemplateViewModel().idListingPage(),
                alternateTitle: listingPages[i].alternateTitle,
                position: listingPages[i].position,
                isFullList: listingPages[i].isFullList,
                type: listingPages[i].type,
            };

            if (listingPages[i].type == "featured") {
                addFeaturedListingPageEnabled = false;
            }

            pinnedListingPageIds.push(item)
        }

        this.getTemplateViewModel().addFeaturedListingPageEnabled(addFeaturedListingPageEnabled);

        return pinnedListingPageIds;
    }

    public updatePinnedHubPagesPreviewPosition() {

        let pinnedHubPagesPreview = this.getTemplateViewModel().pinnedHubPagesPreview();

        for (let i = 0; i < pinnedHubPagesPreview.length; i++) {

            pinnedHubPagesPreview[i].position = i + 1;
        }

        this.getTemplateViewModel().pinnedHubPagesPreview([]);
        this.getTemplateViewModel().pinnedHubPagesPreview(pinnedHubPagesPreview);
    }

    public getPinnedHubPagesPreviewPages() {

        this.updatePinnedHubPagesPreviewPosition();

        let pinnedHubPagesPreviewIds = [];
        const listingPages = this.getTemplateViewModel().pinnedHubPagesPreview();

        for (let i = 0; i < listingPages.length; i++) {

            let item = {
                idListingPage: listingPages[i].idListingPage,
                idShowMoreListingPage: listingPages[i].showMoreListingPageFilter.getTemplateViewModel().idListingPage(),
                alternateTitle: listingPages[i].alternateTitle,
                position: listingPages[i].position,
                isHubPreview: listingPages[i].isHubPreview,
                type: listingPages[i].type,
            };

            pinnedHubPagesPreviewIds.push(item)
        }

        return pinnedHubPagesPreviewIds;
    }

    public updatePinnedDbPagesPosition() {

        let pinnedDbPages = this.getTemplateViewModel().pinnedDbPages();

        for (let i = 0; i < pinnedDbPages.length; i++) {

            pinnedDbPages[i].position = i + 1;
        }

        this.getTemplateViewModel().pinnedDbPages([]);
        this.getTemplateViewModel().pinnedDbPages(pinnedDbPages);
    }

    public getPinnedDbPages() {

        this.updatePinnedDbPagesPosition();

        let pinnedDbPageTagIds = [];
        const pinnedDbPages = this.getTemplateViewModel().pinnedDbPages();

        for (let i = 0; i < pinnedDbPages.length; i++) {

            let item = {
                idListingPage: pinnedDbPages[i].idListingPage,
                idShowMoreListingPage: null,
                alternateTitle: '',
                position: pinnedDbPages[i].position,
                isHubPreview: pinnedDbPages[i].isHubPreview,
                type: pinnedDbPages[i].type,
            };

            pinnedDbPageTagIds.push(item)
        }

        return pinnedDbPageTagIds;
    }

    public getPinnedDbHomeSpotlightPages() {

        this.updatePinnedDbPagesPosition();

        let pinnedDbPageTagIds = [];
        const pinnedDbHomeSpotlightPages = this.getTemplateViewModel().pinnedDbHomeSpotlightPages();
        const spotlightTitle = this.getTemplateViewModel().spotlightTitle();

        for (let i = 0; i < pinnedDbHomeSpotlightPages.length; i++) {
            let idTag = pinnedDbHomeSpotlightPages[i].idTags[0] ? pinnedDbHomeSpotlightPages[i].idTags[0] : null;

            if (!idTag) {
                idTag = pinnedDbHomeSpotlightPages[i].listingPage ? pinnedDbHomeSpotlightPages[i].listingPage.tags[0] : null;
            }

            if (idTag) {
                pinnedDbPageTagIds.push(idTag)
            }
        }

        return { title: spotlightTitle, idTags: pinnedDbPageTagIds };
    }

    public getPinnedTradingCardPages() {

        this.updatePinnedTradingCardPagesPosition();

        const tradingCardsSectionTitle = this.getTemplateViewModel().tradingCardsSectionTitle();
        const pinnedTradingCardPages = this.getTemplateViewModel().pinnedTradingCardPages();

        const items: { id: number, name: string, permalink: string }[] = [];
        for (let i = 0; i < pinnedTradingCardPages.length; i++) {
            const listingPage = pinnedTradingCardPages[i].listingPage;
            if (listingPage && listingPage.id) {
                items.push({ id: listingPage.id, name: listingPage.name, permalink: listingPage.permalink });
            }
        }

        if(!tradingCardsSectionTitle && items.length == 0 ) {
            return null;
        }

        return { title: tradingCardsSectionTitle, listingPages : items };
    }

    public updatePinnedTradingCardPagesPosition() {

        let pinnedTradingCardPages = this.getTemplateViewModel().pinnedTradingCardPages();

        for (let i = 0; i < pinnedTradingCardPages.length; i++) {

            pinnedTradingCardPages[i].position = i + 1;
        }

        this.getTemplateViewModel().pinnedTradingCardPages([]);
        this.getTemplateViewModel().pinnedTradingCardPages(pinnedTradingCardPages);
    }

    public setPinnedTradingCards(data)
    {
        const title = data.title;
        const listingPages = data.listingPages;
        const pinnedListingPages = [];
        for (let x in listingPages) {
            let id = 'tradingCardShowMoreListingPage';
            let filter = new filterListingPage_template(id + (x), this.getTemplateViewModel(), this.caller);
            filter.setShowDetails(true);
            filter.setPlaceholder('Show More Listing Page');
            filter.setIsLoadingAnimationEnable(true);
            let pinnedListingPage = {
                id: listingPages[x].id,
                name: listingPages[x].name,
                permalink: listingPages[x].permalink,
                idListingPage: listingPages[x].id,
                listingPage: listingPages[x],
                idShowMoreListingPage: listingPages[x].idShowMoreListingPage,
                showMoreListingPage: listingPages[x].showMoreListingPage,
                showMoreListingPageFilter: filter,
                position: listingPages[x].position,
                dateCreated: listingPages[x].dateCreated,
                alternateTitle: listingPages[x].alternateTitle,
                enableEdit: false,
                isFullList: listingPages[x].isFullList,
                isHubPreview: false,
                isDbPage: false,
                isTradingCardPage: true,
                type: listingPages[x].type,
                idTags: listingPages[x].tags,
            };

            pinnedListingPages.push(pinnedListingPage);
        }

        this.getTemplateViewModel().pinnedTradingCardPages([]);
        this.getTemplateViewModel().pinnedTradingCardPages(pinnedListingPages);
        this.getTemplateViewModel().tradingCardsSectionTitle('');
        this.getTemplateViewModel().tradingCardsSectionTitle(title);
    }

    public getMultiListingPinnedSection() {
        const vm = this.getTemplateViewModel();

        if (!vm.isFX()) {
            return null;
        }

        const title = vm.multiListingPinnedSectionTitle();
        const items = vm.multiListingPinnedItems().map((item, index) => {
            return {
                title: item.title,
                listingPage: item.listingPage,
                pinnedArticles: item.pinnedArticles,
                useLatest: item.useLatest === true,
                isPrimary: item.isPrimary === true,
                position: index + 1,
            };
        });

        if (!title && items.length === 0) {
            return null;
        }

        return {
            title: title,
            items: items,
        };
    }

    public setMultiListingPinnedSection(data) {
        const section = data && data.multiListingPinnedSection ? data.multiListingPinnedSection : data;
        const title = section && section.title ? section.title : '';
        const items = section && Array.isArray(section.items) ? section.items : [];

        this.getTemplateViewModel().multiListingPinnedSectionTitle(title);
        this.getTemplateViewModel().multiListingPinnedItems(items.map((item, index) => {
            return {
                title: item.title || '',
                listingPage: item.listingPage || null,
                pinnedArticles: this.normalizeMultiListingPinnedArticles(item.pinnedArticles || []),
                useLatest: item.useLatest === true,
                isPrimary: item.isPrimary === true,
                position: item.position || index + 1,
            };
        }));
    }

    private normalizeMultiListingPinnedArticles(articles) {
        return articles.map((article, index) => {
            return {
                id: article.id || '',
                idArticle: article.idArticle || article.id,
                reference: article.reference || (article.article ? article.article.reference : ''),
                article: article.article || article,
                alternateTitle: article.alternateTitle || '',
                pinnedHours: article.pinnedHours || '',
                position: article.position || index + 1,
                expire: article.expire || '',
                timeLeft: article.timeLeft || '',
                enableEdit: false,
            };
        });
    }

    public setLatestYoutubeVideosSection(data) {
        const vm = this.getTemplateViewModel();
        const section = data && data.latestYoutubeVideosSection ? data.latestYoutubeVideosSection : data;
        const channelOptions = data && Array.isArray(data.youtubeChannelOptions) ? data.youtubeChannelOptions : [];
        const videoOptions = data && Array.isArray(data.youtubeVideoOptions) ? data.youtubeVideoOptions : [];
        const primaryChannel = data && data.primaryYoutubeChannel ? data.primaryYoutubeChannel : '';

        vm.latestYoutubeChannelOptions(channelOptions);
        vm.latestYoutubeVideoOptions(videoOptions.map(option => {
            option.id = option.idVideo;
            return option;
        }));
        vm.latestYoutubeVideosSectionTitle(section && section.title ? section.title : 'Latest Youtube Videos');
        vm.latestYoutubeVideosIdChannel(section && section.idChannel ? section.idChannel : primaryChannel);
        vm.latestYoutubeVideoItems(this.normalizeLatestYoutubeVideoItems(section && section.videos ? section.videos : []));
    }

    public getLatestYoutubeVideosSection() {
        const vm = this.getTemplateViewModel();

        if (!vm.isFX()) {
            return null;
        }

        const title = vm.latestYoutubeVideosSectionTitle();
        const idChannel = vm.latestYoutubeVideosIdChannel();
        const videos = vm.latestYoutubeVideoItems().map(item => {
            const video: any = {
                idChannel: item.idChannel,
                idVideo: item.idVideo,
            };

            if (item.overrideTitle) {
                video['overrideTitle'] = item.overrideTitle;
            }

            if (item.overrideImage) {
                video['overrideImage'] = item.overrideImage;
            }

            return video;
        });

        if (!title && !idChannel && videos.length === 0) {
            return null;
        }

        return {
            title: title,
            idChannel: idChannel,
            videos: videos,
        };
    }

    private normalizeLatestYoutubeVideoItems(videos) {
        return videos.map(video => {
            const option = this.getLatestYoutubeVideoOption(video.idChannel, video.idVideo) || video;
            return {
                id: video.idVideo || video.id || '',
                idChannel: video.idChannel || option.idChannel || '',
                idVideo: video.idVideo || option.idVideo || video.id || '',
                title: option.title || option.name || video.title || '',
                name: option.name || option.title || video.title || video.idVideo || '',
                thumbnailUrl: option.thumbnailUrl || video.thumbnailUrl || '',
                datePublished: option.datePublished || video.datePublished || '',
                overrideTitle: video.overrideTitle || '',
                overrideImage: video.overrideImage || null,
            };
        });
    }

    private getLatestYoutubeVideoOption(idChannel, idVideo) {
        if (!idChannel || !idVideo) {
            return null;
        }

        return this.getTemplateViewModel().latestYoutubeVideoOptions().find(option => option.idChannel === idChannel && option.idVideo === idVideo) || null;
    }

    public onChangeLatestYoutubeVideosChannel() {
        this.latestYoutubeVideoFilter.clearInputNoCallback();
        this.getTemplateViewModel().latestYoutubeVideoItems([]);
        this.resetLatestYoutubeVideoEditForm();
    }

    public onClickAddLatestYoutubeVideo() {
        const vm = this.getTemplateViewModel();
        const selectedVideo = this.latestYoutubeVideoFilter.getOptionObj();
        const idChannel = vm.latestYoutubeVideosIdChannel();

        if (!idChannel) {
            this.caller.triggerNotification('Please select a YouTube channel before adding videos.');
            return;
        }

        if (!selectedVideo || !selectedVideo.idVideo) {
            this.caller.triggerNotification('Please select a YouTube video before adding it.');
            return;
        }

        if (selectedVideo.idChannel !== idChannel) {
            this.caller.triggerNotification('Selected video must belong to the selected YouTube channel.');
            return;
        }

        const items = vm.latestYoutubeVideoItems().slice();
        if (items.length >= 6) {
            this.caller.triggerNotification('Up to 6 YouTube videos are allowed.');
            return;
        }

        if (items.find(item => item.idChannel === selectedVideo.idChannel && item.idVideo === selectedVideo.idVideo)) {
            this.caller.triggerNotification('This YouTube video is already in the list.');
            return;
        }

        items.push({
            id: selectedVideo.idVideo,
            idChannel: selectedVideo.idChannel,
            idVideo: selectedVideo.idVideo,
            title: selectedVideo.title || selectedVideo.name || '',
            name: selectedVideo.name || selectedVideo.title || selectedVideo.idVideo,
            thumbnailUrl: selectedVideo.thumbnailUrl || '',
            datePublished: selectedVideo.datePublished || '',
            overrideTitle: '',
            overrideImage: null,
        });

        vm.latestYoutubeVideoItems([]);
        vm.latestYoutubeVideoItems(items);
        this.latestYoutubeVideoFilter.clearInputNoCallback();
    }

    public onClickDeleteLatestYoutubeVideo(data) {
        const items = this.getTemplateViewModel().latestYoutubeVideoItems().filter(item => item !== data);
        this.getTemplateViewModel().latestYoutubeVideoItems([]);
        this.getTemplateViewModel().latestYoutubeVideoItems(items);
        this.resetLatestYoutubeVideoEditForm();
    }

    public getLatestYoutubeVideoDisplayTitle(item) {
        return item.overrideTitle || item.title || item.name || item.idVideo;
    }

    public getLatestYoutubeVideoDisplayImageUrl(item) {
        return item.overrideImage && item.overrideImage.url ? item.overrideImage.url : item.thumbnailUrl || '';
    }

    public onClickEditLatestYoutubeVideo(data) {
        const vm = this.getTemplateViewModel();
        const items = vm.latestYoutubeVideoItems();

        vm.latestYoutubeVideoEditedIndex(items.indexOf(data));
        vm.latestYoutubeVideoEditingItem(data);
        vm.latestYoutubeVideoOverrideTitle(data.overrideTitle || '');

        if (data.overrideImage) {
            this.latestYoutubeOverrideImageWidget.setImage(data.overrideImage);
        } else {
            this.latestYoutubeOverrideImageWidget.clearImage();
        }

        vm.isLatestYoutubeVideoEditModalVisible(true);
    }

    public onClickSaveLatestYoutubeVideoOverride() {
        const vm = this.getTemplateViewModel();
        const editedIndex = vm.latestYoutubeVideoEditedIndex();
        const items = vm.latestYoutubeVideoItems().slice();

        if (editedIndex === null || editedIndex < 0 || !items[editedIndex]) {
            this.resetLatestYoutubeVideoEditForm();
            return;
        }

        let overrideImage = this.latestYoutubeOverrideImageWidget.getImage();
        if (overrideImage) {
            overrideImage.uri = overrideImage.url;
            overrideImage.src = overrideImage.url;
        }

        items[editedIndex] = {
            ...items[editedIndex],
            overrideTitle: vm.latestYoutubeVideoOverrideTitle(),
            overrideImage: overrideImage,
        };

        vm.latestYoutubeVideoItems([]);
        vm.latestYoutubeVideoItems(items);
        this.resetLatestYoutubeVideoEditForm();
    }

    public resetLatestYoutubeVideoEditForm() {
        const vm = this.getTemplateViewModel();

        vm.latestYoutubeVideoEditedIndex(null);
        vm.latestYoutubeVideoEditingItem(null);
        vm.latestYoutubeVideoOverrideTitle('');
        vm.isLatestYoutubeVideoEditModalVisible(false);
        this.latestYoutubeOverrideImageWidget.clearImage();
    }

    public onClickOpenMultiListingPinnedModal() {
        this.resetMultiListingPinnedEntryForm();
        this.getTemplateViewModel().isMultiListingPinnedModalVisible(true);
    }

    public onChangeMultiListingPinnedUseLatest() {
        const useLatest = this.getTemplateViewModel().multiListingPinnedUseLatest() === true;
        this.multiListingPinnedListingPageFilter.getTemplateViewModel().disabled(useLatest);

        if (useLatest) {
            this.multiListingPinnedListingPageFilter.clearInput();
        }
    }

    public onClickAddMultiListingPinnedItem() {
        const vm = this.getTemplateViewModel();
        const title = vm.multiListingPinnedEntryTitle();
        const listingPage = this.multiListingPinnedListingPageFilter.getTemplateViewModel().listingPageObj();
        const pinnedArticles = this.multiListingPinnedArticles.getArticlesMarkedAsUnedited();
        const useLatest = vm.multiListingPinnedUseLatest() === true;
        const isPrimary = vm.multiListingPinnedIsPrimary() === true;

        if (!title) {
            this.caller.triggerNotification('Multi listing entry title is required.');
            return;
        }

        if (!useLatest && (!listingPage || !listingPage.id)) {
            this.caller.triggerNotification('Multi listing hub page is required.');
            return;
        }

        if (pinnedArticles.length > 4) {
            this.caller.triggerNotification('Up to 4 pinned articles are allowed.');
            return;
        }

        const items = vm.multiListingPinnedItems();
        const editedIndex = vm.multiListingPinnedEditedIndex();
        if (!useLatest && items.filter((item, index) => index !== editedIndex && item.listingPage && item.listingPage.id === listingPage.id).length > 0) {
            this.caller.triggerNotification('Hub page already added.');
            return;
        }

        if (isPrimary) {
            for (let i = 0; i < items.length; i++) {
                items[i].isPrimary = false;
            }
        }

        const item = {
            title: title,
            listingPage: useLatest ? null : listingPage,
            pinnedArticles: pinnedArticles,
            useLatest: useLatest,
            isPrimary: isPrimary,
            position: editedIndex !== null ? editedIndex + 1 : items.length + 1,
        };

        if (editedIndex !== null) {
            items.splice(editedIndex, 1, item);
        } else {
            items.push(item);
        }

        vm.multiListingPinnedItems([]);
        vm.multiListingPinnedItems(items);
        this.resetMultiListingPinnedEntryForm();
        vm.isMultiListingPinnedModalVisible(false);
    }

    public onClickEditMultiListingPinnedItem(data) {
        const vm = this.getTemplateViewModel();
        const items = vm.multiListingPinnedItems();
        const index = items.indexOf(data);

        if (index < 0) {
            return;
        }

        vm.multiListingPinnedEditedIndex(index);
        vm.multiListingPinnedEntryTitle(data.title || '');
        vm.multiListingPinnedUseLatest(data.useLatest === true);
        vm.multiListingPinnedIsPrimary(data.isPrimary === true);
        this.multiListingPinnedListingPageFilter.clearInput();
        this.multiListingPinnedListingPageFilter.setListingPage(data.listingPage || null);
        this.multiListingPinnedListingPageFilter.getTemplateViewModel().disabled(data.useLatest === true);
        this.multiListingPinnedArticles.setArticles(this.markArticlesAsNotEditable(data.pinnedArticles || []));
        vm.isMultiListingPinnedModalVisible(true);
    }

    public onClickDeleteMultiListingPinnedItem(data) {
        const items = this.getTemplateViewModel().multiListingPinnedItems().filter(item => item !== data);
        this.getTemplateViewModel().multiListingPinnedItems([]);
        this.getTemplateViewModel().multiListingPinnedItems(items);
        this.resetMultiListingPinnedEntryForm();
    }

    private resetMultiListingPinnedEntryForm() {
        this.getTemplateViewModel().multiListingPinnedEntryTitle('');
        this.getTemplateViewModel().multiListingPinnedUseLatest(false);
        this.getTemplateViewModel().multiListingPinnedIsPrimary(false);
        this.getTemplateViewModel().multiListingPinnedEditedIndex(null);
        this.getTemplateViewModel().isMultiListingPinnedModalVisible(false);
        this.multiListingPinnedListingPageFilter.getTemplateViewModel().disabled(false);
        this.multiListingPinnedListingPageFilter.clearInput();
        this.multiListingPinnedArticles.setArticles([]);
        this.multiListingPinnedArticles.clearInput();
    }

    public setPinnedDbSpotlight(data) {
        const title = data.title;
        const listingPages = data.listingPages;
        const pinnedListingPages = [];

        for (let x in listingPages) {

            let id = 'spotlightShowMoreListingPage';

            let filter = new filterListingPage_template(id + (x), this.getTemplateViewModel(), this.caller);
            filter.setShowDetails(true);
            filter.setPlaceholder('Show More Listing Page');
            filter.setIsLoadingAnimationEnable(true);

            let pinnedListingPage = {

                id: listingPages[x].id,
                name: listingPages[x].name,
                permalink: listingPages[x].permalink,
                idListingPage: listingPages[x].id,
                listingPage: listingPages[x],
                idShowMoreListingPage: listingPages[x].idShowMoreListingPage,
                showMoreListingPage: listingPages[x].showMoreListingPage,
                showMoreListingPageFilter: filter,
                position: listingPages[x].position,
                dateCreated: listingPages[x].dateCreated,
                alternateTitle: listingPages[x].alternateTitle,
                enableEdit: false,
                isFullList: listingPages[x].isFullList,
                isHubPreview: false,
                isDbPage: false,
                isDbHomeSpotlightPage: true,
                type: listingPages[x].type,
                idTags: listingPages[x].tags,
            };

            pinnedListingPages.push(pinnedListingPage);
        }

        this.getTemplateViewModel().pinnedDbHomeSpotlightPages([]);
        this.getTemplateViewModel().pinnedDbHomeSpotlightPages(pinnedListingPages);
        this.getTemplateViewModel().spotlightTitle('');
        this.getTemplateViewModel().spotlightTitle(title);
    }

    public setFilterListingPagesAutoComplete(listingPages: Array<HubPageSearchResult>, listingPageIdElement: string): void {


        switch (listingPageIdElement) {
            case 'filterListingPage':
                this.listingPageFilter.setOptions(listingPages);
                break;
            case 'filterHeaderLatestHubPage':
                this.headerLatestHubPageFilter.setOptions(listingPages);
                break;
            case 'filterHubPageLeft':
                this.listingPageFilterLeft.setOptions(listingPages);
                break;
            case 'filterHubPageRight':
                this.listingPageFilterRight.setOptions(listingPages);
                break;
            case 'filterHubPageFullWidth':
                this.listingPageFilterFullWidth.setOptions(listingPages);
                break;
            case 'filterHubPageLeftShowMore':
                this.listingPageFilterLeftShowMore.setOptions(listingPages);
                break;
            case 'filterHubPageRightShowMore':
                this.listingPageFilterRightShowMore.setOptions(listingPages);
                break;
            case 'filterHubPageFullWidthShowMore':
                this.listingPageFilterFullWidthShowMore.setOptions(listingPages);
                break;
            case 'filterShowMoreListingPage':
                this.showMoreListingPageFilter.setOptions(listingPages);
                break;
            case 'filterSidebarLinksListingPage':
                this.getTemplateViewModel().filterSidebarLinksListingPage.listingPages(listingPages);
                break;
            case 'multipleHubPagesWidget':
                this.multipleHubPagesWidget.setOptions(listingPages);
                break;
            case 'multiListingPinnedListingPage':
                this.multiListingPinnedListingPageFilter.setOptions(listingPages);
                break;
            case 'homePageEventBannerListingPage':
                this.homePageEventBannerListingPageFilter.setOptions(listingPages);
                break;
            default:
                this.filterSimpleOnAutoComplete(listingPages, listingPageIdElement);
                break;
        }
    }

    protected onClickCancelHomePageConfig() {

        this.caller.cancelHomePageConfig();
    }

    protected onClickSaveHomePageConfig() {

        this.caller.saveHomePageConfig();
    }

    protected onClickAddSidebarLinks() {

        let sidebarLinks = this.getTemplateViewModel().sidebarLinks();

        let link = -1;
        if (sidebarLinks.length > 0) {
            link = sidebarLinks.findIndex(e => e.title.toLowerCase() == this.getTemplateViewModel().sectionTitle().toLowerCase() && e.type.toLowerCase() == this.getTemplateViewModel().sectionType().toLowerCase());
        }
        if (link == -1) {
            sidebarLinks.push({ title: this.getTemplateViewModel().sectionTitle(), style: this.filterSectionType.getTemplateViewModel().selectedOption, links: this.getTemplateViewModel().sidebarLinks(), position: sidebarLinks.length + 1 })
        }

        this.getTemplateViewModel().sidebarLinks(sidebarLinks);
    }

    protected setFiltersArticleAutocompleteOptions(articles) {

        this.filterSidebarLinksArticle.setOptions(articles);
    }

    public onClickSaveSection() {

        let sidebarSections = this.getTemplateViewModel().sidebarSections();

        let index = 0;
        let sectionType = this.sectionTypes.find(e => e.id == this.filterSectionType.getTemplateViewModel().selectedOption())
        let sectionTypeTitle = sectionType.name;
        if (this.getTemplateViewModel().sidebarSections().length > 0 && this.getTemplateViewModel().sectionToEdit() > -1) {
            sidebarSections[this.getTemplateViewModel().sectionToEdit()].value.sectionTitle = this.getTemplateViewModel().sectionTitle();
            sidebarSections[this.getTemplateViewModel().sectionToEdit()].value.sectionType = this.filterSectionType.getTemplateViewModel().selectedOption();
            sidebarSections[this.getTemplateViewModel().sectionToEdit()].value.sectionTypeTitle = sectionTypeTitle;
            this.getTemplateViewModel().activeSection(this.getTemplateViewModel().sectionToEdit())
            this.getTemplateViewModel().sectionToEdit(null);
        } else {
            sidebarSections.push({
                dragging: ko.observable(false),
                value: {
                    sectionTitle: this.getTemplateViewModel().sectionTitle(),
                    sectionType: this.filterSectionType.getTemplateViewModel().selectedOption(),
                    sectionTypeTitle: sectionTypeTitle,
                    links: ko.observableArray([]),
                    position: sidebarSections.length + 1
                }
            });
            this.getTemplateViewModel().activeSection(sidebarSections.length - 1)

        }

        this.getTemplateViewModel().sidebarSections([]);
        this.getTemplateViewModel().sidebarSections(sidebarSections);
        this.setIsSectionDialogVisible(false)
        this.clearSectionFields();
    }

    public onClickConfirmSectionDelete() {

        let sidebarSections = this.getTemplateViewModel().sidebarSections();

        let index = this.getTemplateViewModel().activeSection();
        if (index != -1) {
            sidebarSections.splice(index, 1);
        }

        let activeSection = null;
        if (index > 0) {
            activeSection = index - 1;
        } else if (index == 0) {
            activeSection = 0
        }
        this.getTemplateViewModel().activeSection(activeSection);
        this.getTemplateViewModel().sidebarSections([]);
        this.getTemplateViewModel().sidebarSections(sidebarSections);
        this.setIsSectionDeleteDialogVisible(false);
    }

    public onClickAddLink() {

        let sidebarSections = this.getTemplateViewModel().sidebarSections();
        let activeSection = this.getTemplateViewModel().activeSection();
        let linkToEdit = this.getTemplateViewModel().linkToEdit();
        let section = sidebarSections[activeSection]
        if (section) {
            let reference = '';
            let linkType = this.getTemplateViewModel().linkType();
            let alternateTitle = this.getTemplateViewModel().alternateTitle();

            let article = null;
            let listingPage = null;
            let title = null;

            if (linkType == 'article') {
                article = this.filterSidebarLinksArticle.getTemplateViewModel().optionObj();

                if (article) {
                    reference = article.reference;
                    title = article.name;
                }
            } else {
                listingPage = this.filterSidebarLinksListingPage.getTemplateViewModel().listingPageObj();
                if (listingPage) {
                    reference = listingPage.id + '';
                    title = listingPage.name;
                }
            }

            let links = sidebarSections[activeSection].value.links();
            if (linkToEdit == null || linkToEdit == -1) {
                links.push({ dragging: ko.observable(false), value: { type: linkType, alternateTitle: alternateTitle, reference: reference, title: title, articleObj: article, listingPageObj: listingPage } });
            } else {
                links[linkToEdit] = { dragging: ko.observable(false), value: { type: linkType, alternateTitle: alternateTitle, reference: reference, title: title, articleObj: article, listingPageObj: listingPage } };
            }
            sidebarSections[activeSection].value.links([]);
            sidebarSections[activeSection].value.links(links);

            this.clearAddLinkFields();
        }

        this.getTemplateViewModel().sidebarSections([]);
        this.getTemplateViewModel().sidebarSections(sidebarSections);
        this.setIsItemDialogVisible(false);
    }

    private clearAddLinkFields() {

        this.getTemplateViewModel().alternateTitle(null);
        this.filterSidebarLinksArticle.clearInput();
        this.filterSidebarLinksListingPage.getTemplateViewModel().listingPage('');
        this.filterSidebarLinksListingPage.getTemplateViewModel().listingPageObj(null);
        this.getTemplateViewModel().linkType(null);
        this.getTemplateViewModel().linkToEdit(null);
    }

    private clearSectionFields() {

        this.getTemplateViewModel().sectionTitle(null);
        this.filterSectionType.setSelectedOption(null);
        this.filterSidebarLinksListingPage.clearInput();
    }

    protected onClickSaveSidebarFeaturedLinks() {

        this.caller.saveSidebarFeaturedLinksConfig();
    }

    protected setSidebarSectionTabTitle(title) {

        this.getTemplateViewModel().sidebarSectionTabTitle(title);
    }

    protected setSidebarFeaturedLinks(sections) {

        for (let section of sections) {

            let sectionType = this.sectionTypes.find(e => e.id == section.sectionType)
            let sectionTypeTitle = sectionType.name;
            section.sectionTypeTitle = sectionTypeTitle;
            let x = this.toDraggables(section.links);

            section.links = ko.observableArray(x);
        }

        this.getTemplateViewModel().sidebarSections(this.toDraggables(sections));
        if (sections.length > 0) {
            this.getTemplateViewModel().activeSection(0);
        }
    }

    public onClickEditLink(data) {

        let sidebarSections = this.getTemplateViewModel().sidebarSections();
        let activeSection = this.getTemplateViewModel().activeSection();

        let section = sidebarSections[activeSection];
        if (section) {
            let link = section.value.links().find(e => e.value.alternateTitle == data.value.alternateTitle && e.value.type == data.value.type && e.value.reference == data.value.reference);
            let linkIndex = section.value.links().findIndex(e => e.value.alternateTitle == data.value.alternateTitle && e.value.type == data.value.type && e.value.reference == data.value.reference);
            this.getTemplateViewModel().linkToEdit(linkIndex);
            if (link) {
                this.getTemplateViewModel().linkType(data.value.type);
                this.getTemplateViewModel().alternateTitle(data.value.alternateTitle);
                if (data.value.type == 'article') {
                    this.filterSidebarLinksArticle.getTemplateViewModel().optionObj(data.value.articleObj);
                } else if (data.value.type == 'listing_page') {
                    this.filterSidebarLinksListingPage.getTemplateViewModel().listingPage(data.value.listingPageObj.name + ' (' + data.value.listingPageObj.permalink + ')');
                    this.filterSidebarLinksListingPage.getTemplateViewModel().listingPageObj(data.value.listingPageObj);
                }
            }
        }
        this.setIsItemDialogVisible(true)
    }

    public onClickEditSection(data) {

        let sidebarSections = this.getTemplateViewModel().sidebarSections();
        let activeSection = this.getTemplateViewModel().activeSection();

        let section = sidebarSections[activeSection];
        if (section) {
            this.getTemplateViewModel().sectionTitle(section.value.sectionTitle);
            this.getTemplateViewModel().sectionToEdit(activeSection);
            this.filterSectionType.setSelectedOption(section.value.sectionType);
        }
        this.setIsSectionDialogVisible(true);
    }

    public onClickConfirmLinkDelete(data) {

        let sidebarSections = this.getTemplateViewModel().sidebarSections();
        let activeSection = this.getTemplateViewModel().activeSection();
        let index = this.getTemplateViewModel().linkToDelete();
        if (index > -1) {
            sidebarSections[activeSection].value.links.splice(index, 1);
        }

        this.getTemplateViewModel().sidebarSections([]);
        this.getTemplateViewModel().sidebarSections(sidebarSections);
        this.setIsLinkDeleteDialogVisible(false);
    }

    public onClickShowSectionModal() {

        this.getTemplateViewModel().sectionToEdit(-1);
        this.setIsSectionDialogVisible(true);
    }

    protected onClickHideSectionModal() {

        this.getTemplateViewModel().activeSection(0);
        this.setIsSectionDialogVisible(false);
    }

    public onClickShowItemModal() {

        this.setIsItemDialogVisible(true);
    }

    protected onClickHideItemModal() {

        this.setIsItemDialogVisible(false);
    }

    public onClickCancelLinkEdit(data) {

        this.clearAddLinkFields();
        this.setIsItemDialogVisible(false);
    }

    public onClickCancelSectionEdit() {

        this.clearSectionFields();
        this.setIsSectionDialogVisible(false);
    }

    public onClickSetActiveSection(index) {

        this.getTemplateViewModel().activeSection(index);
    }

    public setIsItemDialogVisible(isItemDialogVisible) {

        this.getTemplateViewModel().isItemDialogVisible(isItemDialogVisible);
    }

    public setIsSectionDialogVisible(isSectionDialogVisible) {

        this.getTemplateViewModel().isSectionDialogVisible(isSectionDialogVisible);
    }

    public setIsSectionDeleteDialogVisible(isSectionDeleteVisible) {

        this.getTemplateViewModel().isSectionDeleteVisible(isSectionDeleteVisible);
    }

    public setIsPinnedListingPageSectionDialogVisible(section, bool, value) {

        this.getTemplateViewModel().isPinnedListingPageSectionVisible(bool);
        this.getTemplateViewModel().isFullListTabActive(value);
        this.getTemplateViewModel().currentSection(section);
        this.getTemplateViewModel().isHubPagesPreviewTabActive((section == 'hubPreview'));
        this.getTemplateViewModel().isDbPageTabActive((section == 'hubRating'));
        this.getTemplateViewModel().isDbHomeSpotlightPageTabActive((section == 'homeSpotlight'));
        this.getTemplateViewModel().isTradingCardPageTabActive((section == 'tradingCard'));
        this.resetPinnedListingPageFilters();
        if (section == 'featured' || section == 'hubRating' || section == 'homeSpotlight' || section == 'tradingCard') {
            this.getTemplateViewModel().isAlternateTitleVisible(false);
            this.getTemplateViewModel().isShowMoreVisible(false);
        } else {
            this.getTemplateViewModel().isAlternateTitleVisible(true);
            this.getTemplateViewModel().isShowMoreVisible(true);
        }
    }

    public setIsLinkDeleteDialogVisible(isLinkDeleteVisible) {

        this.getTemplateViewModel().isLinkDeleteVisible(isLinkDeleteVisible);
    }

    public onClickDeleteSection() {

        this.setIsSectionDeleteDialogVisible(true);
    }

    public onClickDeleteLink(data) {

        console.log(data);
        let sidebarSections = this.getTemplateViewModel().sidebarSections();
        let activeSection = this.getTemplateViewModel().activeSection();

        let section = sidebarSections[activeSection];
        if (section) {
            let index = section.value.links().findIndex(e => e.value.alternateTitle == data.value.alternateTitle && e.value.type == data.value.type && e.value.reference == data.value.reference);
            if (index > -1) {
                this.getTemplateViewModel().linkToDelete(index);
            }
        }

        this.setIsLinkDeleteDialogVisible(true);
    }

    public onClickCancelLinkDelete() {

        this.getTemplateViewModel().linkToDelete(null);
        this.setIsLinkDeleteDialogVisible(false);
    }

    public startDrag(data, event) {

        console.log(data);
        try {
            this.executeDrag(data, event);

        } catch (err) {
            throw new Error(err.message);
        }
    }

    public executeDrag(data, event) {

        if (event.srcElement.className.indexOf('i-move') !== -1) {
            data.dragging(true);
            return true;
        } else {
            throw new Error('drag only allowed from the handle');
        }
    }

    private toDraggables(values) {
        return ko.utils.arrayMap(values, function (value) {
            return {
                value: value,
                dragging: ko.observable(false),
            };
        });
    }

    public reorderSortable(event, dragData, zoneData): void {

        if (dragData !== zoneData.item) {

            var zoneDataIndex = zoneData.items.indexOf(zoneData.item);
            zoneData.items.remove(dragData);
            zoneData.items.splice(zoneDataIndex, 0, dragData);
        }
    }


    public updatePinnedListingPagePosition() {

        let pinnedListingPages = this.getTemplateViewModel().pinnedListingPages();

        for (let i = 0; i < pinnedListingPages.length; i++) {

            if (pinnedListingPages[i].type == "featured") {
                pinnedListingPages[i].position = 1;
            } else {
                pinnedListingPages[i].position = i + 1;
            }
        }

        this.getTemplateViewModel().pinnedListingPages([]);
        this.getTemplateViewModel().pinnedListingPages(pinnedListingPages);
    }

    public updateFullListPinnedListingPagePosition() {

        let fullListPinnedListingPages = this.getTemplateViewModel().fullListPinnedListingPages();

        for (let i = 0; i < fullListPinnedListingPages.length; i++) {

            fullListPinnedListingPages[i].position = i + 1;
        }

        this.getTemplateViewModel().fullListPinnedListingPages([]);
        this.getTemplateViewModel().fullListPinnedListingPages(fullListPinnedListingPages);
    }

    public onClickAddPinnedListingPage(section = null) {

        let addFeaturedListingPageEnabled = true;


        let listingPages = this.getTemplateViewModel().pinnedListingPages();
        if (this.getTemplateViewModel().isFullListTabActive()) {
            listingPages = this.getTemplateViewModel().fullListPinnedListingPages();
        }

        if (this.getTemplateViewModel().isHubPagesPreviewTabActive()) {
            listingPages = this.getTemplateViewModel().pinnedHubPagesPreview();
        }

        if (this.getTemplateViewModel().isDbPageTabActive()) {
            listingPages = this.getTemplateViewModel().pinnedDbPages();
        }

        if (this.getTemplateViewModel().isDbHomeSpotlightPageTabActive()) {
            listingPages = this.getTemplateViewModel().pinnedDbHomeSpotlightPages();
        }

        if (this.getTemplateViewModel().isTradingCardPageTabActive()) {
            listingPages = this.getTemplateViewModel().pinnedTradingCardPages();
        }

        let mainListingPage = this.listingPageFilter.getTemplateViewModel().listingPageObj();
        let showMoreListingPage = this.showMoreListingPageFilter.getTemplateViewModel().listingPageObj();
        let listingPageAlternateTitle = this.getTemplateViewModel().listingPageAlternateTitle();

        let index = this.getListingPageIndex(mainListingPage, listingPages);
        if (index < 0) {

            let id = (this.getTemplateViewModel().isFullListTabActive() ? 'full' : 'limited') + "filterShowMoreListingPage" + (listingPages.length);
            let filter = new filterListingPage_template(id, this.getTemplateViewModel(), this.caller);
            filter.setPlaceholder('Show More Listing Page');
            filter.setShowDetails(true);
            filter.setIsLoadingAnimationEnable(true);

            let newPinnedListingPage = {
                id: null,
                idListingPage: mainListingPage.id,
                listingPage: mainListingPage,
                idShowMoreListingPage: null,
                showMoreListingPage: showMoreListingPage,
                showMoreListingPageFilter: filter,
                position: listingPages.length + 1,
                dateCreated: null,
                alternateTitle: listingPageAlternateTitle,
                enableEdit: false,
                isFullList: (this.getTemplateViewModel().isFullListTabActive()),
                isHubPreview: (this.getTemplateViewModel().isHubPagesPreviewTabActive()),
                isDbPage: (this.getTemplateViewModel().isDbPageTabActive()),
                isDbHomeSpotlightPage: (this.getTemplateViewModel().isDbHomeSpotlightPageTabActive()),
                isTradingCardPage: (this.getTemplateViewModel().isTradingCardPageTabActive()),
                type: this.getTemplateViewModel().currentSection(),
                idTags: (this.getTemplateViewModel().isDbPageTabActive()) ? JSON.parse(mainListingPage.tags) : []
            };

            if (this.getTemplateViewModel().currentSection() == "featured") {
                addFeaturedListingPageEnabled = false;
                newPinnedListingPage.position = 1;
            }
            this.getTemplateViewModel().addFeaturedListingPageEnabled(addFeaturedListingPageEnabled);

            //set value and filter too for vie/edit mode
            if (showMoreListingPage) {

                newPinnedListingPage.idShowMoreListingPage = showMoreListingPage.id;
                newPinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().idListingPage(showMoreListingPage.id);
                newPinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().listingPageObj(showMoreListingPage);
                newPinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().listingPage(showMoreListingPage.name + ' (' + showMoreListingPage.permalink + ')');
            }

            listingPages.push(newPinnedListingPage);

            if (this.getTemplateViewModel().isFullListTabActive()) {
                this.getTemplateViewModel().fullListPinnedListingPages([]);
                this.getTemplateViewModel().fullListPinnedListingPages(listingPages);
            } else if (this.getTemplateViewModel().isHubPagesPreviewTabActive()) {
                this.getTemplateViewModel().pinnedHubPagesPreview([]);
                this.getTemplateViewModel().pinnedHubPagesPreview(listingPages);
            } else if (this.getTemplateViewModel().isDbPageTabActive()) {
                this.getTemplateViewModel().pinnedDbPages([]);
                this.getTemplateViewModel().pinnedDbPages(listingPages);
            } else if (this.getTemplateViewModel().isDbHomeSpotlightPageTabActive()) {
                this.getTemplateViewModel().pinnedDbHomeSpotlightPages([]);
                this.getTemplateViewModel().pinnedDbHomeSpotlightPages(listingPages);
            } else if (this.getTemplateViewModel().isTradingCardPageTabActive()) {
                this.getTemplateViewModel().pinnedTradingCardPages([]);
                this.getTemplateViewModel().pinnedTradingCardPages(listingPages);
            }
            else {
                this.getTemplateViewModel().pinnedListingPages([]);
                this.getTemplateViewModel().pinnedListingPages(listingPages);
            }

            this.resetPinnedListingPageFilters();
            this.setIsPinnedListingPageSectionDialogVisible(section, false, '');

        } else {

            this.caller.triggerNotification('Main Hub page already pinned');
        }
    }

    public onClickEditPinnedListing(data) {

        let listingPages = this.getTemplateViewModel().pinnedListingPages();
        if (data.isFullList) {
            listingPages = this.getTemplateViewModel().fullListPinnedListingPages();
        } else if (data.isHubPreview) {
            listingPages = this.getTemplateViewModel().pinnedHubPagesPreview();
        }

        let index = this.getListingPageIndex(data.listingPage, listingPages);
        if (index > -1) {
            listingPages[index].enableEdit = true;
        }

        if (data.isFullList) {
            this.getTemplateViewModel().fullListPinnedListingPages([]);
            this.getTemplateViewModel().fullListPinnedListingPages(listingPages);
        } else if (data.isHubPreview) {
            for (let i = 0; i < listingPages.length; i++) {
                if (listingPages[i].idListingPage == data.idListingPage) {
                    listingPages[i].enableEdit = true;
                }
            }
            this.getTemplateViewModel().pinnedHubPagesPreview([]);
            this.getTemplateViewModel().pinnedHubPagesPreview(listingPages);
        } else {
            this.getTemplateViewModel().pinnedListingPages([]);
            this.getTemplateViewModel().pinnedListingPages(listingPages);
        }

    }

    public onClickDeletePinnedListingPage(data) {

        let listingPages = this.getTemplateViewModel().pinnedListingPages();
        if (data.isFullList) {
            listingPages = this.getTemplateViewModel().fullListPinnedListingPages();
        } else if (data.isHubPreview) {
            listingPages = this.getTemplateViewModel().pinnedHubPagesPreview();
        } else if (data.isDbPage) {
            listingPages = this.getTemplateViewModel().pinnedDbPages();
        } else if (data.isDbHomeSpotlightPage) {
            listingPages = this.getTemplateViewModel().pinnedDbHomeSpotlightPages();
        } else if (data.isTradingCardPage) {
            listingPages = this.getTemplateViewModel().pinnedTradingCardPages();
        }

        let index = this.getListingPageIndex(data.listingPage, listingPages);
        if (index > -1) {
            listingPages.splice(index, 1);
        }

        if (data.isFullList) {
            this.getTemplateViewModel().fullListPinnedListingPages([]);
            this.getTemplateViewModel().fullListPinnedListingPages(listingPages);
        } else if (data.isHubPreview) {
            listingPages = listingPages.filter(item => item.idListingPage != data.idListingPage);
            this.getTemplateViewModel().pinnedHubPagesPreview([]);
            this.getTemplateViewModel().pinnedHubPagesPreview(listingPages);
        } else if (data.isDbPage) {
            listingPages = listingPages.filter(item => item.idListingPage != data.idListingPage);
            this.getTemplateViewModel().pinnedDbPages([]);
            this.getTemplateViewModel().pinnedDbPages(listingPages);
        } else if (data.isDbHomeSpotlightPage) {
            listingPages = listingPages.filter(item => item.idListingPage != data.idListingPage);
            this.getTemplateViewModel().pinnedDbHomeSpotlightPages([]);
            this.getTemplateViewModel().pinnedDbHomeSpotlightPages(listingPages);
        } else if (data.isTradingCardPage) {
            listingPages = listingPages.filter(item => item.idListingPage != data.idListingPage);
            this.getTemplateViewModel().pinnedTradingCardPages([]);
            this.getTemplateViewModel().pinnedTradingCardPages(listingPages);
        }
        else {
            this.getTemplateViewModel().pinnedListingPages([]);
            this.getTemplateViewModel().pinnedListingPages(listingPages);
        }

        if (data.type == "featured") {
            this.getTemplateViewModel().addFeaturedListingPageEnabled(true);
        }
    }

    public getListingPageIndex(data, listingPages) {

        return listingPages.findIndex(listingPage => listingPage.idListingPage == data.id);
    }

    public resetPinnedListingPageFilters() {

        this.listingPageFilter.clearInput();
        this.showMoreListingPageFilter.clearInput();
        this.getTemplateViewModel().listingPageAlternateTitle('');
    }

    public filterSimpleOnAutoComplete(results, idElement) {

        let listingPages = this.getTemplateViewModel().pinnedListingPages();
        if (idElement.startsWith('full')) {
            listingPages = this.getTemplateViewModel().fullListPinnedListingPages();
        } else if (idElement.startsWith('hubPreview')) {
            listingPages = this.getTemplateViewModel().pinnedHubPagesPreview();
        }
        let index = listingPages.findIndex(listingPage => listingPage.showMoreListingPageFilter.idElement == idElement);
        if (index > -1) {
            listingPages[index].showMoreListingPageFilter.setOptions(results);
        }
    }

    public handleDragAndDrop(element, currentObservableArray, childrenSelector): any {

        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray, childrenSelector);
    }

    public onFocus(data, event) {

        let parent = event.currentTarget.parentNode.parentNode;
        if (parent.hasAttribute('draggable')) {
            parent.setAttribute('draggable', 'false');
        }
    }

    public onBlur(data, event) {

        let parent = event.currentTarget.parentNode.parentNode;
        if (parent.hasAttribute('draggable')) {
            parent.setAttribute('draggable', 'true');
        }
    }

    protected onClickTogglePinnedCustomCardSection(show, reset = true): void {

        if (show && reset) {
            let pinnedCustomCardItems = this.getTemplateViewModel().pinnedCustomCardItems();
            if (pinnedCustomCardItems.length > 5) {
                this.caller.triggerNotification('Maximum custom card number reached. Please delete one to add new! ');
                return;
            }
        }

        if (reset) {
            this.getTemplateViewModel().cardEdited(null);
            this.getTemplateViewModel().customCardTitle('');
            this.getTemplateViewModel().customCardLinkoutUrl('');
            this.imageWidget.clearImage();
            if (this.caller.textAreaEditor) {
                this.caller.textAreaEditor.setData('');
            }
        }

        this.getTemplateViewModel().isAddPinnedCustomCardVisible(show);
    }

    public onClickAddPinnedCustomCardItem() {
        const vm = this.getTemplateViewModel();
        const cardEdited = vm.cardEdited();
        const pinnedCustomCardItems = vm.pinnedCustomCardItems().slice();

        let cardImage = this.imageWidget.getImage();
        if (cardImage) {
            cardImage.uri = cardImage.url;
            cardImage.src = cardImage.url;
        }

        const newItem = {
            cardTitle: vm.customCardTitle(),
            cardLinkoutUrl: vm.customCardLinkoutUrl(),
            cardImage: cardImage,
            cardDescription: this.caller.textAreaEditor.getData()
        };

        if (cardEdited) {
            const index = pinnedCustomCardItems.findIndex(c =>
                c.cardTitle === cardEdited.cardTitle &&
                c.cardLinkoutUrl === cardEdited.cardLinkoutUrl &&
                c.cardDescription === cardEdited.cardDescription
            );

            if (index > -1) {
                pinnedCustomCardItems[index] = newItem;
            } else {
                pinnedCustomCardItems.push(newItem);
            }

            vm.cardEdited(null);
        } else {
            pinnedCustomCardItems.push(newItem);
        }

        vm.pinnedCustomCardItems([]);
        vm.pinnedCustomCardItems(pinnedCustomCardItems);

        this.onClickTogglePinnedCustomCardSection(false);
    }

    public onClickDeletePinnedCustomCardItem(data) {
        let pinnedCustomCardItems = this.getTemplateViewModel().pinnedCustomCardItems();

        let index = this.getCustomCardIndex(data, pinnedCustomCardItems);
        if (index > -1) {
            pinnedCustomCardItems.splice(index, 1);
        }

        this.getTemplateViewModel().pinnedCustomCardItems([]);
        this.getTemplateViewModel().pinnedCustomCardItems(pinnedCustomCardItems);
    }

    public getCustomCardIndex(data, pinnedCustomCardItems) {
        return pinnedCustomCardItems.findIndex(item => item.cardTitle == data.cardTitle && item.cardLinkoutUrl == data.cardLinkoutUrl);
    }

    public getPinnedCustomCardsSection() {

        if (!this.getTemplateViewModel().activatePinnedCustomCards()) {
            return null;
        }

        let pinnedCustomCardItems = this.getTemplateViewModel().pinnedCustomCardItems();
        let data = {
            title: this.getTemplateViewModel().customCardsSectionTitle(),
            moreLinkoutTitle: this.getTemplateViewModel().customCardsMoreLinkoutTitle(),
            moreLinkoutUrl: this.getTemplateViewModel().customCardsMoreLinkoutUrl(),
            items: pinnedCustomCardItems
        };

        return data;
    }

    public setPinnedCustomCardsSection(data) {
        if (data && data.pinnedCustomCards && data.pinnedCustomCards.items && data.pinnedCustomCards.items.length > 0) {
            data = data.pinnedCustomCards;

            this.getTemplateViewModel().activatePinnedCustomCards(true);
            this.getTemplateViewModel().customCardsSectionTitle(data.title);
            this.getTemplateViewModel().customCardsMoreLinkoutTitle(data.moreLinkoutTitle);
            this.getTemplateViewModel().customCardsMoreLinkoutUrl(data.moreLinkoutUrl);
            this.getTemplateViewModel().pinnedCustomCardItems(data.items);
        }
    }

    public getHomePageEventBanner() {
        const vm = this.getTemplateViewModel();

        if (!vm.isMLT()) {
            return null;
        }

        return {
            enabled: vm.homePageEventBannerEnabled(),
            image: this.homePageEventBannerImageWidget.getImage(),
            listingPage: this.homePageEventBannerListingPageFilter.getListingPageObj(),
            startDate: vm.homePageEventBannerStartDate(),
            endDate: vm.homePageEventBannerEndDate(),
        };
    }

    public setHomePageEventBanner(data) {
        const vm = this.getTemplateViewModel();

        vm.homePageEventBannerEnabled(Boolean(data && data.enabled));
        vm.homePageEventBannerStartDate(data && data.startDate ? data.startDate : '');
        vm.homePageEventBannerEndDate(data && data.endDate ? data.endDate : '');

        if (data && data.image) {
            this.homePageEventBannerImageWidget.setImage(data.image);
        }
        if (data && data.listingPage) {
            this.homePageEventBannerListingPageFilter.setListingPage(data.listingPage);
        }
    }

    public onClickEditPinnedCustomCardItem(data) {
        this.getTemplateViewModel().cardEdited(data);
        this.getTemplateViewModel().customCardTitle(data.cardTitle);
        this.getTemplateViewModel().customCardLinkoutUrl(data.cardLinkoutUrl);
        if (data.cardImage) {
            this.imageWidget.setImage(data.cardImage);
        }
        if (this.caller.textAreaEditor) {
            this.caller.textAreaEditor.setData(data.cardDescription);
        }

        this.onClickTogglePinnedCustomCardSection(true, false);
    }

    public setFeaturedWikisSection(data) {
        const vm = this.getTemplateViewModel();

        vm.activateFeaturedWikis(vm.isFX());

        if (data && data.featuredWikiOptions) {
            vm.featuredWikiOptions(data.featuredWikiOptions.map(option => {
                option.id = option.idWiki;
                return option;
            }));
        }

        if (data && data.featuredWikis && data.featuredWikis.items && data.featuredWikis.items.length > 0) {
            vm.featuredWikiItems(data.featuredWikis.items);
        }
    }

    public getFeaturedWikisSection() {
        const vm = this.getTemplateViewModel();

        if (!vm.isFX()) {
            return null;
        }

        return {
            items: vm.featuredWikiItems().map(item => {
                return {
                    idWiki: Number(item.idWiki),
                    overrideTitle: item.overrideTitle || '',
                    overrideImage: item.overrideImage || null
                };
            })
        };
    }

    public getFeaturedWikiOption(idWiki) {
        if (!idWiki) {
            return null;
        }

        return this.getTemplateViewModel().featuredWikiOptions().find(option => Number(option.idWiki) === Number(idWiki)) || null;
    }

    public getFeaturedWikiCurrentValue(item, property) {
        const wiki = this.getFeaturedWikiOption(item.idWiki) || item.currentWiki || {};

        return wiki[property] || '';
    }

    public onClickAddFeaturedWikiItem() {
        const vm = this.getTemplateViewModel();
        const selectedWiki = vm.featuredWikiSelectedOption();
        const idWiki = selectedWiki ? Number(selectedWiki.idWiki) : null;

        if (!idWiki || !selectedWiki) {
            this.caller.triggerNotification('Please select a wiki before adding it.');
            return;
        }

        let overrideImage = this.featuredWikiImageWidget.getImage();
        if (overrideImage) {
            overrideImage.uri = overrideImage.url;
            overrideImage.src = overrideImage.url;
        }

        const featuredWikiItems = vm.featuredWikiItems().slice();
        const editedIndex = vm.featuredWikiEditedIndex();
        const duplicateIndex = featuredWikiItems.findIndex(item => Number(item.idWiki) === idWiki);

        if (duplicateIndex > -1 && duplicateIndex !== editedIndex) {
            this.caller.triggerNotification('This wiki is already in the Featured Wikis list.');
            return;
        }

        const newItem = {
            idWiki: idWiki,
            overrideTitle: vm.featuredWikiOverrideTitle(),
            overrideImage: overrideImage,
            currentWiki: selectedWiki
        };

        if (editedIndex !== null && editedIndex > -1) {
            featuredWikiItems[editedIndex] = newItem;
        } else {
            featuredWikiItems.push(newItem);
        }

        vm.featuredWikiItems([]);
        vm.featuredWikiItems(featuredWikiItems);
        this.resetFeaturedWikiForm();
        vm.isAddFeaturedWikiVisible(false);
    }

    public onClickDeleteFeaturedWikiItem(data) {
        const vm = this.getTemplateViewModel();
        const featuredWikiItems = vm.featuredWikiItems().slice();
        const index = featuredWikiItems.indexOf(data);

        if (index > -1) {
            featuredWikiItems.splice(index, 1);
            vm.featuredWikiItems([]);
            vm.featuredWikiItems(featuredWikiItems);
        }

        this.resetFeaturedWikiForm();
    }

    public onClickEditFeaturedWikiItem(data) {
        const vm = this.getTemplateViewModel();
        const featuredWikiItems = vm.featuredWikiItems();
        const selectedWiki = this.getFeaturedWikiOption(data.idWiki);

        vm.featuredWikiEditedIndex(featuredWikiItems.indexOf(data));
        vm.selectedFeaturedWikiId(data.idWiki);
        vm.featuredWikiSelectedOption(selectedWiki);
        if (selectedWiki) {
            this.featuredWikiFilter.setOption(selectedWiki);
        }
        vm.featuredWikiOverrideTitle(data.overrideTitle || '');

        if (data.overrideImage) {
            this.featuredWikiImageWidget.setImage(data.overrideImage);
        } else {
            this.featuredWikiImageWidget.clearImage();
        }

        vm.isAddFeaturedWikiVisible(true);
    }

    public onClickToggleFeaturedWikiModal(show) {
        if (!show) {
            this.resetFeaturedWikiForm();
        }

        if (show && this.getTemplateViewModel().featuredWikiEditedIndex() === null) {
            this.resetFeaturedWikiForm();
        }

        this.getTemplateViewModel().isAddFeaturedWikiVisible(show);
    }

    protected resetFeaturedWikiForm() {
        const vm = this.getTemplateViewModel();

        vm.featuredWikiEditedIndex(null);
        vm.selectedFeaturedWikiId(null);
        vm.featuredWikiSelectedOption(null);
        vm.featuredWikiOverrideTitle('');
        this.featuredWikiFilter.clearInputNoCallback();
        this.featuredWikiImageWidget.clearImage();
    }

    public getSuggestions(keyword, idElement) {
        if (idElement === 'latestYoutubeVideoFilter') {
            const normalizedKeyword = (keyword || '').toString().toLowerCase();
            const selectedChannel = this.getTemplateViewModel().latestYoutubeVideosIdChannel();
            const selectedKeys = {};
            this.getTemplateViewModel().latestYoutubeVideoItems().forEach(item => {
                selectedKeys[item.idChannel + ':' + item.idVideo] = true;
            });

            const filteredOptions = this.getTemplateViewModel().latestYoutubeVideoOptions().filter(option => {
                if (option.videoType !== 'long') {
                    return false;
                }

                if (selectedChannel && option.idChannel !== selectedChannel) {
                    return false;
                }

                if (selectedKeys[option.idChannel + ':' + option.idVideo]) {
                    return false;
                }

                return (option.name || '').toLowerCase().indexOf(normalizedKeyword) > -1
                    || (option.title || '').toLowerCase().indexOf(normalizedKeyword) > -1
                    || String(option.idVideo || '').toLowerCase().indexOf(normalizedKeyword) > -1;
            });

            this.latestYoutubeVideoFilter.setOptions(filteredOptions.slice(0, 25));
            return;
        }

        if (idElement !== 'featuredWikiFilter') {
            return;
        }

        const normalizedKeyword = (keyword || '').toString().toLowerCase();
        const filteredOptions = this.getTemplateViewModel().featuredWikiOptions().filter(option => {
            return (option.name || '').toLowerCase().indexOf(normalizedKeyword) > -1
                || (option.currentUrl || '').toLowerCase().indexOf(normalizedKeyword) > -1
                || String(option.idWiki || '').indexOf(normalizedKeyword) > -1;
        });

        this.featuredWikiFilter.setOptions(filteredOptions.slice(0, 25));
    }

    public onAutocompleteOptionChange(idElement) {
        if (idElement === 'latestYoutubeVideoFilter') {
            return;
        }

        if (idElement !== 'featuredWikiFilter') {
            return;
        }

        const selectedWiki = this.featuredWikiFilter.getOptionObj();
        this.getTemplateViewModel().featuredWikiSelectedOption(selectedWiki);
        this.getTemplateViewModel().selectedFeaturedWikiId(selectedWiki ? selectedWiki.idWiki : null);
    }

    public onAutocompleteInputClear(idElement) {
        if (idElement === 'latestYoutubeVideoFilter') {
            return;
        }

        if (idElement !== 'featuredWikiFilter') {
            return;
        }

        this.getTemplateViewModel().featuredWikiSelectedOption(null);
        this.getTemplateViewModel().selectedFeaturedWikiId(null);
    }

    public onAutocompleteInputClick(idElement) {
    }

    public onAutocompleteAddNewInputClick(idElement) {
    }

    public onAutocompleteAddNewSelected(idElement) {
    }

    public onAutocompleteAddNewInputChange(idElement) {
    }

    public onAutocompleteAcceptSuggestion(idElement) {
    }

    protected onClickLayout(data) {

        const layoutId = this.getTemplateViewModel().idLayout();
        const match = this.getTemplateViewModel().activeLayoutOptions().find(h => h.id === layoutId);

        if(layoutId != 3) {
            this.getTemplateViewModel().enableLayoutFeaturedPinnedTitle(false);
        }

        if (match) {

            let horizontalLatest = match.horizontalLatest;
            this.getTemplateViewModel().articleCount(null);
            this.getTemplateViewModel().horizontalLatest(horizontalLatest);
            // this.getTemplateViewModel().showGr(horizontalLatest);
        }
    }

    protected onClickArticleCount() {

        const layoutId = this.getTemplateViewModel().idLayout();
        const articleCount = this.getTemplateViewModel().articleCount();

        //only avaible for grid tall layout with 9 articles
        if (layoutId == 3 && articleCount == 9) {
            this.getTemplateViewModel().enableLayoutFeaturedPinnedTitle(true);
        }else{
            this.getTemplateViewModel().enableLayoutFeaturedPinnedTitle(false);
        }
    }

    public setLayoutSelected(data) {
        if (!data || !data.id) {
            this.getTemplateViewModel().idLayout(1);
            this.onClickLayout(null);
        } else {
            this.getTemplateViewModel().idLayout(data.id);
            this.getTemplateViewModel().horizontalLatest(data.horizontalLatest);
            this.getTemplateViewModel().layoutFeaturedPinnedTitle(data.alternateTitle);
        }

    }

    public setHeaderLatestSelected(data) {
        if (data) {

            this.getTemplateViewModel().additionalDataType(data.additionalData);
            this.getTemplateViewModel().articleCount(data.availableArticleCount);
            this.getTemplateViewModel().showImage(data.image);
            this.getTemplateViewModel().showThreadCount(data.threadCount);
            let background = 'none';
            if(data.background == 'yes' || data.background == 'no') {
                background = 'none';
            }else{
                background = data.background;
            }
            this.getTemplateViewModel().useBackground(background);
            this.getTemplateViewModel().headerLatestHubPageAlternateTitle(data.alternateTitle || '');
            this.getTemplateViewModel().headerLatestHubArticlesConfig(data.articlesConfig || 'hubPageSortOrder');
            this.setHeaderLatestHubPage(data.hubPage);
        }

    }

    private isThreeArticleHubPageConfigurationVisible(): boolean {
        const layoutId = this.getTemplateViewModel().idLayout();
        const articleCount = Number(this.getTemplateViewModel().articleCount());
        const selectedLayout = this.getTemplateViewModel().activeLayoutOptions()
            .find((layout) => layout.id == layoutId);

        return articleCount === 3
            && !!selectedLayout
            && ['Accordion', 'Grid L'].indexOf(selectedLayout.name) !== -1;
    }

    private onClickOpenThreeArticleHubPageConfigurationModal(): void {
        const vm = this.getTemplateViewModel();
        const hubPage = this.headerLatestHubPageFilter.getTemplateViewModel().listingPageObj();

        this.threeArticleHubPageConfigurationSnapshot = {
            hubPage: hubPage ? { ...hubPage } : null,
            alternateTitle: vm.headerLatestHubPageAlternateTitle(),
            articlesConfig: vm.headerLatestHubArticlesConfig(),
        };
        vm.isThreeArticleHubPageConfigurationModalVisible(true);
    }

    private onClickSaveThreeArticleHubPageConfigurationModal(): void {
        this.threeArticleHubPageConfigurationSnapshot = null;
        this.getTemplateViewModel().isThreeArticleHubPageConfigurationModalVisible(false);
    }

    private onClickCancelThreeArticleHubPageConfigurationModal(): void {
        const snapshot = this.threeArticleHubPageConfigurationSnapshot;
        const vm = this.getTemplateViewModel();

        if (snapshot) {
            vm.headerLatestHubPageAlternateTitle(snapshot.alternateTitle);
            vm.headerLatestHubArticlesConfig(snapshot.articlesConfig);
            this.setHeaderLatestHubPage(snapshot.hubPage);
        }

        this.threeArticleHubPageConfigurationSnapshot = null;
        vm.isThreeArticleHubPageConfigurationModalVisible(false);
    }

    private setHeaderLatestHubPage(hubPage: any): void {
        if (hubPage) {
            this.headerLatestHubPageFilter.setListingPage(hubPage);
            return;
        }

        const headerLatestHubPageFilterVm = this.headerLatestHubPageFilter.getTemplateViewModel();
        headerLatestHubPageFilterVm.idListingPage(null);
        headerLatestHubPageFilterVm.listingPage('');
        headerLatestHubPageFilterVm.listingPages([]);
        headerLatestHubPageFilterVm.listingPageObj(null);
    }

    public setPermissions(data) {
        this.getTemplateViewModel().permissions(data);
    }

    public setIsFX(data) {
        this.getTemplateViewModel().isFX(data);
    }

    public setIsMLT(data) {
        this.getTemplateViewModel().isMLT(data);
    }

    public onClickAddPinnedWidgetToggle(){
        let isPinnedWidgetSectionVisible = this.getTemplateViewModel().isPinnedWidgetSectionVisible();
        this.getTemplateViewModel().isPinnedWidgetSectionVisible(!isPinnedWidgetSectionVisible);
    }

    public onClickCancelPinnedWidget() {
        let isPinnedWidgetSectionVisible = this.getTemplateViewModel().isPinnedWidgetSectionVisible();
        this.getTemplateViewModel().configuration(null);
        this.getTemplateViewModel().fullWidthWidgetType(null);
        this.getTemplateViewModel().widgetTypeLeft(null);
        this.getTemplateViewModel().widgetTypeRight(null);
        this.getTemplateViewModel().leftWidgetHubPage(null);
        this.getTemplateViewModel().leftWidgetHubPageShowMore(null);
        this.getTemplateViewModel().rightWidgetHubPage(null);
         this.getTemplateViewModel().rightWidgetHubPageShowMore(null);
        this.getTemplateViewModel().fullWidthWidgetHubPage(null);
        this.getTemplateViewModel().fullWidthWidgetHubPageShowMore(null);
        this.getTemplateViewModel().layoutSideBySideRight(null);
        this.getTemplateViewModel().layoutSideBySideLeft(null);
        this.getTemplateViewModel().leftWidgetHubPageAlternateTitle(null);
        this.getTemplateViewModel().rightWidgetHubPageAlternateTitle(null);
        this.getTemplateViewModel().fullWidthWidgetHubPageAlternateTitle(null);
        this.getTemplateViewModel().isEditingPinnedWidget(false);
        this.getTemplateViewModel().editingPinnedWidgetIndex(null);
        this.getTemplateViewModel().isPinnedWidgetSectionVisible(!isPinnedWidgetSectionVisible);
        this.getTemplateViewModel().layoutFullWidth(null);
        this.updateFullWidthArticlesMaximum();
        this.imageWidgetForFullWidth.clearImage();
        //this.listingPageFilterLeft.clearInput();
        this.listingPageFilterLeft.getTemplateViewModel().idListingPage(null);
        this.listingPageFilterLeft.getTemplateViewModel().listingPage("");
        this.listingPageFilterLeft.getTemplateViewModel().listingPages([]);
        this.listingPageFilterLeft.getTemplateViewModel().listingPageObj(null);

        this.multipleHubPagesWidget.reset();

        this.listingPageFilterLeftShowMore.getTemplateViewModel().idListingPage(null);
        this.listingPageFilterLeftShowMore.getTemplateViewModel().listingPage("");
        this.listingPageFilterLeftShowMore.getTemplateViewModel().listingPages([]);
        this.listingPageFilterLeftShowMore.getTemplateViewModel().listingPageObj(null);

        this.listingPageFilterRight.getTemplateViewModel().idListingPage(null);
        this.listingPageFilterRight.getTemplateViewModel().listingPage("");
        this.listingPageFilterRight.getTemplateViewModel().listingPages([]);
        this.listingPageFilterRight.getTemplateViewModel().listingPageObj(null);

        this.listingPageFilterRightShowMore.getTemplateViewModel().idListingPage(null);
        this.listingPageFilterRightShowMore.getTemplateViewModel().listingPage("");
        this.listingPageFilterRightShowMore.getTemplateViewModel().listingPages([]);
        this.listingPageFilterRightShowMore.getTemplateViewModel().listingPageObj(null);


        this.listingPageFilterFullWidth.getTemplateViewModel().idListingPage(null);
        this.listingPageFilterFullWidth.getTemplateViewModel().listingPage("");
        this.listingPageFilterFullWidth.getTemplateViewModel().listingPages([]);
        this.listingPageFilterFullWidth.getTemplateViewModel().listingPageObj(null);

        this.listingPageFilterFullWidthShowMore.getTemplateViewModel().idListingPage(null);
        this.listingPageFilterFullWidthShowMore.getTemplateViewModel().listingPage("");
        this.listingPageFilterFullWidthShowMore.getTemplateViewModel().listingPages([]);
        this.listingPageFilterFullWidthShowMore.getTemplateViewModel().listingPageObj(null);

        this.getTemplateViewModel().addToListDisabled(true);

        // pinned articles on hubpage config
        this.getTemplateViewModel().fullHubArticlesConfig('hubPageSortOrder');
        this.getTemplateViewModel().leftHubArticlesConfig('hubPageSortOrder');
        this.getTemplateViewModel().rightHubArticlesConfig('hubPageSortOrder');

        // pinned articles on hubpage
        this.hpFullWidthArticles.setArticles([]);
        this.hpLeftPinnedArticles.setArticles([]);
        this.hpRightPinnedArticles.setArticles([]);

        // newsletter reset
        this.getTemplateViewModel().newsletterTitle(null);
        this.getTemplateViewModel().newsletterDescription(null);
        this.getTemplateViewModel().newsletterBackgroundColor(null);
        this.getTemplateViewModel().newsletterBackgroundColorPicker('#ffffff');
        this.getTemplateViewModel().newsletterWidth('full-screen');
        this.imagePickerForNewsletter.clearImage();

    }

    public onClickAddPinnedWidget() {

        let config = this.getTemplateViewModel().configuration();
        let fullWidthWidgetType = this.getTemplateViewModel().fullWidthWidgetType();
        let widgetTypeLeft = this.getTemplateViewModel().widgetTypeLeft();
        let widgetTypeRight = this.getTemplateViewModel().widgetTypeRight();

        let layoutFullWidth = this.getTemplateViewModel().layoutFullWidth();
        let layoutSideBySideLeft = this.getTemplateViewModel().layoutSideBySideLeft();
        let layoutSideBySideRight = this.getTemplateViewModel().layoutSideBySideRight();

        let includeDBSearch = false;
        let widgetTitle = null;
        let widgetLeftTitle = null;
        let widgetRightTitle = null;
        let fullHubArticlesConfig = null;
        let leftHubArticlesConfig = null;
        let rightHubArticlesConfig = null;
        let widgetImage = null;
        let newsletterTitle = null;
        let newsletterDescription = null;
        let newsletterBackgroundColor = null;
        let newsletterWidth = null;

        let pinnedArticles = {};
        if (fullWidthWidgetType !== 'multipleHubPages') {
            this.multipleHubPagesWidget.setListingPages([]);

        }
        if(config === 'fullWidth') {

            widgetTitle = this.getTemplateViewModel().widgetTitle();
            if (fullWidthWidgetType === 'hubPage') {

                widgetImage = this.imageWidgetForFullWidth.getImage();
                pinnedArticles['fullWidth'] = this.hpFullWidthArticles.getArticlesMarkedAsUnedited();
                fullHubArticlesConfig = this.getTemplateViewModel().fullHubArticlesConfig();
                let fullWidthHubPage = this.getTemplateViewModel().fullWidthWidgetHubPage();
                if (fullWidthHubPage && fullWidthHubPage.permalink && fullWidthHubPage.idArticleType == 16) {
                    layoutFullWidth = "equalSizeHorizontal-4";
                }
            } else if (fullWidthWidgetType === 'multipleHubPages') {
                layoutFullWidth = this.multipleHubPagesWidget.getLayoutFullWidth();
                includeDBSearch = this.multipleHubPagesWidget.getIncludeDbSearch();
            } else if (fullWidthWidgetType === 'newsletterWidget') {
                widgetImage = this.imagePickerForNewsletter.getImage();
                newsletterTitle = this.getTemplateViewModel().newsletterTitle();
                newsletterDescription = this.getTemplateViewModel().newsletterDescription();
                newsletterBackgroundColor = this.getTemplateViewModel().newsletterBackgroundColor();
                newsletterWidth = this.getTemplateViewModel().newsletterWidth();
            }
        }

        if (config === 'sideBySide') {
            widgetLeftTitle = this.getTemplateViewModel().widgetLeftTitle();
            widgetRightTitle = this.getTemplateViewModel().widgetRightTitle();
            if (widgetTypeLeft === 'hubPage') {
                leftHubArticlesConfig = this.getTemplateViewModel().leftHubArticlesConfig();
                pinnedArticles['left'] = this.hpLeftPinnedArticles.getArticlesMarkedAsUnedited();
            }
            if (widgetTypeRight === 'hubPage') {
                rightHubArticlesConfig = this.getTemplateViewModel().rightHubArticlesConfig();
                pinnedArticles['right'] = this.hpRightPinnedArticles.getArticlesMarkedAsUnedited();
            }
        }

        const newWidget = {
            configuration: config,
            fullWidthWidgetType: fullWidthWidgetType,
            widgetTypeLeft: widgetTypeLeft,
            widgetTypeRight: widgetTypeRight,
            layoutFullWidth: layoutFullWidth,
            layoutSideBySideRight: layoutSideBySideRight,
            layoutSideBySideLeft: layoutSideBySideLeft,
            leftWidgetRatingWidgetAlternateTitle: this.getTemplateViewModel().leftWidgetRatingWidgetAlternateTitle(),
            rightWidgetRatingWidgetAlternateTitle: this.getTemplateViewModel().rightWidgetRatingWidgetAlternateTitle(),
            widgetTitle: widgetTitle,
            widgetLeftTitle: widgetLeftTitle,
            widgetRightTitle: widgetRightTitle,
            includeDBSearch: includeDBSearch,
            fullHubArticlesConfig: fullHubArticlesConfig,
            leftHubArticlesConfig: leftHubArticlesConfig,
            rightHubArticlesConfig: rightHubArticlesConfig,
            pinnedHubPages: {
                left: this.getTemplateViewModel().leftWidgetHubPage(),
                leftShowMore: this.getTemplateViewModel().leftWidgetHubPageShowMore(),
                leftAlternateTitle: this.getTemplateViewModel().leftWidgetHubPageAlternateTitle(),
                right: this.getTemplateViewModel().rightWidgetHubPage(),
                rightShowMore: this.getTemplateViewModel().rightWidgetHubPageShowMore(),
                rightAlternateTitle: this.getTemplateViewModel().rightWidgetHubPageAlternateTitle(),
                fullWidth: this.getTemplateViewModel().fullWidthWidgetHubPage(),
                fullWidthShowMore: this.getTemplateViewModel().fullWidthWidgetHubPageShowMore(),
                fullWidthAlternateTitle: this.getTemplateViewModel().fullWidthWidgetHubPageAlternateTitle(),
                fullWidthMultiple: this.multipleHubPagesWidget.getListingPages()
            },
            pinnedArticles: pinnedArticles,
            widgetImage: widgetImage,
            newsletterTitle: newsletterTitle,
            newsletterDescription: newsletterDescription,
            newsletterBackgroundColor: newsletterBackgroundColor,
            newsletterWidth: newsletterWidth
        };
        let errors = this.validatePinnedWidget(newWidget);
        //No error messages here, but this prevents the user from adding an invalid widget
        if(errors.length > 0){
            this.getTemplateViewModel().addToListDisabled(true);
            return;
        }
        if(this.getTemplateViewModel().isEditingPinnedWidget()){
            const index = this.getTemplateViewModel().editingPinnedWidgetIndex();
            let pinnedWidgets = this.getTemplateViewModel().pinnedWidgets();
            pinnedWidgets.splice(index, 1, newWidget);

            this.getTemplateViewModel().pinnedWidgets([]);
            this.getTemplateViewModel().pinnedWidgets(pinnedWidgets);
        } else {
            let pinnedWidgets = this.getTemplateViewModel().pinnedWidgets();
            if(!pinnedWidgets) pinnedWidgets = [];
            pinnedWidgets.push(newWidget);
            this.getTemplateViewModel().pinnedWidgets([]);
            this.getTemplateViewModel().pinnedWidgets(pinnedWidgets);
        }

        // Reset form values after adding
        this.onClickCancelPinnedWidget();
    }

    public validatePinnedWidget(newWidget = null){
        const errors = [];
        if(!newWidget){
            const fullWidthWidgetType = this.getTemplateViewModel().fullWidthWidgetType();
            const config = this.getTemplateViewModel().configuration();
            let layoutFullWidth = this.getTemplateViewModel().layoutFullWidth();
            let widgetTitle = null;
            let widgetLeftTitle = null;
            let widgetRightTitle = null;
            if(config === 'fullWidth') {

                widgetTitle = this.getTemplateViewModel().widgetTitle();
                if (fullWidthWidgetType === 'multipleHubPages') {
                    layoutFullWidth = this.multipleHubPagesWidget.getLayoutFullWidth();
                }
            } else if (config === 'sideBySide') {
                widgetLeftTitle = this.getTemplateViewModel().widgetLeftTitle();
                widgetRightTitle = this.getTemplateViewModel().widgetRightTitle();
            }

            newWidget = {
                configuration: this.getTemplateViewModel().configuration(),
                fullWidthWidgetType: this.getTemplateViewModel().fullWidthWidgetType(),
                widgetTypeLeft: this.getTemplateViewModel().widgetTypeLeft(),
                widgetTypeRight: this.getTemplateViewModel().widgetTypeRight(),
                layoutFullWidth: layoutFullWidth,
                layoutSideBySideRight: this.getTemplateViewModel().layoutSideBySideRight(),
                layoutSideBySideLeft: this.getTemplateViewModel().layoutSideBySideLeft(),
                leftWidgetRatingWidgetAlternateTitle: this.getTemplateViewModel().leftWidgetRatingWidgetAlternateTitle(),
                rightWidgetRatingWidgetAlternateTitle: this.getTemplateViewModel().rightWidgetRatingWidgetAlternateTitle(),
                widgetTitle: widgetTitle,
                widgetLeftTitle: widgetLeftTitle,
                widgetRightTitle: widgetRightTitle,
                pinnedHubPages: {
                    left: this.getTemplateViewModel().leftWidgetHubPage(),
                    leftShowMore: this.getTemplateViewModel().leftWidgetHubPageShowMore(),
                    leftAlternateTitle: this.getTemplateViewModel().leftWidgetHubPageAlternateTitle(),
                    right: this.getTemplateViewModel().rightWidgetHubPage(),
                    rightShowMore: this.getTemplateViewModel().rightWidgetHubPageShowMore(),
                    rightAlternateTitle: this.getTemplateViewModel().rightWidgetHubPageAlternateTitle(),
                    fullWidth: this.getTemplateViewModel().fullWidthWidgetHubPage(),
                    fullWidthShowMore: this.getTemplateViewModel().fullWidthWidgetHubPageShowMore(),
                    fullWidthAlternateTitle: this.getTemplateViewModel().fullWidthWidgetHubPageAlternateTitle(),
                    fullWidthMultiple: this.multipleHubPagesWidget.getListingPages()
                }
            }
        }
        // --- Validation Scope ---
        const config = newWidget.configuration;
        if(!config){
            errors.push({
                label: "Configuration",
                messages: ["You must select a Configuration."]
            });
        }
        if(config == "fullWidth" && !newWidget.fullWidthWidgetType){
            errors.push({
                label: "Full Width Widget Type",
                messages: ["You must select a Full Width Widget Type."],
            })
        }
        if (config === 'fullWidth') {
            if (newWidget.fullWidthWidgetType === 'hubPage') {
                if (!newWidget.layoutFullWidth) {
                    errors.push({
                        label: "Full Width Layout",
                        messages: ["You must select a layout for Full Width Hub Page."]
                    });
                }

                let pinnedArticlesCount = this.hpFullWidthArticles.getArticlesCount();
                if (this.isFourArticleFullWidthLayoutSelected() && pinnedArticlesCount > 4) {
                    errors.push({
                        label: this.isGridAccordionSelected() ? "Grid Accordion Articles" : "Horizontal List Medium Articles",
                        messages: [this.isGridAccordionSelected()
                            ? "Grid Accordion supports a maximum of four manually selected articles."
                            : "Horizontal List Medium supports a maximum of four manually selected articles."]
                    });
                }
                if ((!newWidget.pinnedHubPages.fullWidth || Object.keys(newWidget.pinnedHubPages.fullWidth).length === 0) && pinnedArticlesCount === 0) {
                    errors.push({
                        label: "Full Width Hub Page",
                        messages: ["You must select a hub page for Full Width layout."]
                    });
                }
            }
            if (newWidget.fullWidthWidgetType === 'multipleHubPages') {
                if (!newWidget.widgetTitle) {
                    errors.push({
                        label: "Full Width Multiple Hub Pages Title",
                        messages: ["You must enter a title for Full Width Multiple Hub Pages."]
                    });
                }
                if (newWidget.pinnedHubPages.fullWidthMultiple.length < 1) {
                    errors.push({
                        label: "Full Width Multiple Hub Pages",
                        messages: ["You must select at least one hub page for Full Width Multiple Hub Pages."]
                    });
                }
            }

            if (newWidget.fullWidthWidgetType === 'newsletterWidget') {

            }
        }


        if (config === 'sideBySide') {
            if (newWidget.widgetTypeLeft === 'hubPage' || !newWidget.widgetTypeLeft) {
                if (!newWidget.layoutSideBySideLeft) {
                    errors.push({
                        label: "Left Layout",
                        messages: ["You must select a layout for the left Hub Page."]
                    });
                }

                let pinnedArticlesCount = this.hpLeftPinnedArticles.getArticlesCount();
                if ((!newWidget.pinnedHubPages.left || Object.keys(newWidget.pinnedHubPages.left).length === 0) && pinnedArticlesCount === 0) {
                    errors.push({
                        label: "Left Hub Page",
                        messages: ["You must select a left Hub Page."]
                    });
                }
            }

            if (newWidget.widgetTypeRight === 'hubPage' || !newWidget.widgetTypeRight) {
                if (!newWidget.layoutSideBySideRight) {
                    errors.push({
                        label: "Right Layout",
                        messages: ["You must select a layout for the right Hub Page."]
                    });
                }

                let pinnedArticlesCount = this.hpRightPinnedArticles.getArticlesCount();
                if ((!newWidget.pinnedHubPages.right || Object.keys(newWidget.pinnedHubPages.right).length === 0) && pinnedArticlesCount === 0) {
                    errors.push({
                        label: "Right Hub Page",
                        messages: ["You must select a right Hub Page."]
                    });
                }
            }
        }

        if(errors.length > 0){
            this.getTemplateViewModel().addToListDisabled(true);
        }else{
            this.getTemplateViewModel().addToListDisabled(false);
        }
        return errors;

    }

    public setFilterHubPageLeft(item){

        this.getTemplateViewModel().leftWidgetHubPage(item);
        if (!item) {
            this.getTemplateViewModel().leftWidgetHubPageAlternateTitle('');
        }
        this.validatePinnedWidget();
    }

    public setFilterHubPageRight(item){

        this.getTemplateViewModel().rightWidgetHubPage(item);
        if (!item) {
            this.getTemplateViewModel().rightWidgetHubPageAlternateTitle('');
        }
        this.validatePinnedWidget();
    }

    public setFullWidthWidgetHubPage(item){

        this.getTemplateViewModel().fullWidthWidgetHubPage(item);
        if (!item) {
            this.getTemplateViewModel().fullWidthWidgetHubPageAlternateTitle('');
        }
        this.updateFullWidthArticlesMaximum();
        this.validatePinnedWidget();
    }


    public setFilterHubPageLeftShowMore(item){

        this.getTemplateViewModel().leftWidgetHubPageShowMore(item);
        this.validatePinnedWidget();
    }

    public setFilterHubPageRightShowMore(item){

        this.getTemplateViewModel().rightWidgetHubPageShowMore(item);
        this.validatePinnedWidget();
    }

    public setFullWidthWidgetHubPageShowMore(item){

        this.getTemplateViewModel().fullWidthWidgetHubPageShowMore(item);
        this.validatePinnedWidget();
    }

    public setPinnedWidgets(data) {
        let widgets = [];
        if (Array.isArray(data)) {
            data.forEach((item) => {
                if (!item.hasOwnProperty('widgetTitle')) {
                    item.widgetTitle = '';
                }
                if (!item.hasOwnProperty('widgetLeftTitle')) {
                    item.widgetLeftTitle = '';
                }
                if (!item.hasOwnProperty('widgetRightTitle')) {
                    item.widgetRightTitle = '';
                }
                if (!item.hasOwnProperty('includeDBSearch')) {
                    item.includeDBSearch = '';
                }
                if (item.hasOwnProperty('pinnedHubPages')) {
                    if (!item.pinnedHubPages.hasOwnProperty('fullWidthMultiple')) {
                        item.pinnedHubPages.fullWidthMultiple = [];
                    }
                }

                widgets.push(item);
            });
        }
        this.getTemplateViewModel().pinnedWidgets(widgets);
    }

    public setLeftHubpagephaseOfCreation(data) {
        this.getTemplateViewModel().leftHubpagephaseOfCreation(data);
    }

    public getLeftHubpagephaseOfCreation() {
        return this.getTemplateViewModel().leftHubpagephaseOfCreation();
    }

    public setRightHubpagephaseOfCreation(data) {
        this.getTemplateViewModel().rightHubpagephaseOfCreation(data);
    }

    public getRightHubpagephaseOfCreation() {
        return this.getTemplateViewModel().rightHubpagephaseOfCreation();
    }

    public isLeftInitialPhase() {
        return this.getLeftHubpagephaseOfCreation() === 'initial';
    }

    public isLeftFinalPhase() {
        return this.getLeftHubpagephaseOfCreation() === 'final';
    }

    public isRightInitialPhase() {
        return this.getRightHubpagephaseOfCreation() === 'initial';
    }

    public isRightFinalPhase() {
        return this.getRightHubpagephaseOfCreation() === 'final';
    }

    public onClickEditPinnedWidget(widget){

        const vm = this.getTemplateViewModel();
        // Set shared config
        vm.configuration(widget.configuration);
        vm.fullWidthWidgetType(widget.fullWidthWidgetType || null);
        vm.widgetTypeLeft(widget.widgetTypeLeft || null);
        vm.widgetTypeRight(widget.widgetTypeRight || null);

        // Set layout
        vm.layoutFullWidth(widget.layoutFullWidth || null);
        vm.layoutSideBySideLeft(widget.layoutSideBySideLeft || null);
        vm.layoutSideBySideRight(widget.layoutSideBySideRight || null);

        // Set hub pages
        vm.fullWidthWidgetHubPage(widget.pinnedHubPages.fullWidth || null);
        this.updateFullWidthArticlesMaximum();
        vm.leftWidgetHubPage(widget.pinnedHubPages.left || null);
        vm.rightWidgetHubPage(widget.pinnedHubPages.right || null);

        this.listingPageFilterLeft.setListingPage(widget.pinnedHubPages.left || null);
        this.listingPageFilterRight.setListingPage(widget.pinnedHubPages.right || null);
        this.listingPageFilterFullWidth.setListingPage(widget.pinnedHubPages.fullWidth || null);


        vm.fullWidthWidgetHubPageShowMore(widget.pinnedHubPages.fullWidthShowMore || null);
        vm.leftWidgetHubPageShowMore(widget.pinnedHubPages.leftShowMore || null);
        vm.rightWidgetHubPageShowMore(widget.pinnedHubPages.rightShowMore || null);

        this.listingPageFilterLeftShowMore.setListingPage(widget.pinnedHubPages.leftShowMore || null);
        this.listingPageFilterRightShowMore.setListingPage(widget.pinnedHubPages.rightShowMore || null);
        this.listingPageFilterFullWidthShowMore.setListingPage(widget.pinnedHubPages.fullWidthShowMore || null);

        // Set alternate titles
        vm.fullWidthWidgetHubPageAlternateTitle(widget.pinnedHubPages.fullWidthAlternateTitle || '');
        vm.leftWidgetHubPageAlternateTitle(widget.pinnedHubPages.leftAlternateTitle || '');
        vm.rightWidgetHubPageAlternateTitle(widget.pinnedHubPages.rightAlternateTitle || '');

        vm.leftWidgetRatingWidgetAlternateTitle(widget.leftWidgetRatingWidgetAlternateTitle || '');
        vm.rightWidgetRatingWidgetAlternateTitle(widget.rightWidgetRatingWidgetAlternateTitle || '');
        vm.widgetTitle(widget.widgetTitle || '');
        vm.widgetLeftTitle(widget.widgetLeftTitle || '');
        vm.widgetRightTitle(widget.widgetRightTitle || '');
        if (widget.fullWidthWidgetType === 'multipleHubPages') {

            this.multipleHubPagesWidget.setLayoutFullWidth(widget.layoutFullWidth || null);
            this.multipleHubPagesWidget.setListingPages(widget.pinnedHubPages.fullWidthMultiple || []);
            this.multipleHubPagesWidget.setIncludeDbSearch(widget.includeDBSearch || false);
        } else if (widget.fullWidthWidgetType === 'newsletterWidget') {

            if (widget.widgetImage) {
                this.imagePickerForNewsletter.setImage(widget.widgetImage);
            }
            vm.newsletterTitle(widget.newsletterTitle || null);
            vm.newsletterDescription(widget.newsletterDescription || null);
            vm.newsletterBackgroundColor(widget.newsletterBackgroundColor || null);
            vm.newsletterBackgroundColorPicker(widget.newsletterBackgroundColor || '#ffffff');
            vm.newsletterWidth(widget.newsletterWidth || 'full-screen');
        } else if (widget.fullWidthWidgetType === 'hubPage') {
            if (widget.widgetImage) {
                this.imageWidgetForFullWidth.setImage(widget.widgetImage);
            }
        } else {
            this.multipleHubPagesWidget.setLayoutFullWidth(null);
            this.multipleHubPagesWidget.setListingPages([]);
            this.multipleHubPagesWidget.setIncludeDbSearch(false);
        }

        vm.fullHubArticlesConfig(widget.fullHubArticlesConfig || 'hubPageSortOrder');
        vm.leftHubArticlesConfig(widget.leftHubArticlesConfig || 'hubPageSortOrder');
        vm.rightHubArticlesConfig(widget.rightHubArticlesConfig || 'hubPageSortOrder');

        if (widget.pinnedArticles && widget.pinnedArticles.fullWidth) {

            let fullArticles = this.markArticlesAsNotEditable(widget.pinnedArticles.fullWidth);
            this.hpFullWidthArticles.setArticles(fullArticles);
        }
        if (widget.pinnedArticles && widget.pinnedArticles.left) {

            let leftArticles = this.markArticlesAsNotEditable(widget.pinnedArticles.left);
            this.hpLeftPinnedArticles.setArticles(leftArticles);
        }
        if (widget.pinnedArticles && widget.pinnedArticles.right) {

            let rightArticles = this.markArticlesAsNotEditable(widget.pinnedArticles.right);
            this.hpRightPinnedArticles.setArticles(rightArticles);
        }


        vm.isEditingPinnedWidget(true);
        vm.editingPinnedWidgetIndex(vm.pinnedWidgets.indexOf(widget));
        // Show modal
        vm.isPinnedWidgetSectionVisible(true);
        vm.addToListDisabled(true);
    }

    public formatCamelCaseLabel(str) {

        return str
            .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters
            .replace(/^./, function (match) { return match.toUpperCase(); }); // Capitalize first letter
    }

    public setRatingWidgetEnabled(ratingWidgetEnabled){
        this.getTemplateViewModel().ratingWidgetEnabled(ratingWidgetEnabled);
    }

    private isHorizontalListMediumSelected(): boolean {
        const vm = this.getTemplateViewModel();
        const fullWidthHubPage = vm.fullWidthWidgetHubPage();

        return vm.configuration() === 'fullWidth'
            && vm.fullWidthWidgetType() === 'hubPage'
            && vm.layoutFullWidth() === 'equalSizeHorizontal-4'
            && (!fullWidthHubPage || fullWidthHubPage.idArticleType != 16);
    }

    private isGridAccordionSelected(): boolean {
        const vm = this.getTemplateViewModel();

        return vm.configuration() === 'fullWidth'
            && vm.fullWidthWidgetType() === 'hubPage'
            && vm.layoutFullWidth() === 'gridAccordion';
    }

    private isFourArticleFullWidthLayoutSelected(): boolean {
        return this.isHorizontalListMediumSelected() || this.isGridAccordionSelected();
    }

    private updateFullWidthArticlesMaximum(): void {
        this.hpFullWidthArticles.setMaximum(this.isFourArticleFullWidthLayoutSelected() ? 4 : 25);
    }

    public formatListingPagesForDisplay(listingPages) {
        const formattedListingPages = listingPages.map((listingPage) => {
            let formatted = listingPage.name;
            if (listingPage.alternateTitle) {
                formatted += ` (${listingPage.alternateTitle})`;
            }
            return formatted;
        });
        return formattedListingPages.join(', ');
    }

    public formatArticlesForDisplay(artices) {
        if (!artices) {
            return '';
        }
        const formattedArticless = artices.map((a) => {
            let formatted = a.article.title;
            if (a.alternateTitle) {
                formatted += ` (${a.alternateTitle})`;
            }
            return formatted;
        });
        return formattedArticless.join(', ');
    }

    private markArticlesAsNotEditable(articles) {
        return articles.map((article) => {
            article.enableEdit = false;
            return article;
        });
    }

    protected onUpdateError(requestStatus: any, responseParsed): void {

        let msg = "error: while obtaining the form data - (" + responseParsed.message + ")";
        console.log(msg);
    }

    public clearImage(target){

        switch (target) {
            case 'homepage_event_banner_image':
                this.homePageEventBannerImageWidget.clearImage();
                break;
            case 'custom_card_image':
                this.imageWidget.clearImage();
                break;
            case 'featured_wiki_override_image':
                this.featuredWikiImageWidget.clearImage();
                break;
            case 'latest_youtube_override_image':
                this.latestYoutubeOverrideImageWidget.clearImage();
                break;
            case 'imagePickerForNewsletter':
                this.imagePickerForNewsletter.clearImage();
                break;
            case 'imageWidgetForFullWidthHubPage':
                this.imageWidgetForFullWidth.clearImage();
                break;
            default:
                break;
        }

        this.validatePinnedWidget();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/configHomePage_template.ts